const commonLabels = {
  assignTo: 'Assign to',
  approve: 'Approve',
  apply: 'Apply',
  actions: 'Actions',
  addComment: 'Add comment',
  after: 'After',
  editComment: 'Edit comment',
  questionnaire: 'Questionnaire',
  employees: 'Employees',
  cycle: 'Cycle',
  all: 'All',
  cancel: 'Cancel',
  ok: 'Ok',
  archive: 'Archive',
  active: 'Active',
  score: 'Score',
  completed: 'Completed',
  comments: 'Comments',
  inactive: 'Inactive',
  answers: 'Answers',
  answer: 'Answer',
  absences: 'Absences',
  absence: 'Absence',
  question: 'Question',
  questionComments: 'Question comments',
  allComments: 'All  comments',
  discard: 'Discard',
  detractors: 'Detractors',
  department: 'Department',
  edit: 'Edit',
  save: 'Save',
  saveAndCreate: 'Save&Create',
  reset: 'Reset',
  email: 'Email',
  reminder: 'Send Reminder',
  yes: 'Yes',
  no: 'No',
  search: 'Search',
  none: 'None',
  name: 'Name',
  preview: 'Preview',
  manager: 'Manager',
  delete: 'Delete',
  back: 'back',
  send: 'Send',
  close: 'Close',
  filters: 'Filters',
  viewAll: 'View all',
  viewLess: 'View less',
  start: 'Start',
  status: 'Status',
  confirm: 'Confirm',
  noOptions: 'No options',
  helpIcon: 'help icon',
  continue: 'Continue',
  private: 'Private',
  personal: 'Personal',
  public: 'Public',
  addFilters: 'Add Filters',
  create: 'Create',
  update: 'Update',
  createdBy: 'Created by',
  date: 'Date',
  description: 'Description',
  sharedNote: 'Shared note',
  duplicate: 'Duplicate',
  next: 'next',
  previous: 'previous',
  finish: 'Finish',
  choose: 'Choose',
  assign: 'Assign',
  add: 'Add',
  me: 'me',
  schedule: 'Schedule',
  enroll: 'Enroll',
  ago: 'ago',
  day: 'day',
  days: 'days',
  today: 'Today',
  yesterday: 'Yesterday',
  loadMore: 'Load more',
  searching: 'Searching',
  organization: 'Organization',
  noJobTitle: 'No job title',
  level: 'Level',
  title: 'Title',
  sendSurvey: 'Send survey',
  anonymous: 'Anonymous',
  app: 'Kadar',
  submit: 'Submit',
  attribute: 'Attribute',
  attributes: 'Attributes',
  verifyEmail: 'Verify email',
  noResults: 'No results',
  noPresetResults: 'No presets to select',
  noUserResults: 'No employees to select',
  people: 'People',
  percentage: 'Percentage',
  employeesName: "Employee's name",
  candidatesName: "Candidate's name",
  jobsName: "Job's name",
  noSearchResultsMessage: 'No results match your search criteria.',
  period: 'Period',
  viewReport: 'View report',
  compareReport: 'Compare report',
  tags: 'Tags',
  tasks: 'Tasks',
  assignedTo: 'Assigned to',
  note: 'Public note',
  privateNote: 'Private note',
  manageTasks: 'Add/edit tasks',
  recurring: 'Recurring',
  resend: 'Resend',
  dueDate: 'Due date',
  createdByMe: 'Created by me',
  completeness: 'Completeness',
  for: 'For',
  modifiedOn: 'Modified on',
  overdue: 'Overdue',
  courses: 'Courses',
  proposed: 'Proposed',
  propose: 'Propose',
  proposedOn: 'Proposed on',
  promoters: 'Promoters',
  requested: 'Requested',
  request: 'Request',
  requestedOn: 'Requested on',
  startsOn: 'Starts on',
  endsOn: 'Ends on',
  accept: 'Accept',
  dismiss: 'Dismiss',
  weight: 'Weight',
  manageEmployeeTopic: 'Add/Edit your agenda',
  survey: 'Survey',
  actionPlan: 'Action plan',
  actionPlans: 'Action plans',
  oneOnOne: '1:1',
  oneOnOnes: '1:1s',
  fill: 'Fill',
  notes: 'Public notes',
  neutral: 'Neutral',
  you: 'you',
  share: 'Share',
  type: 'Type',
  createdAt: 'Created at',
  move: 'Move',
  range: 'Range',
  reactivate: 'Reactivate',
  invite: 'Invite',
  reinvite: 'Reinvite',
  reject: 'Reject',
  deactivate: 'Deactivate',
  revokeAccess: 'Revoke access',
  holiday: 'Holiday',
  gotIt: 'Got it',
  employee: 'Employee',
  saveAndContinue: 'Save & continue',
  viewComments: 'View comments',
  feedback: 'feedback',
  unarchive: 'Unarchive',
  reviewers: 'Reviewers',
  participants: 'Participants',
  job: 'Job',
  stage: 'Stage',
  tag: 'Tag',
  message: 'Message',
  subject: 'Subject',
  disqualify: 'Disqualify',
  qualify: 'Qualify',
  roles: 'Roles',
};

const systemRoles = {
  en: {
    ADMIN: 'Admin',
    ASSOCIATE: 'Associate',
    MODERATOR: 'Manager',
    USER: 'Employee',
  },
};

const permissionsGroups = {
  en: {
    announcements: {
      name: 'Announcements',
      permissions: {
        'announcements.manage': 'Manage Announcements',
        'announcements.view': 'View Announcements',
      },
      tooltips: {
        'announcements.manage':
          'Allows creating, editing, and deleting announcements within the assigned scope.',
        'announcements.view':
          'Allows viewing announcements within the assigned scope.',
      },
    },
    one_on_one: {
      name: '1:1',
      permissions: {
        'one_on_one.delete': 'Delete 1:1',
        'one_on_one.edit': 'Edit 1:1',
        'one_on_one.comments.manage': 'Edit/Delete 1:1 meeting notes',
        'one_on_one.view': 'View 1:1',
      },
      tooltips: {
        'one_on_one.delete':
          'Allows deleting 1:1 meetings within the assigned scope.',
        'one_on_one.edit':
          'Allows editing 1:1 meetings within the assigned scope.',
        'one_on_one.comments.manage':
          'Allows editing and deleting notes on 1:1 meetings within the assigned scope.',
        'one_on_one.view':
          'Allows viewing 1:1 meetings within the assigned scope.',
      },
    },
    job_titles: {
      name: 'Job titles',
      permissions: {
        'job_titles.users.manage': 'Manage Job title users',
        'job_titles.manage': 'Manage Job titles',
        'job_titles.view': 'View Job titles',
      },
      tooltips: {
        'job_titles.users.manage':
          'Allows assigning and removing users from job titles.',
        'job_titles.manage':
          'Allows creating, editing, and deleting job titles.',
        'job_titles.view':
          'Allows viewing job titles and their assigned users.',
      },
    },
    succession: {
      name: 'Succession',
      permissions: {
        'succession.manage': 'Manage Succession',
      },
      tooltips: {
        'succession.manage':
          'Allows adding, editing, and removing successors and talent pools.',
      },
    },
    absence: {
      name: 'Absence',
      permissions: {
        'absence.requests.manage': 'Manage user requests',
        'absence.manage': 'Manage Settings',
        'absence.view': 'View Absence',
      },
      tooltips: {
        'absence.requests.manage':
          'Allows approving, rejecting, and managing absence requests within the assigned scope.',
        'absence.manage':
          'Allows managing absence settings such as absence types and policies.',
        'absence.view':
          'Allows viewing absence records within the assigned scope.',
      },
    },
    departments: {
      name: 'Divisions and departments',
      permissions: {
        'departments.delete': 'Delete Department users',
        'departments.users.manage': 'Manage Department users',
        'departments.edit': 'Edit Divisions and departments',
        'departments.view': 'View Divisions and departments',
      },
      tooltips: {
        'departments.delete':
          'Allows removing users from departments within the assigned scope.',
        'departments.users.manage':
          'Allows assigning and managing users in departments within the assigned scope.',
        'departments.edit':
          'Allows creating, editing, and deleting divisions and departments.',
        'departments.view':
          'Allows viewing divisions, departments, and their users.',
      },
    },
    learning: {
      name: 'Learning',
      permissions: {
        'learning.delete': 'Delete Courses',
        'learning.users.manage': 'Manage course users',
        'learning.edit': 'Edit Courses',
        'learning.view': 'View Courses',
      },
      tooltips: {
        'learning.delete': 'Allows deleting courses within the assigned scope.',
        'learning.users.manage':
          'Allows assigning and managing users enrolled in courses.',
        'learning.edit':
          'Allows creating and editing courses within the assigned scope.',
        'learning.view':
          'Allows viewing courses and enrollment within the assigned scope.',
      },
    },
    leveling: {
      name: 'Levels and tracks',
      permissions: {
        'leveling.delete': 'Delete Levels and tracks',
        'leveling.users.manage': 'Manage level users',
        'leveling.edit': 'Edit Levels and tracks',
        'leveling.view': 'View Levels and tracks',
      },
      tooltips: {
        'leveling.delete':
          'Allows deleting levels and career tracks within the assigned scope.',
        'leveling.users.manage':
          'Allows assigning and managing users on levels and tracks.',
        'leveling.edit':
          'Allows creating and editing levels and career tracks within the assigned scope.',
        'leveling.view':
          'Allows viewing levels, tracks, and assigned users within the assigned scope.',
      },
    },
    plans: {
      name: 'Action plans',
      permissions: {
        'plans.delete': 'Delete Action plans',
        'plans.edit': 'Edit Action plans',
        'plans.comments.delete': 'Delete Action plan comments',
        'plans.view': 'View Action plans',
      },
      tooltips: {
        'plans.delete':
          'Allows deleting action plans within the assigned scope.',
        'plans.edit':
          'Allows creating and editing action plans within the assigned scope.',
        'plans.comments.delete':
          'Allows deleting comments on action plans within the assigned scope.',
        'plans.view': 'Allows viewing action plans within the assigned scope.',
      },
    },
    profiles: {
      name: 'Profiles',
      permissions: {
        'profiles.delete': 'Delete Employees',
        'profiles.edit': 'Edit Employees',
        'profiles.create': 'Add Employees',
        'profiles.view': 'View Employees',
        'profiles.roles.manage': 'Manage Roles',
        'profiles.documents.view': 'View documents',
        'profiles.documents.manage': 'Manage documents',
        'settings.person_info.manage': 'Manage person fields information',
        'profiles.sensitive.view': 'View Profile Info sensitive data',
      },
      tooltips: {
        'profiles.delete':
          'Allows deleting employee profiles within the assigned scope.',
        'profiles.edit':
          'Allows editing employee profile information within the assigned scope.',
        'profiles.create': 'Allows adding new employees to the organization.',
        'profiles.view':
          'Allows viewing employee profiles within the assigned scope.',
        'profiles.roles.manage':
          'Allows assigning and managing roles for employees within the assigned scope.',
        'profiles.documents.view':
          'Allows viewing employee documents within the assigned scope.',
        'profiles.documents.manage':
          'Allows uploading, editing, and deleting employee documents within the assigned scope.',
        'profiles.sensitive.view':
          'Allows viewing sensitive profile information such as personal identifiers within the assigned scope.',
      },
    },
    recruitment: {
      name: 'Recruitment',
      permissions: {
        'recruitment.delete': 'Delete Recruitment',
        'recruitment.edit': 'Edit Recruitment',
        'recruitment.view': 'View Recruitment',
      },
      tooltips: {
        'recruitment.delete':
          'Allows deleting jobs and candidates within the assigned scope.',
        'recruitment.edit':
          'Allows creating and editing jobs and candidates within the assigned scope.',
        'recruitment.view':
          'Allows viewing jobs and candidates within the assigned scope.',
      },
    },
    reviews: {
      name: 'Review',
      permissions: {
        'cycles.view': 'View Cycles',
        'cycles.manage': 'Manage Cycles',
        'surveys.view.all': 'View all Surveys',
        'surveys.view.created':
          'View Surveys created by the logged-in user (own surveys only)',
        'surveys.manage.all': 'Manage all Surveys',
        'surveys.manage.created':
          'Manage Surveys created by the logged-in user (own surveys only)',
        'attributes.manage': 'Manage Attributes',
        'attributes.view': 'View Attributes',
      },
      tooltips: {
        'cycles.view':
          'Allows viewing review cycles within the assigned scope.',
        'cycles.manage':
          'Allows creating, editing, and managing review cycles within the assigned scope.',
        'surveys.view.all':
          'Allows viewing all surveys within the assigned scope.',
        'surveys.view.created':
          'Allows viewing only surveys created by the logged-in user.',
        'surveys.manage.all':
          'Allows managing all surveys within the assigned scope.',
        'surveys.manage.created':
          'Allows managing only surveys created by the logged-in user.',
        'attributes.manage':
          'Allows creating, editing, and deleting review attributes within the assigned scope.',
        'attributes.view':
          'Allows viewing review attributes within the assigned scope.',
      },
    },
    reports: {
      name: 'Reports',
      permissions: {
        'reports.summary.manage': 'Manage Survey summary report',
        'reports.absence.view': 'View Absence report',
        'reports.attributes.view': 'View Attribute report',
        'reports.headcount.view': 'View Headcount report',
        'reports.overview.view': 'View Company overview report',
        'reports.competence.view': 'View Competence map report',
        'reports.skills.view': 'View Skills matrix report',
        'reports.mood.view': 'View General mood report',
        'reports.compare.view': 'View Compare report',
      },
      tooltips: {
        'reports.summary.manage':
          'Allows configuring and managing the survey summary report.',
        'reports.attributes.view': 'Allows viewing the attribute report.',
        'reports.headcount.view': 'Allows viewing the headcount report.',
        'reports.absence.view': 'Allows viewing the absence report.',
        'reports.overview.view': 'Allows viewing the company overview report.',
        'reports.competence.view': 'Allows viewing the competence map report.',
        'reports.skills.view': 'Allows viewing the skills matrix report.',
        'reports.mood.view': 'Allows viewing the general mood report.',
        'reports.compare.view': 'Allows viewing the compare report.',
      },
    },
    settings: {
      name: 'Settings',
      permissions: {
        'settings.demo_data.manage': 'Manage demo data',
        'settings.slack_integration.manage': 'Manage Slack integration',
        'settings.user_documents.manage': 'Manage documents',
        'settings.person_info.manage': 'Manage person info fields',
        'settings.features.manage': 'Manage features',
        'settings.permissions.manage': 'Manage permissions',
        'settings.subscriptions.manage': 'Manage subscription',
      },
      tooltips: {
        'settings.demo_data.manage':
          'Allows managing demo data for the organization.',
        'settings.slack_integration.manage':
          'Allows configuring and managing the Slack integration.',
        'settings.user_documents.manage':
          'Allows managing organization document categories and types.',
        'settings.features.manage':
          'Allows enabling and disabling organization features.',
        'settings.permissions.manage':
          'Allows managing roles and permissions across the organization.',
        'settings.subscriptions.manage':
          'Allows managing the organization subscription and billing.',
      },
    },
    tags: {
      name: 'Tags',
      permissions: {
        'tags.users.manage': 'Manage Tag users',
        'tags.manage': 'Manage Tags',
        'tags.view': 'View Tags',
      },
      tooltips: {
        'tags.users.manage': 'Allows assigning and removing users from tags.',
        'tags.manage': 'Allows creating, editing, and deleting tags.',
        'tags.view': 'Allows viewing tags and their assignments.',
      },
    },
  },
};

const organizationSettingsNavigation = {
  en: {
    features: 'Features',
    permissions: 'Permissions',
    documents: 'Documents',
    profileInfo: 'Profile info',
  },
};

const successionNavigation = {
  en: {
    keyJobs: 'Key jobs',
    pools: 'Pools',
    settings: 'Settings',
  },
};

const statuses = {
  en: {
    active: commonLabels.active,
    archived: 'Archived',
    removed: 'Removed',
    approved: 'Approved',
    approvedAbsence: 'Approved',
    all: 'All',
    toDo: 'To do',
    inProgress: 'In progress',
    done: 'Done',
    draft: 'Draft',
    completed: 'Completed',
    scheduled: 'Scheduled',
    past: 'Past',
    pending: 'Pending',
    halfApproved: 'Half approved',
    upcoming: 'Upcoming',
    started: 'Started',
    submitted: 'Submitted',
    notStarted: 'Not started',
    requested: commonLabels.requested,
    requestedAbsence: commonLabels.requested,
    proposed: commonLabels.proposed,
    activeWithoutAccess: 'Active without access',
    activeInvited: 'Active invited',
    activeWithAccess: 'Active with access',
    deactivated: 'Deactivated',
    rejected: 'Rejected',
    sent: 'Sent',
  },
};

const proposedPlanTooltip = {
  en: {
    default: 'Proposed by user',
    requestedByYou: 'Proposed by you',
  },
};

const requestedOneOnOneTooltip = {
  en: {
    default: 'Requested by user',
    requestedByYou: 'Requested by you',
  },
};

const attributeChip = {
  en: {
    openEndedAttribute: 'Open-ended attribute',
    personalAttribute: 'Personal attribute',
    dragTooltip: 'You can drag attributes to rearrange them.',
    userPersonalAttribute:
      "This is [FULL NAME]'s personal attribute. Usage is restricted.",
    toggleComments: 'Toggle attribute comments',
    answerComments: 'This attribute has answer comment enabled',
    preview: 'Preview questions',
  },
};

const sidebarNavigation = {
  en: {
    dashboard: {
      title: 'Dashboard',
    },
    announcements: {
      title: 'Announcements',
    },
    alignment: {
      title: 'Alignment',
      items: {
        actionPlans: 'Action plans',
        myPrivateNotes: 'My private notes',
        oneOnOne: '1:1 meetings',
      },
    },
    learning: {
      title: 'Learning hub',
    },
    review: {
      title: 'Review',
      items: {
        attributes: 'Attributes',
        cycles: 'Cycles',
        surveys: 'Surveys',
        surveyHistory: 'Survey history',
      },
    },
    reports: {
      title: 'Reports',
      items: {
        companyOverview: 'Company overview',
        absenceReport: 'Absence report',
        skillsMatrix: 'Skills matrix',
        stats: 'Competence map',
        headcountReport: 'Headcount report',
        oneOnOneReport: 'General mood',
        attribute: 'Attribute',
        compare: 'Compare',
        surveySummary: 'Survey summary',
      },
    },
    career: {
      title: 'Career',
      items: {
        jobTitles: 'Job titles',
        leveling: 'Levels and tracks',
        succession: 'Succession',
      },
    },
    absence: {
      title: commonLabels.absence,
      items: {
        calendar: 'Calendar',
        requests: 'Requests',
        settings: 'Settings',
      },
    },
    company: {
      title: 'Organization',
      items: {
        absenceSettings: commonLabels.absence,
        orgChart: 'Org Chart',
        people: 'People directory',
        tags: 'Tags',
        divisions: 'Divisions',
      },
    },
    recruitment: {
      title: 'Recruitment',
      items: {
        jobs: 'Jobs',
        candidates: 'Candidates',
        talentPool: 'Talent pool',
        timeToHire: 'Time to hire',
      },
    },
  },
};

const successionJobChangelogActions = {
  en: {
    added: 'added to successors',
    updatedReadiness: 'readiness level changed',
    updatedNote: 'note changed',
    removed: 'removed from successors',
    rankChanged: 'rank changed',
    keySet: 'Job title added to key jobs',
    keyUnset: 'Job title removed from key jobs',
  },
};

const successionPoolChangelogActions = {
  en: {
    added: 'added to pool',
    updatedReadiness: 'readiness level changed',
    updatedNote: 'note changed',
    removed: 'removed from pool',
  },
};
const absenceAccrualOptions = {
  en: {
    yearly: 'Yearly',
    monthly: 'Monthly',
  },
};

const interval = {
  en: {
    week: 'Week',
    month: 'Month',
  },
};

const periodFilter = {
  en: {
    all: 'All time',
    twoMonths: '2 months range',
    sixMonths: '6 months range',
    twelveMonths: '12 months range',
  },
};

const personalAttribute = {
  en: {
    tooltipText:
      "This is [FULL NAME]'s personal attribute. Usage is restricted.",
  },
};

const surveyTypeFilterOptions = {
  en: {
    teamPeerDirect: 'Team & Peer & Direct',
    teamPeer: 'Team & Peer',
    teamDirect: 'Team & Direct',
    peerDirect: 'Peer & Direct',
    team: 'Team',
    peer: 'Peer',
    direct: 'Direct',
    self: 'Self',
    pulse: 'Pulse',
  },
};

const teamNotifications = {
  en: {
    title: 'Updated',
    updatesButtonTooltip: 'View notification',
    markAsRead: 'Mark as read',
    updates: {
      agenda: 'Manager meeting agenda',
      employeeAgenda: 'Employee meeting agenda',
      title: commonLabels.title,
      dueDate: commonLabels.dueDate,
      status: commonLabels.status,
      completeness: commonLabels.completeness,
      tags: commonLabels.tags,
      courses: commonLabels.courses,
      description: commonLabels.description,
      tasks: commonLabels.tasks,
      meetingTime: 'Meeting time',
      meetingDateTime: 'Meeting date and time',
      meetingDate: 'Meeting date',
      recurring: 'Recurring',
      plans: commonLabels.actionPlans,
      sharedNote: commonLabels.sharedNote,
      meetingImpression: 'Impression',
      text: 'Content',
      createdPlan: 'New Action plan has been created.',
      createdOneOnOne: 'New 1:1 has been created.',
      createdNote: 'New Note has been created.',
    },
  },
};

const commonFieldValidationMessages = {
  en: {
    availableName: 'Name is already taken.',
    isEmpty: 'This field is required.',
    forbiddenCharacters:
      'Field contains forbidden characters: <, >, [, ], {, }, |, \\',
    maxLength: 'Exceeded max length of 250 characters.',
    somethingWentWrong: 'Oops! Something went wrong.',
    itemName: 'Field can contain only alphanumeric and +, # characters.',
    alphanumeric: 'Field can contain only alphanumeric characters.',
    freemium: 'Free plan limit reached.',
  },
};

const levelingTypes = {
  en: {
    custom: {
      name: 'Start from scratch',
      description:
        'With this option you now have the opportunity to create personalized leveling tables tailored to your specific needs.',
    },
    template: {
      name: 'Templates',
      description:
        'Gain access to a curated collection of the finest examples from' +
        ' renowned companies by Higher-ups. ',
    },
  },
};

const courseLabels = {
  en: {
    level: commonLabels.level,
    attribute: commonLabels.attribute,
    url: 'URL',
    visitCourse: 'See course',
    all: commonLabels.all,
    enrolledUsers: 'Enrolled employees',
    tags: 'Tags',
  },
};

const validationMessages = {
  en: {
    city: {
      invalid: 'City should contain only alphabets.',
      required: 'City is required.',
      minLength: 'Minimum length is 2 characters.',
      maxLength: 'Maximum length is 100 characters.',
    },
    country: {
      invalid: 'Country is invalid.',
      required: 'Country is required.',
    },
    date: {
      invalid: 'Date is invalid.',
      required: 'Date is required.',
    },
    email: {
      invalid: 'Email is invalid.',
      required: 'Email is required.',
      exceededLength: 'Maximum length is 100 characters.',
      existingEmails: 'Email(s) already in use:',
      isUnique: 'Email is not unique.',
      isAvailable: 'Email is already taken.',
    },
    firstName: {
      invalid: 'Name should contain only alphabets.',
      required: 'Name is required.',
      minLength: 'Minimum length is 2 characters.',
      maxLength: 'Maximum length is 50 characters.',
    },
    lastName: {
      invalid: 'Name should contain only alphabets.',
      required: 'Name is required.',
      minLength: 'Minimum length is 2 characters.',
      maxLength: 'Maximum length is 50 characters.',
    },
    level: {
      invalid: 'Level is invalid.',
      required: 'Level is required.',
    },
    phoneHome: {
      invalid: 'Phone number can start with + and can contain only numbers',
      required: 'Phone number is required.',
      minLength: 'Minimum length is 7 characters.',
      maxLength: 'Maximum length is 15 characters.',
    },
    phoneMobile: {
      invalid: 'Phone number can start with + and can contain only numbers.',
      required: 'Phone number is required.',
      minLength: 'Minimum length is 7 characters.',
      maxLength: 'Maximum length is 15 characters.',
    },
    jobTitle: {
      invalid: 'Job title is invalid.',
      required: 'Job title is required.',
    },
    track: {
      required: 'Track is required.',
    },
    framework: {
      required: 'Framework is required.',
    },
    division: {
      required: 'Division is required.',
    },
    department: {
      required: 'Department is required.',
    },
    role: {
      invalid: 'Role is invalid.',
      required: 'Role is required.',
      freemiumLimit: commonFieldValidationMessages.en.freemium,
    },
    status: {
      invalid: 'Status is invalid.',
      required: 'Status is required.',
    },
    reportTo: {
      required: 'Reporting to is required.',
      invalid: 'Reporting to is invalid.',
    },
    desiredUrl: {
      required: 'Url is required.',
      invalid: 'Url is invalid.',
      maxLength: 'Maximum length is 50 characters.',
    },
    acceptTerms: {
      invalid: 'You need to accept terms-of-service.',
    },
    name: {
      required: 'Name is required.',
      minLength: 'Attribute name must be at least 3 characters long.',
      maxLength: 'Exceeded max length of 100 characters.',
    },
    description: {
      maxLength: 'Exceeded max length of 200 characters.',
      required: 'Description is required.',
    },
    organization: {
      required: 'Workspace url is required',
      invalid: 'Workspace url is invalid',
      notExist: "Workspace doesn't exist",
      maxLength: 'Maximum length is 50 characters',
    },
    twoFactor: {
      required: 'Code is required',
      invalid: 'Invalid otp code.',
      rateLimit: 'Too many attempts. Please wait a moment and try again.',
      enterCodeAgain: 'Enter code again.',
    },
  },
};

const iconButtonsTooltip = {
  en: {
    accept: 'Accept',
    dismiss: 'Dismiss',
    resolve: 'Resolve',
    reschedule: 'Reschedule',
    download: 'Download',
  },
};

const authContainer = {
  en: {
    kadar: commonLabels.app,
    description: 'Take your career to another level',
    singUpText: 'New to Kadar?',
    singInText: 'Already have an account?',
    signUpButton: 'Sign up',
    signInButton: 'Sign in',
    notIn: 'Not in',
    changeOrganization: 'Change organization',
    privacy_policy: { name: 'Privacy policy' },
    terms_of_service: { name: 'Terms of service' },
    copyrightText: `© Kadar ${new Date().getFullYear()}`,
    desktopOnly: 'Currently optimized only for desktop.',
    cookieConsentSettings: 'Consent settings',
  },
};

const alertDialogs = {
  en: {
    actionPlanDelete: {
      title: 'Delete Action plan',
      contentMessage: 'Are you sure you want to delete this action plan?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Action plan successfully deleted.',
    },
    actionPlanProposalDismiss: {
      title: 'Dismiss proposed Action plan',
      contentMessage:
        'Are you sure you want to dismiss this proposed action plan?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Action plan proposal successfully dismissed.',
    },
    actionPointCommentDelete: {
      title: 'Delete comment',
      contentMessage: 'Are you sure you want to delete this comment?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Comment successfully deleted.',
    },
    attributeDelete: {
      title: 'Delete attribute',
      contentMessage: 'Are you sure that you want to delete this attribute?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Attribute successfully deleted.',
    },
    attributeUsedDelete: {
      title: 'Delete attribute',
      contentMessage:
        'This Attribute is used in [X] survey(s) and by' +
        ' deleting it all data, answers and results from survey(s) will be lost.',
      contentDescription:
        'Are you sure that you want to delete this attribute?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Attribute successfully deleted.',
    },
    attributeQuestionArchive: {
      title: 'Confirm Question Archiving',
      contentMessage:
        'Archiving will affect all future surveys that use this attribute.',
      confirmButton: commonLabels.archive,
      closeButton: commonLabels.no,
    },
    attributeQuestionUnarchive: {
      title: 'Confirm Question Unarchiving',
      contentMessage:
        'Unarchiving will make this question available for future surveys using this attribute',
      confirmButton: commonLabels.unarchive,
      closeButton: commonLabels.no,
    },
    attributeQuestionDelete: {
      title: 'Confirm question deletion',
      contentMessage: 'Are you sure that you want to delete this question?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Attribute question successfully deleted.',
    },
    attributeQuestionDuplicate: {
      title: 'Question duplication',
      contentMessage: 'Are you sure that you want to duplicate this question?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      duplicateSuccess: 'Attribute question successfully duplicated.',
    },
    categoryDelete: {
      title: 'Delete category',
      contentMessage:
        'Are you sure you want to delete this category? All uploaded documents within this category will be permanently lost.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Category successfully deleted.',
    },
    documentTypeFieldDelete: {
      title: 'Delete document type',
      contentMessage:
        'Are you sure you want to remove this document type? All uploaded documents within this type will be permanently lost.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
    },
    courseDelete: {
      title: 'Delete course',
      contentMessage: 'Are you sure you want to delete this course?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Course successfully deleted.',
    },
    announcementDelete: {
      title: 'Delete announcement',
      contentMessage: 'Are you sure you want to delete this announcement?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Announcement successfully deleted.',
    },
    courseDisenroll: {
      title: 'Disenroll from course',
      contentMessage: 'Are you sure you want disenroll this user from course? ',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      disenrollSuccess: 'User has been disenrolled from course.',
    },
    jobTitleDelete: {
      title: 'Delete job title',
      contentMessage: 'Are you sure that you want to delete this job title?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Job title successfully deleted.',
    },
    jobArchive: {
      title: 'Archive job',
      contentMessage: 'Are you sure that you want to archive this job?',
      confirmButton: commonLabels.archive,
      closeButton: commonLabels.no,
      archiveSuccess: 'Job successfully archived.',
    },
    jobUnarchive: {
      title: 'Unarchive job',
      contentMessage: 'Are you sure that you want to activate this job?',
      confirmButton: commonLabels.unarchive,
      closeButton: commonLabels.no,
      unarchiveSuccess: 'Job successfully unarchived.',
    },
    jobDelete: {
      title: 'Delete job',
      contentMessage: 'Are you sure that you want to delete this job?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Job successfully deleted.',
    },
    jobDuplicate: {
      title: 'Duplicate job',
      contentMessage: 'Are you sure that you want to duplicate this job?',
      confirmButton: commonLabels.duplicate,
      closeButton: commonLabels.no,
      deleteSuccess: 'Job successfully duplicated.',
    },
    candidateDelete: {
      title: 'Delete candidate',
      contentMessage:
        'Are you sure that you want to delete this candidate? Once you delete this candidate, it will be removed from all jobs.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Candidate successfully deleted.',
    },
    commentDelete: {
      title: 'Delete comment',
      contentMessage: 'Are you sure that you want to delete this comment?',
      confirmButton: commonLabels.delete,
      closeButton: commonLabels.no,
      deleteSuccess: 'Comment successfully deleted.',
    },
    voteDelete: {
      title: 'Delete evaluation',
      contentMessage: 'Are you sure that you want to delete this evaluation?',
      confirmButton: commonLabels.delete,
      closeButton: commonLabels.no,
      deleteSuccess: 'Evaluation successfully deleted.',
    },
    disqualifyCandidate: {
      title: 'Disqualify candidate',
      contentMessage:
        'Are you sure that you want to disqualify this candidate?',
      confirmButton: commonLabels.disqualify,
      closeButton: commonLabels.no,
      deleteSuccess: 'Candidate successfully disqualified.',
    },
    qualifyCandidate: {
      title: 'Qualify candidate',
      contentMessage: 'Are you sure that you want to qualify this candidate?',
      confirmButton: commonLabels.qualify,
      closeButton: commonLabels.no,
      deleteSuccess: 'Candidate successfully qualified.',
    },
    surveySubmit: {
      title: 'Confirm review submission',
      contentMessage: 'Are you sure that you want to submit this review?',
      multipleReviews:
        'Are you sure that you want to submit this review and proceed to' +
        ' the next review?',
      confirmButton: 'Submit',
      closeButton: 'Cancel',
    },
    surveySubmitMultiple: {
      title: 'Confirm review submission',
      contentMessage:
        'Are you sure that you want to submit this review and proceed to' +
        ' the next review?',
      confirmButton: 'Submit',
      closeButton: 'Cancel',
    },
    deleteLevelingTemplate: {
      title: 'Delete leveling system',
      contentMessage:
        'Are you sure that you want to delete this leveling system?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Leveling system successfully deleted.',
    },
    deleteLevelingTrack: {
      title: 'Are you sure that you want to delete this track?',
      contentMessage: 'Levels have been created in this track.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Leveling track successfully deleted.',
    },
    editLevelingTemplate: {
      title: 'Add leveling system',
      contentMessage:
        'Are you sure that you want to add this leveling system? It will override the existing one.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      editSuccess: 'Leveling system successfully edited.',
    },
    levelingFrameworkDelete: {
      title: 'Are you sure that you want to delete this framework?',
      contentMessage: 'Levels have been created in this framework.',
      confirmButton: commonLabels.delete,
      closeButton: commonLabels.cancel,
    },
    levelingTrackDelete: {
      title: 'Are you sure that you want to delete this track?',
      contentMessage: 'Levels have been created in this track.',
      confirmButton: commonLabels.delete,
      closeButton: commonLabels.cancel,
    },
    divisionDelete: {
      title: 'Are you sure that you want to delete this division?',
      contentMessage: 'Departments have been created in this division.',
      confirmButton: commonLabels.delete,
      closeButton: commonLabels.cancel,
    },
    departmentDelete: {
      title: 'Are you sure that you want to delete this department?',
      confirmButton: commonLabels.delete,
      closeButton: commonLabels.cancel,
    },
    levelingLevelDelete: {
      title: 'Are you sure that you want to delete level?',
      confirmButton: commonLabels.delete,
      closeButton: commonLabels.cancel,
    },
    levelingTrackLevelDelete: {
      title: 'Delete  track level',
      contentMessage: 'Are you sure that you want to delete track level?',
      contentDescription:
        'This track level it’s been used by [EMPLOYEE_NUMBER]' +
        ' active employee(s).',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
    },
    oneOnOneTopicDelete: {
      title: 'Delete 1:1 topic',
      contentMessage: 'Are you sure that you want to delete this 1:1 topic?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Your meeting agenda topic has been removed.',
    },
    oneOnOneCommentDelete: {
      title: 'Delete comment',
      contentMessage: 'Are you sure you want to delete this comment?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Comment successfully deleted.',
    },
    upcomingMeeting: {
      title: '1:1 meeting request',
      contentMessage:
        'You already have an upcoming 1:1 with your manager. Do' +
        ' you want to proceed anyway?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
    },
    meetingRequestDelete: {
      title: 'Delete meeting request',
      contentMessage: 'Are you sure you want to delete this meeting request?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Meeting request successfully deleted.',
    },
    oneOnOneRecordDelete: {
      title: 'Delete 1:1 record',
      contentMessage: 'Are you sure that you want to delete this 1:1 record?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: '1:1 record successfully deleted.',
    },
    oneOnOneRequestDismiss: {
      title: 'Dismiss 1:1 request',
      contentMessage: 'Are you sure you want to dismiss this 1:1 request?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      dismissSuccess: '1:1 request successfully dismissed',
    },
    userDelete: {
      title: 'Permanent delete',
      contentMessage:
        'Once you delete this user, all associated data and collected results will be permanently lost.',
      contentDescription: 'Are you sure you want to delete this user?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'User has been successfully deleted.',
    },
    userInvite: {
      title: commonLabels.invite,
      contentDescription:
        'Are you sure you want to send app invitation to this user?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      inviteSuccess: 'User has been successfully invited.',
    },
    userReinvite: {
      title: commonLabels.reinvite,
      contentDescription:
        'Are you sure you want to resend app invitation to this user?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      reinviteSuccess: 'User has been successfully reinvited.',
    },
    userRevokeAccess: {
      title: commonLabels.revokeAccess,
      contentDescription:
        'Are you sure you want to revoke app access to this user?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      revokeSuccess: "User's app access has been successfully revoked.",
    },
    surveyDelete: {
      title: 'Delete survey',
      contentMessage:
        'Once you delete this Survey, all data, answers and results will be permanently lost.',
      contentDescription: 'Are you sure you want to delete this survey?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Survey successfully deleted.',
    },
    scheduledSurveyDelete: {
      title: 'Delete scheduled survey',
      contentMessage: 'Are you sure you want to delete this scheduled survey?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Scheduled survey successfully deleted.',
    },
    draftSurveyDelete: {
      title: 'Delete survey draft ',
      contentMessage: 'Are you sure you want to delete this survey draft?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Survey draft successfully deleted.',
    },
    surveySendReminderAll: {
      title: 'Send reminder',
      contentMessage:
        'Are you sure you want to send reminder to all reviewers?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      sendSuccess: 'Reminder successfully sent.',
    },
    surveyReopenAll: {
      title: 'Reopen survey',
      contentMessage:
        'Are you sure you want to reopen survey for all reviewers?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      success: 'Survey successfully reopened.',
    },
    surveyForceComplete: {
      title: 'Close survey',
      contentMessage: 'Are you sure you want to close this survey?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      completeSuccess: 'Survey successfully closed.',
    },
    tagCategoryDelete: {
      title: 'Delete category',
      contentMessage: 'Are you sure that you want to delete this category?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Tag category successfully deleted.',
    },
    tagDelete: {
      title: 'Delete tag',
      contentMessage: 'Are you sure that you want to delete this tag?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Tag successfully deleted.',
    },
    noteDelete: {
      title: 'Delete note',
      contentMessage: 'Are you sure that you want to delete this note?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Note successfully deleted.',
    },
    questionsIncreaseAnswerCount: {
      title: 'Question style',
      contentMessage:
        'Are you sure you want to change number of answers? New input fields will be added at the end.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.cancel,
    },
    questionsDecreaseAnswerCount: {
      title: 'Question style',
      contentMessage:
        'Are you sure you want to change number of answers? The last answer in every question will be deleted.',
      contentMessageMultiple:
        'Are you sure you want to change number of answers? Last [X] answers' +
        ' in every question will be deleted.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.cancel,
    },
    questionsOpenEndedQuestions: {
      title: 'Question style',
      contentMessage:
        'Are you sure you want to change question style? In this case, all answers will be deleted.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.cancel,
    },
    questionsMultipleChoice: {
      title: 'Question style',
      contentMessage: 'Are you sure you want to change question style?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.cancel,
    },
    questionsNeutralAnswer: {
      title: 'Question style',
      contentMessage:
        'The N/A will be added as an answer option to all questions in the Attribute.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.cancel,
    },
    questionsRemoveNeutralAnswer: {
      title: 'Question style',
      contentMessage:
        'The N/A will be removed as an answer option from all questions in the Attribute.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.cancel,
    },
    answerTypeChangeDialog: {
      title: 'A quick heads-up',
      contentMessage:
        'Once you start editing answers in Horizontal view, any applied text formatting will be removed.',
      closeButton: commonLabels.gotIt,
    },
    unshareUserReport: {
      title: 'Survey report access',
      contentMessage:
        'Are you sure that you want to remove this user from Survey report access list.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess:
        'User successfully removed from Survey report access list.',
    },
    presetDelete: {
      title: 'Delete preset',
      contentMessage: 'Are you sure that you want to delete preset?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Preset successfully deleted.',
    },
    surveyGroupDelete: {
      title: 'Delete group',
      contentMessage: 'Are you sure you want to delete this group?',
      contentDescription: 'All surveys inside group will be preserved.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Survey group successfully deleted.',
    },
    surveyGroupDuplicate: {
      title: 'Duplicate group',
      contentMessage: 'Are you sure you want to duplicate this group?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      duplicateSuccess: 'Survey group successfully duplicated.',
    },
    surveySummaryReportDelete: {
      title: 'Delete summary report',
      contentMessage:
        'Once you delete this report, it will no longer be accessible to employees with whom it was previously shared.',
      contentDescription:
        'Are you sure you want to delete this summary report?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Survey summary report successfully deleted.',
    },
    removeSurveyFromGroup: {
      title: 'Remove from group',
      contentMessage: 'Are you sure you want to remove this survey from group?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      success: 'Survey successfully removed from group.',
    },
    surveyDuplicate: {
      title: 'Duplicate survey',
      contentMessage: 'Are you sure you want to duplicate this survey?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      duplicateSuccess: 'Survey successfully duplicated.',
    },
    taskStatusChange: {
      title: 'Task status',
      contentMessageCheck:
        'Are you sure that you want to mark this task as finished?',
      contentMessageUncheck:
        'Are you sure that you want to mark this task as unfinished?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      success: 'Task status successfully updated.',
    },
    holidayDelete: {
      title: 'Delete holiday',
      contentMessage: 'Are you sure you want to delete this holiday?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Holiday successfully deleted.',
    },
    absenceSetDelete: {
      title: 'Delete absence set',
      contentMessage: 'Are you sure you want to delete this absence set?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Absence set successfully deleted.',
    },
    absenceSetDeleteWarning: {
      title: 'Delete absence set',
      contentMessage: 'Before deleting set, remove any assigned users.',
      closeButton: commonLabels.close,
    },
    absenceDelete: {
      title: 'Delete absence type',
      contentMessage: 'Are you sure you want to delete this absence type?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Absence type successfully deleted.',
    },
    absenceWarningDelete: {
      title: 'Delete absence type',
      contentMessage:
        'Before deleting absence type, remove any assigned users.',
      closeButton: commonLabels.close,
    },
    absenceExtensionDelete: {
      title: 'Delete extension',
      contentMessage: 'Are you sure you want to delete this extension?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Extension successfully deleted.',
    },
    absenceExtensionWarningDelete: {
      title: 'Delete extension',
      contentMessage: 'Before deleting extension, remove any assigned users.',
      closeButton: commonLabels.close,
    },
    absenceRequestDelete: {
      title: 'Delete leave request',
      contentMessage: 'Are you sure you want to delete this leave request?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Leave request successfully deleted.',
    },
    absenceRequestApprove: {
      title: 'Approve leave request',
      contentMessage: 'Are you sure you want to approve this leave request?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      approveSuccess: 'Leave request successfully approved.',
    },
    absenceRequestReject: {
      title: 'Reject leave request',
      contentMessage: 'Are you sure you want to reject this leave request?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      rejectSuccess: 'Leave request successfully rejected.',
    },
    deleteTeam: {
      title: 'Delete team',
      contentMessage: 'Are you sure you want to delete this team?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Team successfully deleted.',
    },
    cycleDelete: {
      title: 'Delete cycle',
      contentMessage: 'Are you sure you want to delete this cycle?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Cycle successfully deleted.',
    },
    rejectAbsenceRequestDialog: {
      title: 'Reject absence request',
      contentMessage: 'Are you sure you want to reject this absence request?',
      confirmButton: commonLabels.reject,
      closeButton: commonLabels.no,
      rejectSuccess: 'Absence request successfully rejected.',
    },
    approveAbsenceRequestDialog: {
      title: 'Approve absence request',
      contentMessage: 'Are you sure you want to approve this absence request?',
      confirmButton: commonLabels.approve,
      closeButton: commonLabels.no,
      acceptSuccess: 'Absence request successfully approved.',
    },
    qrCodeDialog: {
      setupTitle: 'Authentication setup',
      disableTitle: 'Disable 2FA?',
      disableDescription:
        'You will no longer be asked for a verification code when signing in.',
      resetTitle: 'Reset 2FA?',
      resetDescription:
        'This will remove your current authenticator and require you to set up a new one the next time you log in.',
      scanMessage:
        'Scan this QR code with your authenticator app (e.g. Google Authenticator, Microsoft Authenticator).',
      secretMessage: `Can't scan? Enter this setup key manually.`,
      codePlaceholder: 'Enter code',
      codeLabel: 'Enter the verification code',
      helpText: 'Lost access to your authenticator? Use a recovery code.',
      closeButton: commonLabels.close,
      confirmButton: commonLabels.confirm,
      downloadRecoveryCodes: `We recommend you to download your recovery codes. They’re the only way to access your account if you lose your authenticator.`,
      invalid: 'Invalid otp code.',
      rateLimit: 'Too many attempts. Please wait a moment and try again.',
      enterCodeAgain: 'Enter code again.',
    },
    additionalRoleDelete: {
      title: 'Delete additional role',
      contentMessage: 'Are you sure that you want to delete additional role?',
      contentDescription: 'This will also delete any defined scopes.',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Additional role successfully deleted.',
    },
    employeeScopeDelete: {
      title: 'Delete scope',
      contentMessage: 'Are you sure that you want to delete this scope?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Scope successfully deleted.',
    },
  },
};

const warningDialogs = {
  en: {
    attributeDelete: {
      title: 'Attribute you are trying to delete is being used:',
      levelsSubtitle: 'Levels:',
      closeButton: commonLabels.close,
    },
    tagDelete: {
      title: 'Delete tag',
      contentMessage: 'This tag is being used.',
      contentDescription: 'Are you sure that you want to delete this tag?',
      confirmButton: commonLabels.yes,
      closeButton: commonLabels.no,
      deleteSuccess: 'Tag successfully deleted.',
    },
    tagsDelete: {
      title: 'Following Tag(s) you are trying to delete are being used:',
      closeButton: commonLabels.cancel,
      forceDeleteButton: 'Delete & Save',
    },
  },
};

const cycleSteps = {
  en: {
    email: {
      name: commonLabels.email,
      shortName: commonLabels.email,
    },
    selfReview: {
      name: 'Self review',
      shortName: 'Self',
    },
    topDownReview: {
      name: 'Top > Down review',
      shortName: 'Top > Down',
    },
    downUpReview: {
      name: 'Down > Up review',
      shortName: 'Down > Up',
    },
    peerReview: {
      name: 'Peer review',
      shortName: 'Peer',
    },
  },
};

const holidays = {
  en: {
    title: 'Holidays',
    holiday: 'Holiday',
    description: 'Automatically granted time off for all set users.',
  },
};

const neutralAnswer = {
  en: {
    neutral: {
      text: 'Neutral answer',
      shorthand: 'N/A',
      notApplicable: 'Not applicable',
    },
  },
};

const anonymousUser = {
  en: {
    first_name: 'Anonymous',
    last_name: 'User',
  },
};

const employmentInfoHelpText = {
  en: {
    jobTitle: {
      text: "Please choose the employee's Job title.",
    },
    framework: {
      text: "Please choose the employee's Framework.",
    },
    track: {
      text: 'Please choose the Framework first to enable Track selection.',
    },
    level: {
      text: 'Please choose the Track first to enable Level selection.',
    },
    division: {
      text: "Please choose the employee's Division.",
    },
    department: {
      text: 'Please choose the Division first to enable Department selection.',
    },
    reportTo: {
      text: 'Please choose the user superior.',
    },
    role: {
      text: 'Please choose user role.',
    },
  },
};

const personalInfoHelpText = {
  en: {
    email: {
      text:
        'The email you provide will be used only to enable the employee to' +
        ' receive surveys. They will not be notified.',
    },
  },
};

const peoplePicker = {
  en: {
    allEmployees: 'All employees',
    allAssociates: 'All associates',
    selectButtonLabel: 'Select',
    noUserResults: commonLabels.noUserResults,
    startSearch: 'Start typing ...',
    directReports: 'Direct reports',
  },
};

const fillSurveyFlow = {
  en: {
    subject: 'Survey for',
    groupSurvey: 'Group survey',
    anonymous: commonLabels.anonymous,
    appName: commonLabels.app,
    welcomeMessage: 'Hi, there!',
    numberOfSurveys:
      'The Survey in front of you has [NUMBER_OF_REVIEWS] of questions to fill in.',
    numberOfQuestions:
      'The number of questions in total is [NUMBER_OF_QUESTIONS].',
    description: 'Attribute description',
    oneGroup: 'one group',
    groups: 'groups',
    getStartedButtonLabel: 'Get started',
    nextLabel: 'Next',
    backLabel: commonLabels.back,
    addCommentLabel: commonLabels.addComment,
    editCommentLabel: commonLabels.editComment,
    addCommentForm: {
      title: {
        add: commonLabels.addComment,
        edit: commonLabels.editComment,
        view: 'Comment',
      },
      formLabels: {
        answerComment: {
          label: 'Comment',
          placeholder: 'Add comment',
        },
      },
      cancel: commonLabels.cancel,
      save: commonLabels.save,
      validationMessages: {
        required: commonFieldValidationMessages.en.isEmpty,
        answerCommentMaxLength: 'Exceeded maximum allowed field length.',
      },
    },
    submitLabelPreview: 'Next review',
    submitLabel: commonLabels.submit,
    answers: {
      save: commonLabels.save,
      weight: commonLabels.weight,
      purposePlaceholder: 'Add comment',
      dragTooltip: 'You can drag answers to rearrange them.',
      neutralAnswer: {
        label: neutralAnswer.en.neutral.shorthand,
        text: 'Select "Not applicable" for this answer',
        neutralValue: 'Not applicable',
      },
      freeText: {
        placeholder: 'Write an answer',
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          maxLength: 'Exceeded max length of 5000 characters',
        },
      },
    },
    submitDialog: { ...alertDialogs.en.surveySubmit },
    submitMultipleDialog: { ...alertDialogs.en.surveySubmitMultiple },
    feedbackForm: {
      title: 'Your general feedback & expectations',
      placeholder: 'Add feedback',
      validationMessages: {
        forbiddenCharacters:
          commonFieldValidationMessages.en.forbiddenCharacters,
        maxLength: 'Exceeded max length of 2500 characters',
      },
    },
  },
};

const customDialogs = {
  en: {
    transferEmployees: {
      title: commonLabels.deactivate,
      description:
        'The user you want to deactivate has direct reports. Please transfer the following employee(s) to a new manager and add date of employment termination:',
      label: 'New manager',
      placeholder: 'Please select new manager',
      terminatedEmploymentLabel: 'Date of employment termination',
      terminatedEmploymentPlacegolder: 'Add date of employment termination',
      noOptions: commonLabels.noOptions,
      searching: commonLabels.searching,
      save: 'Transfer & Deactivate',
      cancel: commonLabels.cancel,
      successMessage: 'User has been successfully deactivated.',
    },
    employmentTerminationDate: {
      title: commonLabels.deactivate,
      terminationDateTitle: 'Termination date',
      description: 'Please add date of employment termination:',
      updateDescription: 'Update date of employment termination:',
      label: 'Date of employment termination',
      placegolder: 'Add date of employment termination',
      deactivate: 'Deactivate',
      save: commonLabels.save,
      cancel: commonLabels.cancel,
      successMessage: 'User has been successfully deactivated.',
    },
    manageUserTags: {
      title: 'Manage tags',
      description: ' Add or remove tags for this user',
      selectedTags: 'Selected tags',
      search: {
        label: commonLabels.search,
        placeholder: 'Search tags',
      },
      noTags: {
        title: 'No tags',
        content: 'Tags from this category are already selected',
      },
      save: commonLabels.save,
      cancel: commonLabels.cancel,
      noSelectedTags: 'Selected tags will appear here.',
      noResults: 'There are no search results.',
      successMessage: 'Successfully updated tags',
    },
    addUsersDialog: {
      title: 'Choose what you want to do',
      options: {
        manual: {
          title: 'Add regular user manually',
          description:
            'You can add as many users as you want at' +
            'any time by typing basic info about them.',
        },
        import: {
          title: 'Import regular users from .csv',
          description:
            'You can import a group of your users easily ' +
            'from a .csv file and skip the manual part.',
        },
        associate: {
          title: 'Add External Associates',
          description:
            "External Associates won't have a profile, but you'll be able to send them a Survey to gather feedback.",
        },
      },
      upload: {
        initialMessage: 'Drag and drop csv file here or',
        selectFile: 'select file',
        downloadCsv: 'Download example .csv',
        validUsers: 'Imported users',
        existingUsers: 'Existing users',
        existingUsersTitle: 'Emails already in use',
        errors: 'Errors',
        errorsTitle: 'Error in rows',
      },
      continue: commonLabels.continue,
      cancel: commonLabels.cancel,
    },
    enrollToCourse: {
      title: 'Choose Employee(s) to Enroll to the Course',
      create: commonLabels.enroll,
      cancel: commonLabels.cancel,
      label: 'Select Employee(s)',
      placeholder: "Start typing employee's name(s)",
      description: 'The action will enroll Employee(s) in the course.',
      noOptions: commonLabels.noOptions,
    },
    addCompareWith: {
      title: 'Choose compare with',
      create: commonLabels.save,
      cancel: commonLabels.cancel,
      label: 'Compare with',
      placeholder: 'Start typing employee name',
      noOptions: commonLabels.noOptions,
    },
    bulkEdit: {
      changeReportingTo: 'Change reporting to',
      changeJobTitle: 'Change job title',
      inviteUsers: 'Invite users',
      changeLevelTrack: 'Change Level/Track',
      changeDivisionDepartment: 'Change Department',
      inviteUsersSuccess: 'Successfully invited!',
      inviteMessage: {
        following: 'Following ',
        userText: 'user ',
        usersText: 'users ',
        invited: 'will be invited:',
        noInvitation: 'Invitation has already been sent previously to ',
        userHas: ' selected user.',
        usersHave: ' selected users.',
      },
      bulkEdit: 'Bulk actions',
      noOptions: commonLabels.noOptions,
      searching: commonLabels.searching,
      success: 'Successfull change!',
      fields: {
        jobTitle: 'Job title',
        reportTo: 'Reporting to',
        framework: 'Framework',
        track: 'Track',
        level: 'Level',
        division: 'Division',
        department: 'Department',
        placeholders: {
          jobTitle: 'Select job title',
          reportTo: 'Start typing name...',
          framework: 'Select framework',
          track: 'Select track',
          level: 'Select level',
          division: 'Select division',
          department: 'Select department',
        },
      },
      fieldValidations: {
        ...validationMessages.en,
      },
      options: {
        statuses: {
          active: commonLabels.active,
          inactive: commonLabels.inactive,
        },
      },
      labelHelpData: { ...employmentInfoHelpText.en, ...personalInfoHelpText },
    },
    duplicateAttribute: {
      title: 'Duplicate Attribute',
      description:
        'Please provide the name and a short name for your new attribute.',
      name: {
        label: 'Name',
        placeholder: 'Add attribute name ',
      },
      shortName: {
        label: 'Short name',
        placeholder: 'Add attribute short name ',
      },
      save: commonLabels.save,
      cancel: commonLabels.cancel,
      errorMessages: {
        required: commonFieldValidationMessages.en.isEmpty,
        availableName: commonFieldValidationMessages.en.availableName,
        maxNameLength: 'Exceeded max length of 100 characters',
        minLength: validationMessages.en.name.minLength,
        forbiddenCharacters:
          commonFieldValidationMessages.en.forbiddenCharacters,
      },
      errorShortNameMessages: {
        required: commonFieldValidationMessages.en.isEmpty,
        exactLength: 'Short name should be 1 to 5 characters long',
        forbiddenCharacters:
          commonFieldValidationMessages.en.forbiddenCharacters,
        alphanumeric: commonFieldValidationMessages.en.alphanumeric,
        availableShortName: 'Short name is already taken',
      },
    },
    enrollCourse: {
      title: 'Choose course to enroll',
      create: commonLabels.enroll,
      cancel: commonLabels.cancel,
      search: commonLabels.search,
      courseLabels: { ...courseLabels.en },
    },
    actionPointCommentNotify: {
      title: 'Would you like to notify users about this message?',
      confirm: commonLabels.send,
      close: commonLabels.cancel,
      checkboxGroupLabel: 'Send notifications email to:',
    },
    oneOnOneCommentNotify: {
      title: 'Would you like to notify users about this message?',
      confirm: commonLabels.send,
      close: commonLabels.cancel,
      checkboxGroupLabel: 'Send notifications email to:',
    },
    attributePreview: {
      preview: commonLabels.preview,
      noData: "There aren't any questions to preview.",
      weight: commonLabels.weight,
      neutralAnswer: { ...fillSurveyFlow.en.answers.neutralAnswer },
    },
    sendSurveyNotification: {
      title: 'Send email to reviewers',
      titleSchedule: 'Schedule email to reviewers',
      description:
        'This action will [SEND] email with attribute questions' +
        ' only to the following [REVIEWER].',
      reviewer: 'Reviewer',
      reviewers: 'Reviewers',
      attributes: 'Attributes',
      questionnaire: commonLabels.questionnaire,
      createdFor: 'Who will be reviewed',
      fillInline: 'Fill survey now',
      fillInlineTooltip:
        'As you are one of the reviewers, you have an option to fill survey now. ' +
        'If you fill the survey now, no email will be sent. Otherwise, you will receive an email.',
      send: commonLabels.send,
      schedule: commonLabels.schedule,
      saveDraft: 'Save as draft',
      cancel: commonLabels.cancel,
    },
    surveyType: {
      title: 'Choose survey type',
      cancel: commonLabels.cancel,
      continue: commonLabels.continue,
    },
    surveyTitle: {
      title: 'Rename survey',
      description: 'Please enter a new title for this survey',
      name: {
        label: 'Title',
        placeholder: 'Add survey title ',
      },
      save: commonLabels.save,
      cancel: commonLabels.cancel,
      success: 'Survey title successfully changed.',
      errorMessages: {
        required: commonFieldValidationMessages.en.isEmpty,
        forbiddenCharacters:
          commonFieldValidationMessages.en.forbiddenCharacters,
        maxLength: 'Exceeded max length of 150 characters',
      },
    },
    reviewTitle: {
      title: 'Rename review',
      description: 'Please enter a new title for this review',
      name: {
        label: 'Title',
        placeholder: 'Add review title ',
      },
      save: commonLabels.save,
      cancel: commonLabels.cancel,
      success: 'Review title successfully changed.',
      errorMessages: {
        required: commonFieldValidationMessages.en.isEmpty,
        forbiddenCharacters:
          commonFieldValidationMessages.en.forbiddenCharacters,
        maxLength: 'Exceeded max length of 150 characters',
      },
    },
    upgradeRequired: {
      peopleLimit: 'Subscription',
      upgradeRequiredMessage:
        'Subscription expired. Please renew your subscription to restore full functionality.',
      contactAdminMessage:
        'Subscription expired. Please contact your admin to renew the subscription and restore full functionality.',
      upgradeButtonText: 'Upgrade plan',
      close: commonLabels.close,
    },
    starterPlan: {
      title: 'Starter',
      upgradePlan: 'Upgrade to Growth plan to get full functionality.',
      contactAdmin:
        'Please contact your admin to upgrade to Growth plan and get full functionality.',
      upgradeButtonText: 'Upgrade plan',
      close: commonLabels.close,
    },
    surveySendReminder: {
      title: 'Send reminder',
      description:
        'This action will send email with reminder only to the following' +
        ' employees',
      withoutNotification:
        "These employees have already submitted the survey, therefore they won't get an email",
      success: 'Reminder successfully sent.',
      confirm: commonLabels.send,
      close: commonLabels.cancel,
    },
    surveyReopen: {
      title: 'Reopen',
      description:
        'This action will reopen survey only for the following employees',
      withoutNotification:
        "These employees haven't submitted the survey yet, therefore they won't get an email",
      success: 'Survey successfully reopened.',
      confirm: commonLabels.send,
      close: commonLabels.cancel,
    },
    addReviewers: {
      title: 'Add new reviewers',
      titleSchedule: 'Schedule new reviewers',
      description:
        'This action will send email with attribute questions only to the' +
        ' following employee reviewers.',
      descriptionSchedule:
        'This action will schedule email with attribute' +
        ' questions only to the following reviewers.',
      usersToReview: 'Who will be reviewed',
      attributes: 'Attributes',
      confirm: commonLabels.send,
      confirmSchedule: commonLabels.schedule,
      close: commonLabels.cancel,
      success: 'Reviewers successfully added.',
      fieldLabels: {
        label: 'Reviewers',
        placeholder: 'Start typing ...',
        all: commonLabels.all,
        addButtonLabel: commonLabels.add,
        noOptions: commonLabels.noOptions,
        ...peoplePicker.en,
      },
    },
    levelingType: {
      title: 'Choose leveling table type',
      cancel: commonLabels.cancel,
      continue: commonLabels.continue,
    },
    addImpression: {
      title: 'Add impression',
      cancel: commonLabels.cancel,
      save: commonLabels.save,
      saveAndCreate: commonLabels.saveAndCreate,
      success: '1:1 record impression successfully added',
      meetingImpression: {
        label: 'Impression',
        positive: 'Positive',
        negative: 'Negative',
        info: 'Add impression after 1:1',
      },
      recurring: {
        label: 'Schedule the next 1:1 (optional)',
      },
      notifyAll: 'Send updates by email',
      stopRecurringLabel: 'Stop the recurring',
      validationMessages: {
        errorMessage: commonFieldValidationMessages.en.isEmpty,
        isPast: 'Chosen date is in the past',
      },
    },
    deactivateUsers: {
      title: 'Deactivate these users from Kadar',
      description:
        'Are you sure you want to deactivate these users from the application?',
      success: 'Slack users successfully synced.',
      save: 'Deactivate',
      cancel: commonLabels.cancel,
    },
    manageSurveyGroup: {
      title: {
        create: 'Create group',
        edit: 'Edit group',
      },
      description:
        'The group is there to allow for easier organization and sequencing of surveys through sets.',
      name: {
        label: 'Title',
        placeholder: 'Add group title ',
      },
      save: commonLabels.save,
      cancel: commonLabels.cancel,
      success: {
        create: 'Group successfully added.',
        edit: 'Group title successfully changed.',
      },
      errorMessages: {
        required: commonFieldValidationMessages.en.isEmpty,
        forbiddenCharacters:
          commonFieldValidationMessages.en.forbiddenCharacters,
        maxLength: 'Exceeded max length of 500 characters',
        availableTitle: 'Title is already taken',
      },
    },
    manageGroupItems: {
      title: {
        add: 'Add to group',
        edit: 'Change group',
      },
      description:
        'You can choose a group for this survey and thus create a set to help you better organize all the submitted surveys.',
      labels: {
        group: {
          label: 'Group',
          placeholder: 'Select group',
        },
      },
      save: commonLabels.save,
      cancel: commonLabels.cancel,
      success: {
        create: 'Group successfully added.',
        edit: 'Group successfully changed.',
      },
      validationMessages: {
        required: commonFieldValidationMessages.en.isEmpty,
      },
    },
    reactivateUser: {
      title: 'Reactivate',
      description: 'Select new manager and reactivate user.',
      label: 'Report to',
      placeholder: 'Please select new manager',
      noOptions: commonLabels.noOptions,
      create: commonLabels.save,
      cancel: commonLabels.cancel,
      reactivateSuccess: 'User has been successfully reactivated.',
    },
    peopleNoteTypes: {
      title: 'Choose type',
      cancel: commonLabels.cancel,
      continue: commonLabels.continue,
      public: {
        name: 'Public',
        description:
          'Visible to everyone with access to this profile (except the user it concerns). A space for managers and team leads to collaborate and share ideas. Use it to share insights, plans and wider context.',
      },
      private: {
        name: 'Private',
        description:
          'Visible only to you. Keep track of your personal insights, thoughts and observations. Don’t let anything slip!',
      },
    },
    absenceRequest: {
      title: 'Leave request(s):',
      cancel: commonLabels.close,
      table: {
        date: 'Date',
        requestDate: 'Request date',
        description: commonLabels.description,
        used: 'Used',
        absence: commonLabels.type,
        period: 'From-To',
        actions: commonLabels.actions,
        status: commonLabels.status,
        day: commonLabels.day,
        days: commonLabels.days,
        loadMore: commonLabels.loadMore,
        actionButtons: {
          edit: 'Edit request',
          delete: 'Delete request',
        },
        holiday: commonLabels.holiday,
      },
      requestStatuses: { ...statuses.en },
      menuItems: {
        approve: commonLabels.approve,
        reject: commonLabels.reject,
      },
      approveRequestDialog: { ...alertDialogs.en.absenceRequestApprove },
      rejectRequestDialog: { ...alertDialogs.en.absenceRequestReject },
    },
    defaultAbsenceSet: {
      title: 'Absence set created',
      contentMessage:
        "We've automatically created a default absence set based on your location.",
      contentDescription:
        'Click <strong>Preview</strong> to review or update it.',
      confirmButton: commonLabels.preview,
      closeButton: commonLabels.close,
    },
  },
};

const peoplePageContainer = {
  en: {
    personNavItems: {
      absences: commonLabels.absences,
      reviewCycles: 'Review cycles',
      overview: 'Overview',
      career: 'Career',
      insights: 'Insights',
      roles: 'Roles',
      actionPlans: 'Action plans',
      learning: 'Learning',
      notes: 'Notes',
      generalInfo: 'Info',
      oneOnOne: '1:1',
      documents: 'Documents',
    },
    you: 'You',
    yourDirectReport: 'Your direct report',
    inYourBranch: 'Your indirect report',
    avatarUpload: {
      change: 'Change',
      photoSizeMessage: "Photo should be up to 5 mb's",
      choosePhoto: 'Choose format jpeg, png or jpg',
    },
    slackTooltip: 'User account is associated with slack account',
  },
};

const readLessMoreLabels = {
  read: 'Read',
  less: 'less',
  more: 'more',
};

const surveyResults = {
  en: {
    question: 'Questions',
    answers: 'Answers',
    answerShorthand: 'A',
    questionShorthand: 'Q',
    questionScore: commonLabels.score,
    viewComments: commonLabels.viewComments,
    anonymousUser: { ...anonymousUser.en },
    completed: 'Completed',
    scoreLabel: commonLabels.score,
    commentsLabel: commonLabels.comments,
    allLabel: commonLabels.all,
    reviewHasComments: 'This review has comments.',
    attributeScore: {
      anonymous: 'This is an average score.',
      default: 'Click to view individual user scores.',
    },
    textReplyNoAverageScore:
      "Open-ended attributes don't have an average score.",
    feedback: {
      title: 'Feedback',
      noResults: 'There is no feedback for this review',
      anonymousUser: { ...anonymousUser.en },
    },
    ...neutralAnswer.en,
    usersFilter: {
      search: commonLabels.search,
      score: commonLabels.score,
      people: commonLabels.people,
      answers: commonLabels.answers,
      titleMatrix: 'Select employees to view their results on the matrix.',
      titleChart: 'Select employees to view their results on the graph.',
      clearAllButtonLabel: 'Clear all',
      disabledUserMessageLimitReached: 'Maximum 6 users can be selected',
      disabledUserMessageUnfinishedInProgress:
        "This user hasn't completed the review yet.",
      disabledUserMessageUnfinishedTeamInProgress:
        "The review hasn't been completed for this user yet.",
      disabledUserMessageUnfinishedDone:
        "This user hasn't completed the review.",
      disabledUserMessageUnfinishedTeamDone:
        "The review hasn't been completed for this user.",
    },
    noChartResultsGroupDone: 'This review has no submitted results.',
    chartResultsGroupDone: 'Select users to display their results here.',
    chartResultsGroupInProgress: 'Select users to display their results here.',
    noChartResultsGroupInProgress: 'This review has no submitted results yet.',
    noChartResultsSingleInProgress:
      'Results will be displayed once the review is completed.',
    noChartResultsSingleDone: 'This review has no submitted results.',
    detractorsLabel: commonLabels.detractors,
    detractorsScore: 'Score 1-6',
    neutralScore: 'Score 7-8',
    promotersScore: 'Score 9-10',
    neutralLabel: commonLabels.neutral,
    promotersLabel: commonLabels.promoters,
    people: commonLabels.people,
    percentage: commonLabels.percentage,
    responses: 'Responses',
    hunderedPercent: '100%',
    zeroPercent: '0',
    fiftyPercent: '50%',
    score: commonLabels.score,
  },
};

const userStatuses = {
  en: {
    actions: {
      invite: commonLabels.invite,
      reinvite: commonLabels.reinvite,
      revokeAccess: commonLabels.revokeAccess,
      reactivate: commonLabels.reactivate,
      deactivate: commonLabels.deactivate,
      delete: commonLabels.delete,
    },
    statuses: { ...statuses.en },
  },
};

const actionPlan = {
  en: {
    title: commonLabels.title,
    improve: 'Improve',
    dueDate: commonLabels.dueDate,
    created: commonLabels.createdBy,
    status: commonLabels.status,
    description: commonLabels.description,
    createdFor: 'For',
    createdOn: 'Created on',
    proposedOn: commonLabels.proposedOn,
    createdBy: commonLabels.createdBy,
    createdByMe: commonLabels.createdByMe,
    tags: commonLabels.tags,
    tasks: commonLabels.tasks,
    preview: commonLabels.preview,
    statuses: { ...statuses.en },
    courses: commonLabels.courses,
    tasksIconTooltip: 'This Action plan has tasks',
    coursesIconTooltip: 'This Action plan has course',
    completeness: commonLabels.completeness,
    proposed: commonLabels.proposed,
    usersListTooltip: 'Who can see this action plan',
    usersListTitle: 'Users who see this action plan',
    proposeAccept:
      'Would you like to accept this employee proposed Action plan?',
    requested: { ...proposedPlanTooltip.en },
    menuItemLabels: {
      accept: commonLabels.accept,
      edit: commonLabels.edit,
      delete: commonLabels.delete,
      dismiss: commonLabels.dismiss,
      manageTasks: commonLabels.manageTasks,
    },
    actionButtons: { ...iconButtonsTooltip.en },
  },
};

const attributeTypes = {
  en: {
    skill: 'Skill',
    engagement: 'Engagement',
    performance: 'Performance',
    oneTime: 'One-Time',
    enps: '(e)NPS',
  },
};

const statsOverviewLabels = {
  en: {
    to_do: 'To do',
    in_progress: 'In progress',
    done: 'Done',
    past: 'Past',
    pending: 'Pending',
    upcoming: 'Upcoming',
  },
};

const surveyTypes = {
  self: {
    name: 'Self Assessment',
    description: 'Send this Survey to an employee to review him or herself.',
    explanation:
      'Self assessment survey helps people evaluate their own knowledge, skills, attitudes, and behaviors on a particular topic.',
  },
  team: {
    name: 'Team Review',
    description:
      'Send this Survey to an employee to review his or her team member.',
    explanation:
      'Team review helps one person evaluate a team at the same time, providing objectivity',
  },
  peer: {
    name: 'Peer Review',
    description:
      'Send this Survey to a group of employees to review another employee.',
    explanation:
      "Peer review helps individuals with similar roles and responsibilities assess and provide feedback on each other's work.",
  },
  pulse: {
    name: 'Company Pulse',
    description:
      'Send this Survey to one or more employees to get feedback on general Company' +
      ' Pulse. ',
    explanation:
      'A company pulse survey is a brief, periodic questionnaire' +
      ' used to measure employee engagement and provide insight into the overall health of the organization.',
  },
  direct: {
    name: 'Direct Review',
    description:
      'Send this Survey to get feedback from employee A about employee B.',
    explanation:
      "Direct review helps one person evaluate other's person knowledge," +
      ' skills, and behaviour based on their direct observation of their work.',
  },
  nps_enps: {
    name: 'NPS & eNPS',
    description:
      "Use eNPS if you're targeting employees, or NPS if you're collecting insights from external clients.",
    explanation:
      'NPS & eNPS review is a scoring system that measures employee satisfaction.' +
      ' It is based on the Net Promoter Score system, which gauges customer loyalty.',
  },
  nps: {
    name: 'NPS',
    description: "Use NPS if you're collecting insights from external clients.",
    explanation:
      'NPS & eNPS review is a scoring system that measures employee satisfaction.' +
      ' It is based on the Net Promoter Score system, which gauges customer loyalty.',
  },
  enps: {
    name: 'eNPS',
    description: "Use eNPS if you're collecting insights from employees.",
    explanation:
      'NPS & eNPS review is a scoring system that measures employee satisfaction.' +
      ' It is based on the Net Promoter Score system, which gauges customer loyalty.',
  },
};

const cycleReviewTypes = {
  en: {
    selfReview: {
      name: 'Self review',
      explanation:
        'Self review helps people evaluate their own knowledge, skills, attitudes, and behaviors on a particular topic.',
    },
    topDownReview: {
      name: 'Top > Down review',
      explanation:
        'Top > Down review enables the manager to conduct a holistic and objective evaluation of their direct reports, assessing individual strengths, identifying growth opportunities, and aligning performance with broader organizational objectives.',
    },
    downUpReview: {
      name: 'Down > Up review',
      explanation:
        "Down > Up review enables team members to provide constructive, honest feedback on their manager's leadership effectiveness, management style, and ability to provide direction and support.",
    },
  },
};

const surveyReviewersActions = {
  en: {
    sendReminder: 'Send reminder',
    sendReminderAll: 'Send reminder to all',
    reopen: 'Reopen',
    reopenAll: 'Reopen for all',
    closeSurvey: 'Close',
  },
};

const coursesLevels = {
  en: {
    all: 'All',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    expert: 'Expert',
  },
};

const statusesFilters = {
  en: {
    commonStatuses: {
      active: 'In Progress',
      draft: 'Draft',
      inProgress: 'In Progress',
      completed: 'Completed',
      scheduled: 'Scheduled',
    },
    invitationStatuses: {
      invited: 'Invited',
      notInvited: 'Not Invited',
      joined: 'Joined',
    },
    employeeStatusFilter: {
      active: 'Active',
      inactive: 'Inactive',
    },
    reportToFilter: {
      direct: 'My Direct Reports',
      subUsers: 'All Reports',
      companyView: 'Company View',
    },
  },
};

const actionPlansFilters = {
  en: {
    allUsers: 'None',
    withoutActionPlan: 'Without',
  },
};

const iconAlt = {
  checkIcon: 'Check',
};

const noReports = {
  title: 'No reports available',
  message: 'You can see reports once a survey has been completed.',
  helpText: 'Please click on the button below to send your first survey.',
  buttonText: commonLabels.start,
};

const surveysActionBar = {
  thisWord: 'This',
  needYourFeedback: 'survey needs your feedback.',
  pleaseFill: 'Please fill out this survey to help us assess your coworker(s).',
  pleaseFillEnps: 'Please fill out this survey.',
  sentToYou: 'Sent to you',
  youHave: 'You have',
  pendingSurveys: 'more pending survey(s).',
  widgetName: 'Pending Surveys',
};

const courseActions = {
  en: {
    viewDetails: 'View Details',
    edit: 'Edit',
    deleteAction: 'Delete',
    disenroll: 'Disenroll',
  },
};

const addAttributeDrawerForm = {
  en: {
    save: commonLabels.save,
    add: 'New attribute',
    editDetails: 'Edit details',
    cancel: 'Cancel',
    create: 'Create',
    edit: 'Edit',
    preview: 'Preview',
    saveAndAdd: 'Save and add questions',
    formLabels: {
      name: {
        label: 'Name',
        placeholder: 'Enter name',
      },
      code: {
        label: 'Short name',
        placeholder: 'Enter abbreviation',
      },
      type: {
        label: 'Purpose',
        placeholder: 'Skill',
        noOptions: 'No Options',
      },
      visibility: {
        label: 'Usage',
        labelText:
          'Please select if you want to make this attribute personal and if you would like to restrict the usage of this attribute only to you.',
        labelHelp:
          "Company-wide attributes can be used by all moderators and admins. Personal attributes can be used only by you, and can't be connected to the job titles.",
      },

      status: {
        label: 'Status',
        labelText: 'Please select if you would like inactive status',
        labelHelp:
          'Inactive attributes cannot be assessed by Surveys and are not' +
          " shown in any reports or elsewhere in application. Inactivate attributes that you don't want to see, but don't want to delete.",
      },
      tags: {
        label: 'Tags',
        placeholder: '#Tag',
        creatableOptionLabel: 'Add tag',
      },
      description: {
        label: 'Attribute Description',
        placeholder: 'Enter description for your Attribute',
        labelTooltip: {
          text: 'Will not be visible to person filling a Survey that includes this Attribute.',
        },
      },
      visibleDescriptionSwitch: {
        label: 'External Description',
        tooltipInfo:
          'Will be visible to person filling a Survey that includes this Attribute.',
      },
      visibleDescription: {
        placeholder: 'Enter external description for your Attribute',
      },
      createdBy: { label: commonLabels.createdBy },
      color: {
        label: 'Color',
        tooltip:
          'Add color to the attribute for better organization and overview. Colors assigned to attributes will be visible in different graphs.',
      },
      questionStyle: { label: 'Question style' },
      layout: {
        label: 'Answer type',
        vertical: 'Vertical answer type',
        horizontal: 'Horizontal answer type',
      },
      withNeutralAnswer: {
        fieldLabel: 'Add N/A answer',
        label:
          'Provide respondents an option to mark Not Applicable as an answer.',
      },
      withZeroValueAnswer: {
        fieldLabel: 'Set answer calulation from 0',
        label: 'Provide respondents answers starting with weight zero.',
        labelHelp:
          'Every answer has its own weight (which is displayed on the right side of the answer).' +
          'Weight is used for score calculation in surveys. Adding zero to the respondents answers influences ' +
          'the answers weight distribution. Max weight is 10 and it is always the weight of the last answer.',
      },
      withAdditionalFeedback: {
        fieldLabel: 'Add additional feedback',
        label:
          'Provide respondents an option to leave additional free form feedback after all questions.',
      },
      withTextReplyQuestions: {
        label: 'Answer style',
        off: 'Multiple choice questions',
        on: 'Open-ended questions',
      },
      answerCount: {
        label: 'Number of answers',
        labelHelp: {
          tooltipText:
            'Pick the number of answers for the question. Each question contains option of an equal number of answers (2-15).',
        },
      },
      questions: { label: 'Questions' },
    },
    validationMessages: {
      availableName: commonFieldValidationMessages.en.availableName,
      required: commonFieldValidationMessages.en.isEmpty,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      maxLength: 'Exceeded max length of 255 characters.',
      maxNameLength: 'Exceeded max length of 100 characters.',
      descriptionMaxLength: 'Exceeded maximum allowed field length.',
      minLength: validationMessages.en.name.minLength,
      itemName: commonFieldValidationMessages.en.itemName,
      availableShortName: 'Short name is already taken.',
      exactLength: 'Short name should be 1 to 5 characters long.',
      attributeUsage: 'Attribute is assigned to level(s).',
    },
  },
};

const addUsers = {
  en: {
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    addUserButton: 'Add new user',
    title: {
      manual: 'Add users manually',
      import: 'Setup imported users from CSV',
      associate: 'Add external associates',
    },
    description: {
      manual:
        'Add users by entering required data. By default, new users are not invited to join. If you want to invite them right away, click on the checkbox.',
      import:
        'Users from your .csv file are listed here. Go through the list, and adjust additional info considering reporting to, role, and the invitation to join.',
      associate:
        "Add users that won't have the profile, but you'll be able to send them a survey to gather data about other users.",
    },

    formLabels: {
      firstName: {
        label: 'First name',
        placeholder: 'First name',
      },
      lastName: {
        label: 'Last name',
        placeholder: 'Last name',
      },
      email: {
        label: commonLabels.email,
        placeholder: commonLabels.email,
      },
      role: {
        label: 'Role',
        placeholder: 'Role',
      },
      reportingTo: {
        label: 'Reporting to',
        placeholder: 'Reporting to',
        noOptions: 'No options',
      },
      invited: {
        label: 'Invited',
      },
      invite: {
        label: 'Invite',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      invalidEmail: 'Email is invalid',
      exceededLengthEmail: 'Maximum length is 100 characters',
      availableEmail: validationMessages.en.email.isAvailable,
      duplicatedEmail: validationMessages.en.email.isUnique,
      minLength: validationMessages.en.firstName.minLength,
      maxLength: validationMessages.en.firstName.maxLength,
      invalidName: validationMessages.en.firstName.invalid,
      freemiumLimit: commonFieldValidationMessages.en.freemium,
    },
    success: {
      add: 'Users added!',
      update: 'Users updated!',
    },
  },
};

const manageActionPlan = {
  en: {
    add: 'New action plan',
    edit: 'Edit action plan',
    proposalTitle: 'Propose new plan',
    proposalTitleEdit: 'Edit plan proposal',
    acceptProposalTitle: 'Accept plan proposal',
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    ok: commonLabels.ok,
    choose: commonLabels.choose,
    seeMore: 'See more...',
    successAdd: 'New Action plan has been added!',
    successProposal: 'New Action plan proposal has been added!',
    successEdit: 'Action plan has been updated!',
    successEditProposal: 'Action plan proposal has been updated!',
    successAcceptProposal: 'Action plan proposal has been accepted!',
    me: commonLabels.me,
    noOptions: commonLabels.noOptions,
    searching: commonLabels.searching,
    custom: 'Custom',
    formLabels: {
      title: {
        label: commonLabels.title,
        placeholder: 'Enter title',
      },
      user: {
        label: 'This Action plan is for',
        placeholder: "Start typing employee's name",
        noOptions: commonLabels.noOptions,
      },
      courses: {
        addButton: 'Enroll',
        label: 'Courses',
        enrollCourseDialog: { ...customDialogs.en.enrollCourse },
        levels: { ...coursesLevels.en },
      },
      tags: {
        label: 'Tags',
        placeholder: '#Tag',
        creatableOptionLabel: 'Add tag',
      },
      tasks: {
        label: commonLabels.tasks,
        addTaskButton: 'Add new task',
        headers: {
          assignTo: 'Assign to',
          description: 'Description',
        },
        task: {
          labels: {
            description: {
              placeholder: 'Add task description',
            },
            assignTo: {
              placeholder: 'Choose user to assign',
            },
          },
          validationMessages: {
            required: commonFieldValidationMessages.en.isEmpty,
            maxTaskTextLength: commonFieldValidationMessages.en.maxLength,
            forbiddenCharacters:
              commonFieldValidationMessages.en.forbiddenCharacters,
          },
          dragTooltip: 'You can drag tasks to rearrange them.',
        },
      },
      description: {
        label: 'Description',
      },
      dueDate: {
        label: 'Due date',
        placeholder: 'Action plan due date',
      },
      status: {
        label: 'Status',
        placeholder: 'Action plan status',
      },
      notify: {
        label: 'Send email notification to',
      },
      creator: {
        label: 'Person who created action plan',
      },
      createdOn: {
        label: 'Date of action plan creation.',
      },
      completeness: {
        label: commonLabels.completeness,
      },
      manager: {
        label: 'Person who created action plan',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      descriptionMaxLength: 'Exceeded maximum allowed field length.',
      titleMaxLength: 'Exceeded max length of 200 characters',
    },
    actionButtons: {
      edit: commonLabels.edit,
    },
  },
};

const manageHiringTeam = {
  en: {
    add: 'Hiring team',
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    formLabels: {
      subtitle: {
        label: 'Choose employees to be in hiring team',
      },
      hiringTeam: {
        ...peoplePicker.en,
        label: 'Select employee(s)',
        placeholder: commonLabels.employeesName,
      },
    },
  },
};

const manageAddExistingCandidates = {
  en: {
    add: 'Add candidates',
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    formLabels: {
      subtitle: {
        label: 'Choose candidates for this job',
      },
      candidates: {
        allEmployees: 'All candidates',
        selectButtonLabel: 'Select',
        noUserResults: 'No candidates to select',
        label: 'Select candidate(s)',
        placeholder: commonLabels.candidatesName,
      },
    },
  },
};

const manageSteps = {
  en: {
    add: 'Recruiting pipelines',
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    formLabels: {
      step: {
        addFieldButton: 'Add custom step',
        draggableTooltip: 'You can drag items to rearrange them.',
        hasData:
          'This step contains reviews, emails, or comments for one or more candidates. Delete is disabled.',
        defaultStepMessage: 'This step is default. Delete is disabled.',
        defaultStepSelectMessage:
          'There should be at least one step with this type.',
        hasCandidatesMessage: 'This step has candidates. Delete is disabled.',
        headers: {
          chooseType: 'Type',
          title: 'Custom name',
        },
        type: {
          placeholder: 'Choose type',
        },
        title: {
          placeholder: 'Add custom step',
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          requiredStep: 'Required.',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          maxLength: 'Exceeded max length of 25 characters.',
        },
      },
    },
  },
};

const sendEmail = {
  en: {
    add: 'Send email',
    cancel: commonLabels.cancel,
    save: 'Send email',
    saveDraft: 'Save draft',
    formLabels: {
      subject: {
        label: commonLabels.subject,
        placeholder: 'Add subject',
      },
      body: {
        label: commonLabels.message,
        placeholder: 'Add message',
      },
      uploadFiles: {
        placeholder: 'Upload a file',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      messageMaxLength: 'Exceeded maximum allowed field length.',
      maxLength: 'Exceeded max length of 255 characters.',
    },
  },
};

const addComment = {
  en: {
    add: 'Add comment',
    edit: 'Edit comment',
    cancel: commonLabels.cancel,
    delete: commonLabels.delete,
    save: commonLabels.save,
    formLabels: {
      comment: {
        label: commonLabels.comment,
        placeholder: 'Add comment',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      messageMaxLength: 'Exceeded maximum allowed field length.',
    },
  },
};

const vote = {
  en: {
    add: 'Add evaluation',
    edit: 'Edit evaluation',
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    formLabels: {
      comment: {
        label: 'How would you rate this candidate?',
        placeholder: 'Write a comment',
      },
      vote: {
        label: 'Vote',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      maxLength: 'Exceeded maximum allowed field length.',
    },
  },
};

const manageAbsenceRequest = {
  en: {
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    add: 'Request leave',
    edit: 'Edit leave request',
    formLabels: {
      user: {
        label: 'For',
        placeholder: 'Select user',
      },
      absence: {
        label: 'Leave type',
        placeholder: 'Select leave type',
      },
      reason: {
        label: 'Reason',
        placeholder: 'Select reason',
      },
      absenceFrom: {
        label: 'From',
        placeholder: 'Select date',
      },
      absenceTo: {
        label: 'To',
        placeholder: 'Select date',
      },
      amount: {
        label: 'Amount',
      },
      description: {
        label: commonLabels.description,
        placeholder: 'Enter leave description',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      descriptionMaxLength: 'Exceeded max length of 255 characters',
      minDays: 'Min 1 day.',
    },
    successMessages: {
      add: 'Leave request has been added.',
      edit: 'Leave request has been updated.',
    },
  },
};

const pageHeader = {
  en: {
    jobTitlePlaceholder: commonLabels.noJobTitle,
    successMessages: {
      demoData: 'Demo data is successfully cleared.',
    },
    qrCodeDialog: { ...alertDialogs.en.qrCodeDialog },
    userMenu: {
      manageSubscription: 'Manage subscription',
      organizationSettings: 'Organization settings',
      slackIntegration: 'Slack integration',
      clearDemoData: 'Clear demo data',
      privacyPolicy: 'Privacy policy',
      releaseNotes: 'Release notes',
      termsOfService: 'Terms of service',
      helpCenter: 'Help center',
      enableAuthentication: 'Enable 2F Authentication',
      disableAuthentication: 'Disable 2F Authentication',
      resetAuthentication: 'Reset 2F Authentication',
      logOut: 'Log out',
    },
  },
};

const compareWidget = {
  notAvailable: 'N/A',
  employee: 'Name',
  average: 'Average',
  noJobTitle: commonLabels.noJobTitle,
  personalAttributeTooltip: personalAttribute.en.tooltipText,
};

const filters = {
  en: {
    filters: commonLabels.filters,
    search: commonLabels.search,
    apply: commonLabels.apply,
    clearAll: 'Clear all',
    selectedLabel: 'Selected',
    labels: {
      active: 'Active',
      attribute: 'Attribute',
      actionPlans: 'Action plans',
      creator: 'Creator',
      createdFor: 'Created for',
      division: 'Division',
      department: 'Department',
      reviewers: 'Reviewers',
      subject: 'Subject',
      level: 'Level',
      report: 'Reporting to',
      scope: 'Reporting to',
      status: 'Status',
      jobTitle: 'Job title',
      position: 'Job title',
      tags: 'Tags',
      track: 'Track',
      trackLevel: 'Track level',
      type: 'Type',
      timeOffType: 'Time-off type',
      surveyType: 'Survey type',
      role: 'Role',
      moderator: 'Organized by',
      impression: 'Impression',
      for: commonLabels.for,
      dueDate: commonLabels.dueDate,
      employee: commonLabels.employee,
      coverage: 'Coverage',
      family: 'Family',
      criticality: 'Criticality',
    },
  },
};

const multipartPeoplePicker = {
  en: {
    title: 'Add people',
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    filters: { ...filters.en },
    search: 'Search by name',
    allUsers: 'All users',
    clearAllUsers: 'Clear users',
    noSearchResults: commonLabels.noSearchResultsMessage,
  },
};

const manageOneOnOneMessages = {
  en: {
    general: {
      create: '1:1 record successfully created',
      edit: '1:1 record successfully edited',
      request: '1:1 employee request successfully created',
      reschedule: '1:1 record successfully rescheduled',
      employeeTopicAdded: 'Your meeting agenda topic has been added.',
      employeeTopicUpdated: 'Your meeting agenda topic has been updated.',
    },
  },
};

const levelingCurrencies = {
  en: {
    dollar: 'US Dollar $',
    euro: 'Euro €',
    pound: 'British Pound £',
    yen: 'Japanese Yen ¥',
    yuan: 'Chinese Yuan ¥',
    franc: 'Swiss Franc CHF',
    cad: 'Canadian Dollar $',
    aud: 'Australian Dollar $',
    nzd: 'New Zealand Dollar $',
    rsd: 'Serbian Dinar RSD',
    nok: 'Norwegian Krone kr',
    sek: 'Swedish Krona kr',
    dkk: 'Danish Krone kr',
    pln: 'Polish Zloty zł',
    czk: 'Czech Koruna Kč',
    huf: 'Hungarian Forint Ft',
    ron: 'Romanian Leu lei',
    bgn: 'Bulgarian Lev лв',
    inr: 'Indian Rupee ₹',
    krw: 'South Korean Won ₩',
    try: 'Turkish Lira ₺',
    thb: 'Thai Baht ฿',
    idr: 'Indonesian Rupiah Rp',
    php: 'Philippine Peso ₱',
    vnd: 'Vietnamese Dong ₫',
    aed: 'UAE Dirham AED',
    sar: 'Saudi Riyal SAR',
    ils: 'Israeli Shekel ₪',
    zar: 'South African Rand R',
    ngn: 'Nigerian Naira ₦',
    egp: 'Egyptian Pound E£',
    brl: 'Brazilian Real R$',
    mxn: 'Mexican Peso $',
    ars: 'Argentine Peso $',
    clp: 'Chilean Peso $',
    cop: 'Colombian Peso $',
  },
};

const frameworkForm = {
  en: {
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    formLabels: {
      name: {
        label: 'Name',
        placeholder: 'Enter name',
      },
      description: {
        label: 'Description',
        placeholder: 'Write description',
      },
      attributes: {
        label: {
          label: 'Add Attributes',
          attributesLabel: 'Attributes',
          rangeFromLabel: 'Range from',
          rangeToLabel: 'Range to',
        },
        placeholder: 'Add attributes',
      },
      people: {
        label: 'People',
        placeholder: `Employee's name`,
      },
      framework: {
        label: 'Select framework',
        placeholder: '',
      },
      track: {
        label: 'Select track',
        placeholder: '',
      },
      assignUsers: {
        label: 'Assign',
        placeholder: 'Assign users to this level',
      },
      salaryInfo: {
        label: 'Salary settings',
        description: 'Enable to set currency and salary type (fixed or range).',
      },
      currency: {
        label: 'Currency',
      },
      salarySubtitle: {
        label: 'Salary range',
      },
      salaryRange: {
        minSalary: {
          label: 'Salary from',
        },
        maxSalary: {
          label: 'Salary to',
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          invalidMinSalary: 'Must be below max salary.',
          invalidMaxSalary: 'Must exceed min salary.',
          negativeSalary: 'Must be a positive number.',
          exceeded: 'The number is too large.',
        },
      },
    },
    validationMessages: {
      titleMaxLength: 'Exceeded max length of 255 characters',
      levelMaxLength: 'Exceeded max length of 5000 characters',
      required: commonFieldValidationMessages.en.isEmpty,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      uniqueFrameworkName: 'This framework name already exists.',
      requiredRange: 'Range is required.',
      attributeRange: 'Range is not valid.',
    },
  },
};

const divisionForm = {
  en: {
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    formLabels: {
      name: {
        label: 'Name',
        placeholder: 'Enter name',
      },
      description: {
        label: 'Description',
        placeholder: 'Write description',
      },
      people: {
        label: 'People',
        placeholder: `Employee's name`,
      },
      division: {
        label: 'Select division',
        placeholder: '',
      },
      assignUsers: {
        label: 'Assign',
        placeholder: 'Assign users to this department',
      },
    },
    validationMessages: {
      titleMaxLength: 'Exceeded max length of 255 characters',
      required: commonFieldValidationMessages.en.isEmpty,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      uniqueDivisionName: 'This division name already exists.',
      uniqueDepartmentName: 'This department name already exists.',
      departmentMaxLength: 'Exceeded maximum allowed field length.',
    },
  },
};

const calendar = {
  en: {
    name: '1:1 meeting with',
    greetingMessage: 'Hi',
    description: 'This is agenda for our 1:1 meeting:',
    addToCalendar: 'Add to calendar',
  },
};

const surveyinfoDescription = {
  en: {
    takeALook: 'Take a look at how',
    usersAbove: 'user(s) above',
    evaluated: 'evaluated',
    selfAssessment: 'Take a look how above user(s) evaluated themselves.',
    companyPulse:
      'Take a look at overall employee engagement, satisfaction,' +
      ' and morale.',
    basedOn: 'This report is based on',
  },
};

const manageTasks = {
  en: {
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    title: commonLabels.manageTasks,
    formLabels: {
      tasks: {
        label: commonLabels.tasks,
        addTaskButton: 'Add new task',
        headers: {
          assignTo: 'Assign to',
          description: 'Description',
        },
        task: {
          labels: {
            description: {
              placeholder: 'Add task description',
            },
            assignTo: {
              placeholder: 'Choose user to assign',
            },
          },
          validationMessages: {
            required: commonFieldValidationMessages.en.isEmpty,
            maxTaskTextLength: commonFieldValidationMessages.en.maxLength,
            forbiddenCharacters:
              commonFieldValidationMessages.en.forbiddenCharacters,
          },
          dragTooltip: 'You can drag tasks to rearrange them.',
        },
      },
    },
    successMessage: 'Tasks have been successfully saved.',
  },
};

const oneOnOneRecords = {
  en: {
    generalImpression: 'Impression',
    note: 'Private note',
    viewPrivateNote: 'Click to view your private note',
    noPrivateNote: 'No private note',
    createdBy: 'Organized by',
    upcoming: 'Upcoming',
    agenda: 'Agenda',
    yes: commonLabels.yes,
    managerAgenda: 'Manager meeting agenda',
    employeeAgenda: 'Employee meeting agenda',
    addYourAgenda: 'Add your topic',
    editYourAgenda: 'Edit your topic',
    edit: commonLabels.edit,
    delete: commonLabels.delete,
    manageTasks: commonLabels.manageTasks,
    createdByMe: 'Organized by me',
    negative: 'Negative',
    neutral: 'Neutral',
    positive: 'Positive',
    requested: { ...requestedOneOnOneTooltip.en },
    description: 'Description',
    calendar: { ...calendar.en },
    impressionTooltip: 'Not visible for [FULL NAME]',
    tags: commonLabels.tags,
    statuses: { ...statuses.en },
    actionButtons: { ...iconButtonsTooltip.en },
    tasksIconTooltip: 'This 1:1 has tasks',
    plansIconTooltip: 'This 1:1 has associated action plans',
    recurring: commonLabels.recurring,
    usersListTooltip: 'Who can see this 1:1',
    usersListTitle: 'Users who see this 1:1',
    notifications: { ...teamNotifications.en },
  },
};

const oneOnOneRecordDialog = {
  en: {
    save: commonLabels.save,
    title: {
      add: 'New 1:1 meeting',
      edit: 'Edit details',
      request: 'Add requested 1:1',
      reschedule: 'Reschedule 1:1 meeting',
    },
    formLabels: {
      with: {
        label: 'With',
        placeholder: "Start typing employee's name",
        noOptions: commonLabels.noOptions,
      },
      meetingStatus: {
        labels: { ...statuses.en },
      },
      meetingAgenda: {
        label: 'Meeting agenda',
        placeholder: 'Your custom topic',
      },
      recurring: {
        label: 'Schedule the next 1:1 (optional)',
        placeholder: 'Does not repeat',
      },
      meetingDate: {
        label: 'Date',
      },
      meetingTime: {
        label: 'Time',
      },
      tags: {
        label: 'Tags',
        placeholder: '#Tag',
        creatableOptionLabel: 'Add tag',
      },
      plans: {
        label: 'Associated Action plans',
        placeholder: 'Select Action plans',
      },
      note: {
        label: 'Private note',
        placeholder: 'Add your private note',
        tooltipText: 'This will be visible exclusively to you.',
      },
      meetingImpression: {
        label: 'Impression',
        positive: 'Positive',
        negative: 'Negative',
        info: 'Add impression after 1:1',
      },
      notify: {
        labelText: 'Send updates by email',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      noteMinMaxLength: 'Exceeded maximum allowed field length.',
      customTopicRequired: commonFieldValidationMessages.en.isEmpty,
      minTopicsLength: 'Minimum 1 topic is required',
      maxTopicsLength: 'Maximum 5 topics are allowed',
      customTopicMinMaxLength:
        'Minimum field length is 2 characters and maximum 50.',
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
    },
  },
};

const surveySummaryForm = {
  en: {
    add: 'Create summary',
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    formLabels: {
      title: {
        label: 'Title',
      },
      description: {
        label: 'Summary',
      },
      reviewsSubtitle: {
        label: 'Reviews',
      },
      reviews: {
        completed: 'Completed',
        scoreLabel: commonLabels.score,
        commentsLabel: commonLabels.comments,
        allLabel: commonLabels.all,
        attributeScore: {
          anonymous: 'This is an average score.',
          default: 'Click to view individual user scores.',
        },
        textReplyNoAverageScore:
          "Open-ended attributes don't have an average score.",
        usersFilter: {
          search: commonLabels.search,
          score: commonLabels.score,
          people: commonLabels.people,
          answers: commonLabels.answers,
          titleReviewed: 'Select reviewed user(s)',
          titleReviewers: 'Select reviewer(s)',
          clearAllButtonLabel: 'Clear all',
          addAllButtonLabel: 'Select all',
          disabledUserMessageLimitReached: 'Maximum 6 users can be selected',
          disabledUserMessageUnfinished: "User didn't complete review yet",
          disabledUserMessageUnfinishedTeam:
            "Review isn't completed yet for this user",
        },
      },
      isAnonymous: {
        labelText: 'Anonymize reviewers',
        endLabelIconHelp: 'If checked, all reviewers will be anonymized',
      },
      shareWith: {
        label: 'Share with',
        placeholder: 'Select user(s) to share with',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      titleMaxLength: 'Exceeded max length of 150 characters.',
      summaryMaxLength: 'Exceeded maximum allowed field length.',
      reviews: 'Select at least one user.',
    },
    successMessage: 'Survey summary has been successfully created.',
  },
};

const surveySummaryShare = {
  en: {
    add: 'Share summary report',
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    formLabels: {
      shareWith: {
        label: 'Share with',
        placeholder: 'Select user(s) to share with',
      },
    },
    validationMessages: {},
    successMessage: 'Successfully updated shared with.',
  },
};

const surveySummaryAutoShare = {
  en: {
    add: 'Auto-share Summary',
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    formLabels: {
      shareWith: {
        label: 'Auto-share with',
        placeholder: 'Select user(s) to auto-share with',
      },
    },
    validationMessages: {},
    successMessage: 'Successfully updated auto-share.',
  },
};

const surveyAutoReminder = {
  en: {
    add: 'Auto reminder',
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    formLabels: {
      auto_reminders: {
        label: 'Send automatic reminders',
        labelHelp: {
          tooltipText:
            'Reminders are sent to reviewers who have not completed the survey. Options that fall before the survey start date are disabled.',
        },
        options: {
          halfway: 'Halfway through',
          day_before_end: '1 day before end',
          days_before_3: '3 days before end',
          days_before_7: '7 days before end',
        },
      },
    },
    validationMessages: {},
    successMessage: 'Successfully updated auto reminders.',
  },
};

const manageTopic = {
  en: {
    save: commonLabels.save,
    request: commonLabels.request,
    employeeTopicTitle: 'Your 1:1 meeting agenda',
    requestTitle: 'Request 1:1 meeting',
    formLabels: {
      name: {
        label: 'Meeting agenda',
        placeholder: 'Add custom topic',
      },
      moderator: {
        label: 'Meeting person',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      topicMaxLength: 'Minimum topic length is 2 and maximum 50 characters',
    },
  },
};

const noteDialog = {
  en: {
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    title: {
      add: 'New public note',
      edit: 'Edit public note',
      addPrivateNote: 'New private note',
      editPrivateNote: 'Edit private note',
    },
    formLabels: {
      note: {
        label: 'Public note',
        placeholder: 'Write your public note here',
      },
      notePrivate: {
        label: 'Private note (Visible only to you)',
        placeholder: 'Write your private note here',
      },
      tags: {
        label: commonLabels.tags,
        placeholder: '#Tag',
        creatableOptionLabel: 'Add tag',
      },
      tasks: {
        label: commonLabels.tasks,
        addTaskButton: 'Add new task',
        headers: {
          assignTo: 'Assign to',
          description: 'Description',
        },
        task: {
          labels: {
            description: {
              placeholder: 'Add task description',
            },
            assignTo: {
              placeholder: 'Choose user to assign',
            },
          },
          validationMessages: {
            required: commonFieldValidationMessages.en.isEmpty,
            maxTaskTextLength: commonFieldValidationMessages.en.maxLength,
            forbiddenCharacters:
              commonFieldValidationMessages.en.forbiddenCharacters,
          },
          dragTooltip: 'You can drag tasks to rearrange them.',
        },
      },
    },
    successMessages: {
      add: 'New Note has been successfully added.',
      edit: 'Note has been successfully updated.',
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      noteMinMaxLength: 'Exceeded maximum allowed field length.',
    },
  },
};

const jobTitleAssigning = {
  en: {
    add: 'Assign job title',
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    labelForModerators: 'Assign to (Only your reports are shown)',
    formLabels: {
      assignTo: {
        label: 'Assign to',
        placeholder: 'Select user(s) for assigning the job title',
      },
    },
    validationMessages: {},
    successMessage: 'Successfully updated job title assigning.',
  },
};

const note = {
  en: {
    about: 'About',
    createdOn: 'Created on',
    createdBy: commonLabels.createdBy,
    basedOn: 'Based on',
    note: commonLabels.note,
    privateNote: commonLabels.privateNote,
    tags: commonLabels.tags,
    edit: commonLabels.edit,
    tasks: commonLabels.tasks,
    delete: commonLabels.delete,
    privateNoteTooltip: 'Visible only to you.',
    basedOnOneOnOne: '1:1 meeting',
    createdByMe: commonLabels.createdByMe,
    tasksList: {
      taskStatusDialog: { ...alertDialogs.en.taskStatusChange },
    },
    usersListTooltip: 'Who can see this note',
    usersListTitle: 'Users who see this note',
    notifications: { ...teamNotifications.en },
  },
};

const usersComments = {
  en: {
    at: 'at',
    edited: 'Edited',
    addComment: {
      placeholder: 'Write a comment',
      errorMessages: {
        required: 'Comment is required',
        forbiddenCharacters:
          commonFieldValidationMessages.en.forbiddenCharacters,
        maxLength: 'Exceeded max length of 1000 characters',
      },
      save: commonLabels.save,
      success: 'Comment successfully sent.',
      update: 'Comment successfully updated.',
      notifyDialog: { ...customDialogs.en.oneOnOneCommentNotify },
    },
    removedUserTooltip: 'This user is no longer available.',
    deleteCommentDialog: { ...alertDialogs.en.oneOnOneCommentDelete },
  },
};

const usersNotes = {
  en: {
    at: 'at',
    edited: 'Edited',
    addComment: {
      placeholder: 'Write a note',
      errorMessages: {
        required: 'Note is required',
        forbiddenCharacters:
          commonFieldValidationMessages.en.forbiddenCharacters,
        maxLength: 'Exceeded maximum allowed field length.',
      },
      save: commonLabels.save,
      success: 'Note successfully sent.',
      update: 'Note successfully updated.',
      notifyDialog: { ...customDialogs.en.oneOnOneCommentNotify },
    },
    removedUserTooltip: 'This user is no longer available.',
    deleteCommentDialog: { ...alertDialogs.en.noteDelete },
  },
};

export const presets = {
  en: {
    remove: 'Delete preset',
    savePresetTitle: 'Save preset',
    label: 'Presets',
    placeholder: 'Preset name',
    inputPlaceholder: 'New preset name',
    noResults: commonLabels.noResults,
    startSearch: 'Search presets',
    addPresetLabel: 'Add preset',
    used: 'Selected filters have already been saved.',
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    limitErrorMessage: 'Exceeded max length of 100 characters.',
    emptyErrorMessage: 'Preset name should not be empty.',
    forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
    availableName: 'Preset name is already taken.',
    noSearchResults: commonLabels.noPresetResults,
    saveCurrentSelection: 'Save the current selection as a preset.',
    createNewPreset: 'Add filters to create a new preset.',
    nothingSelected: 'Nothing selected',
    selectedValuesDescription:
      'The following values are currently selected and will be saved with this preset.',
    presetConditionTooltip:
      'Delete one of presets to make a new one. Maximum number of presets is 10.',
    comparePresetConditionTooltip:
      'Choose user and select survey type / reviewers.',
    attributePresetConditionTooltip:
      'Choose attribute filter and reviewed users / reviewers.',
    oneOnOnePresetConditionTooltip: 'Choose employee(s) from people filter.',
    presetDeleteDialog: { ...alertDialogs.en.presetDelete },
    successMessages: {
      createdPreset: 'Preset is successfully created',
      deletedPreset: 'Preset is successfully deleted',
    },
  },
};

const reviewCommentsDrawer = {
  en: {
    comments: commonLabels.comments,
    question: commonLabels.question,
    answer: commonLabels.answer,
    allComments: commonLabels.allComments,
    questionComments: commonLabels.questionComments,
  },
};

const candidateInfoFields = {
  en: {
    email: 'Email',
    education: 'Education',
    date_of_birth: 'Date of birth',
    referral: 'Referral',
    phone: 'Phone',
    profession_title: 'Profession title',
    address: 'Address',
    city: 'City',
    cv: 'cv',
    country: 'Country',
    start_date: 'From',
    end_date: 'To',
    school: 'Educational institution',
    degree: 'Degree',
    job_title: 'Job title',
    company: 'Company',
    skills: 'Skills',
    experience: 'Experience',
    contact_details: 'Contact details',
  },
};

const addCandidatesManually = {
  en: {
    add: 'Add candidate',
    edit: 'Edit candidate',
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    formLabels: {
      firstName: {
        label: 'First name',
        placeholder: 'Add first name',
      },
      lastName: {
        label: 'Last name',
        placeholder: 'Add last name',
      },
      email: {
        label: 'Email',
        placeholder: 'Add email',
      },
      skills: {
        label: 'Skills',
        addFieldButton: 'Add skill',
        field: {
          labels: {
            skill: {
              placeholder: 'Add skill',
            },
          },
          validationMessages: {
            required: commonFieldValidationMessages.en.isEmpty,
            maxLength: 'Maximum length is 255 characters.',
            forbiddenCharacters:
              commonFieldValidationMessages.en.forbiddenCharacters,
          },
        },
      },
      education: {
        label: 'Education',
        addFieldButton: 'Add education',
        headers: {
          firstTextField: 'Educational institution',
          secondTextField: 'Degree',
          startYear: 'From',
          endYear: 'To',
        },
        field: {
          labels: {
            school: {
              placeholder: 'Add educational institution name',
            },
            degree: {
              placeholder: 'Add degree',
            },
            startYear: {
              placeholder: 'Year',
            },
            startMonth: {
              placeholder: 'Month',
            },
            endYear: {
              placeholder: 'Year',
            },
            endMonth: {
              placeholder: 'Month',
            },
          },
          validationMessages: {
            required: commonFieldValidationMessages.en.isEmpty,
            invalidStartDate: 'Date should be before end date',
            invalidEndDate: 'Date should be after start date',
            invalidMonth: 'Month is bigger than the current month.',
            maxLength: 'Maximum length is 255 characters.',
            forbiddenCharacters:
              commonFieldValidationMessages.en.forbiddenCharacters,
          },
        },
      },
      experience: {
        label: 'Work experience',
        addFieldButton: 'Add work experience',
        headers: {
          firstTextField: 'Company',
          secondTextField: 'Job title',
          startYear: 'From',
          endYear: 'To',
        },
        field: {
          labels: {
            company: {
              placeholder: 'Add company name',
            },
            jobTitle: {
              placeholder: 'Add job title',
            },
            startYear: {
              placeholder: 'Year',
            },
            startMonth: {
              placeholder: 'Month',
            },
            endYear: {
              placeholder: 'Year',
            },
            endMonth: {
              placeholder: 'Month',
            },
          },
          validationMessages: {
            required: commonFieldValidationMessages.en.isEmpty,
            invalidStartDate: 'Date should be before end date',
            invalidEndDate: 'Date should be after start date',
            invalidMonth: 'Month is bigger than the current month.',
            maxLength: 'Maximum length is 255 characters.',
            forbiddenCharacters:
              commonFieldValidationMessages.en.forbiddenCharacters,
          },
        },
      },
      referral: {
        label: 'Referral',
        placeholder: 'Add referral',
      },
      phone: {
        label: 'Phone number',
        placeholder: 'Add phone number',
      },
      cv: {
        placeholder: 'Upload CV',
      },
      parseCvData: {
        labelText: 'Rewrite fields with CV data',
      },
      professionTitle: {
        label: 'Profession title',
        placeholder: 'Add profession title',
      },
      dateOfBirth: {
        label: 'Date of birth',
        placeholder: 'Select date of birth',
      },
      address: {
        label: 'Address',
        placeholder: 'Add address',
      },
      city: {
        label: 'City',
        placeholder: 'Add city',
      },
      country: {
        label: 'Country',
        placeholder: 'Add country',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      invalidEmail: 'Email is invalid',
      exceededLengthEmail: 'Maximum length is 100 characters',
      availableEmail: validationMessages.en.email.isAvailable,
      minLength: validationMessages.en.firstName.minLength,
      maxLength: validationMessages.en.firstName.maxLength,
      invalidName: validationMessages.en.firstName.invalid,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      invalidPhone: 'Invalid phone number',
      fileType: 'File type should be pdf',
      fileLength: 'File should have maximum 100 characters.',
      inputMaxLength: 'Exceeded max length of 255 characters.',
    },
  },
};

const manageJobs = {
  en: {
    add: 'Add candidate to jobs',
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    formLabels: {
      subtitle: {
        label: 'Choose jobs for this candidate',
      },
      jobs: {
        allJobs: 'All jobs',
        selectButtonLabel: 'Select',
        noUserResults: 'No jobs to select',
        label: 'Select job(s)',
        placeholder: commonLabels.jobsName,
      },
    },
  },
};

const manageJobForm = {
  en: {
    add: 'New Job',
    edit: 'Edit Job',
    cancel: commonLabels.cancel,
    close: commonLabels.close,
    save: commonLabels.save,
    archive: commonLabels.archive,
    formLabels: {
      titleSubtitle: {
        label: 'Job title and department',
      },
      title: {
        label: commonLabels.title,
        placeholder: 'Add title',
      },
      department: {
        label: 'Department',
        placeholder: 'Select department',
      },
      dateRange: {
        label: 'Date open - Date end',
        placeholder: 'Select date range',
      },
      dateFrom: {
        label: 'Date open',
        placeholder: 'Select date open',
      },
      dateTo: {
        label: 'Date end',
        placeholder: 'Select date end',
      },
      workspaceSubtitle: {
        label: 'Workspace',
      },
      location: {
        label: 'Office location',
        placeholder: 'Add office location',
      },
      descriptionSubtitle: {
        label: 'Description',
      },
      description: {
        label: 'Description',
        placeholder: 'Add description',
      },
      requirements: {
        label: 'Requirements',
        placeholder: 'Add requirements',
      },
      benefits: {
        label: 'Benefits',
        placeholder: 'Add benefits',
      },
      tags: {
        label: 'Tags',
        placeholder: 'Select tags',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      inputMaxLength: 'Exceeded max length of 255 characters.',
      maxLength: 'Exceeded maximum allowed field length.',
    },
  },
};

const addCandidatesUsingCv = {
  en: {
    add: `Upload candidate's cv`,
    cancel: commonLabels.cancel,
    save: commonLabels.save,
    formLabels: {
      firstName: {
        label: 'First name',
        placeholder: 'Add first name',
      },
      lastName: {
        label: 'Last name',
        placeholder: 'Add last name',
      },
      cv: {
        placeholder: 'Upload CV',
      },
    },
    validationMessages: {
      fileType: 'File type should be pdf',
      fileLength: 'File should have maximum 100 characters.',
      required: commonFieldValidationMessages.en.isEmpty,
      invalidName: validationMessages.en.firstName.invalid,
      minLength: validationMessages.en.firstName.minLength,
      maxLength: validationMessages.en.firstName.maxLength,
    },
  },
};

const candidateViewButtons = {
  en: {
    addCommentLabel: 'Add comment',
    sendEmailLabel: 'Email to candidate',
    moveToJobLabel: 'Move to job',
    moveToStepLabel: 'Move to step',
    disqualify: commonLabels.disqualify,
    qualify: commonLabels.qualify,
  },
};

const peoplePageFormLabels = {
  en: {
    formLabels: {
      status: {
        label: 'Status',
      },
      basic: {
        label: 'Basic',
      },
      permissions: {
        label: 'Permissions',
      },
      personalDetails: {
        label: 'Personal details',
      },
      preferences: {
        label: 'Preferences',
      },
      identification: {
        label: 'Identification',
      },
      professionalBackground: {
        label: 'Professional background',
      },
      additionalInformation: {
        label: 'Additional information',
      },
      organization: {
        label: 'Organization',
      },
      employmentDetails: {
        label: 'Employment details',
      },
      compensation: {
        label: 'Compensation',
      },
      first_name: {
        label: 'First name',
        placeholder: 'Add first name',
      },
      last_name: {
        label: 'Last name',
        placeholder: 'Add last name',
      },
      email: {
        label: commonLabels.email,
        placeholder: 'Add email',
      },
      position: {
        label: 'Job title',
        placeholder: 'Add job title',
      },
      date_of_employment: {
        label: 'Employment date',
        placeholder: 'Add date of employment',
      },
      framework: {
        label: 'Framework',
        placeholder: 'Select framework',
      },
      track: {
        label: 'Track',
        placeholder: 'Select track',
      },
      level: {
        label: 'Level',
        placeholder: 'Select level',
      },
      division: {
        label: 'Division',
        placeholder: 'Select division',
      },
      department: {
        label: 'Department',
        placeholder: 'Select department',
      },
      report_to: {
        label: 'Reporting to',
        noOptions: 'No options',
      },
      personalInformation: {
        label: 'Personal Information',
      },
      employmentInformation: {
        label: 'Employment Information',
      },
      jobDetails: {
        label: 'Job details',
      },
      gender: {
        label: 'Gender',
        placeholder: 'Select gender',
      },
      language: {
        label: 'Language',
        placeholder: 'Select language',
      },
      timezone: {
        label: 'Time zone',
        placeholder: 'Select time zone',
      },
      place_of_birth: {
        label: 'Place of birth',
        placeholder: 'Add place of birth',
      },
      date_of_birth: {
        label: 'Date of birth',
        placeholder: 'Add date of birth',
      },
      residential_address: {
        label: 'Residential address',
        placeholder: 'Add residential address',
      },
      national_id_number: {
        label: 'National ID',
        placeholder: 'Add national ID',
      },
      social_accounts: {
        label: 'Social accounts',
        placeholder: 'Add description here',
      },
      internal_id_number: {
        label: 'Internal ID',
        placeholder: 'Add internal ID',
      },
      profession_title: {
        label: 'Educational qualification',
        placeholder: 'Add educational qualification',
      },
      job_title: {
        label: 'Job title',
        placeholder: 'Select job title',
      },
      years_of_work_experience: {
        label: 'Years of work experience',
        placeholder: 'e.g. 2y',
      },
      previous_work_experience: {
        label: 'Work experience',
        placeholder:
          'Describe previous roles, companies, or relevant experience',
      },
      private_health_insurance: {
        label: 'Private health insurance',
      },
      education: {
        label: 'Education',
        placeholder: 'Add education',
      },
      external_resource: {
        label: 'External resource',
        placeholder:
          'Add a link to any external profile, document, or resource related to the employee',
      },
      working_hours: {
        label: 'Working hours (month)',
        placeholder: 'e.g. 80h',
      },
      net_salary: {
        label: 'Net salary (year)',
        placeholder: 'e.g. 200000',
      },
      gross_salary_1: {
        label: 'Gross 1 (year)',
        placeholder: 'e.g. 200000',
      },
      gross_salary_2: {
        label: 'Gross 2 (year)',
        placeholder: 'e.g. 200000',
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      invalidEmail: 'Email is invalid',
      exceededLengthEmail: 'Maximum length is 100 characters',
      availableEmail: validationMessages.en.email.isAvailable,
      minLength: validationMessages.en.firstName.minLength,
      maxLength: validationMessages.en.firstName.maxLength,
      exceededLength: 'Exceeded max length of 100 characters.',
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
      descriptionMaxLength: 'Exceeded maximum allowed field length.',
      exceededNumberOfYears: 'The number of years is too high.',
      invalidWorkingHours:
        'The number of working hours must be greater than 0.',
      minValue: 'Must be a positive number.',
      invalidName: validationMessages.en.firstName.invalid,
      freemium: commonFieldValidationMessages.en.freemium,
      exceeded: 'The number is too large.',
    },
  },
};

const jobWorkspace = {
  en: {
    onSite: {
      label: 'On-site',
      description: 'Work exclusively from the office',
    },
    hybrid: {
      label: 'Hybrid',
      description: 'Work from both office and home',
    },
    remote: {
      label: 'Remote',
      description: 'Work exclusively from home',
    },
  },
};

const successionSettingsForm = {
  en: {
    save: commonLabels.save,
    cancel: commonLabels.cancel,
    formLabels: {
      label: {
        label: 'Label',
        placeholder: 'Label',
      },
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      isActive: {
        label: commonLabels.status,
        active: commonLabels.active,
        inactive: commonLabels.inactive,
      },
    },
    validationMessages: {
      required: commonFieldValidationMessages.en.isEmpty,
      maxLength: 'Exceeded max length of 128 characters.',
      forbiddenCharacters: commonFieldValidationMessages.en.forbiddenCharacters,
    },
  },
};

export const translations = {
  en: {
    App: {
      support: 'Support',
      sidebarNavigation: { ...sidebarNavigation.en },
    },
    SignUpPage: {
      formLabels: {
        email: {
          label: commonLabels.email,
          placeholder: 'Email address',
        },
        verification: {
          label: 'Verification code',
        },
        fullName: {
          placeholder: {
            firstName: 'First Name',
            lastName: 'Last Name',
          },
        },
        domainName: {
          placeholder: 'Workspace name',
        },
        password: {
          placeholder: 'Password',
        },
      },
      email: {
        email: commonLabels.email,
        emailPageTitle: 'Create your free account',
        emailPageSubtitle: 'No card needed.',
      },
      verification: {
        title: 'Check your email',
        label: 'Please enter the verification code we sent to:',
      },
      fullName: {
        title: 'What is your name',
      },
      domainName: {
        title: 'Hello, `ello',
        subtitle: "Let's choose your workspace URL",
        domainNameLabel: '.kadar.app',
      },
      password: {
        title: 'Create your password',
        validationLabels: [
          'At least 8 characters',
          'One lowercase character',
          'One uppercase character',
          'One number or symbol',
          'No whitespace',
        ],
      },
      jobTitle: {
        title: "Let's personalize experience for",
        label: 'My role is:',
      },
      incentive: {
        title: 'I want Kadar to help me:',
        label: 'Tick all that apply',
      },
      companySize: {
        title: 'My company size is:',
      },
      preference: {
        title: 'What do you prefer',
      },
      authContainer: { ...authContainer.en },
      somethingWentWrong: commonFieldValidationMessages.en.somethingWentWrong,
      readyInMoment: 'Your organization will be ready in a moment.',
      dontReloadMessage:
        "Please don't reload the page until organization initialization is done.",
      loadingText: 'Finalizing your organization setup...',
      backgroundPlaceholder: 'Background image',
      kadar: commonLabels.app,
      back: commonLabels.back,
      next: commonLabels.next,
      verifyEmail: commonLabels.verifyEmail,
      resend: commonLabels.resend,
      and: 'and',
      disclaimer:
        'We’re committed to your privacy. Kadar uses the information you provide to us to contact you about our relevant content, products, and services. You may unsubscribe from these communications at any time. For more information, check out our',
      validationMessages: {
        codeLength: 'Verification code should contain 6 digits.',
        alreadyTaken: 'Already taken',
        required: commonFieldValidationMessages.en.isEmpty,
        invalidName: validationMessages.en.firstName.invalid,
        minLength: validationMessages.en.firstName.minLength,
        maxLength: validationMessages.en.firstName.maxLength,
        invalidWorkspaceUrl: 'Workspace url is invalid',
        requiredLength: 'At least 8 characters',
        lowercase: 'One lowercase character',
        uppercase: 'One uppercase character',
        whitespace: 'No whitespace',
        typeOfCharacters: 'One number or symbol',
        invalidEmail: 'Please provide a valid work email.',
        exceededLengthEmail: 'Maximum length is 100 characters',
      },
    },
    DashboardPage: {
      title: 'Dashboard',
      pageHeader: { ...pageHeader.en },
      globalNotifications: {
        notificationButtonTooltip: 'Stay up-to-date with recent changes.',
        upToDate: "You're up to date with recent changes.",
        markAsRead: 'Mark as read',
        clearAll: 'Mark all as read',
        actions: {
          create: 'Created',
          update: 'Updated',
          expiration: 'Expiration',
        },
        models: {
          note: 'NOTE',
          oneOnOne: commonLabels.oneOnOne,
          actionPlan: 'ACTION PLAN',
          document: 'DOCUMENT',
        },
      },
      toDo: {
        title: 'Things to do',
        noData: {
          title: 'Perfectly cleaned',
          message:
            'All things to do are neatly cleaned up, be diligent in the future as well, the more often you see this message, the easier it will be for you :)',
        },
        absenceRequest: {
          title: commonLabels.absences,
          accept: commonLabels.accept,
          dismiss: commonLabels.dismiss,
          statuses: { ...statuses.en },
        },
        survey: {
          title: commonLabels.survey,
          surveyTypes: { ...surveyTypes },
          expiryDate: 'Expiry date',
          fillSurvey: commonLabels.fill,
        },
        planProposal: {
          title: commonLabels.actionPlan,
          proposed: commonLabels.proposed,
          proposedOn: commonLabels.proposedOn,
          accept: commonLabels.accept,
          dismiss: commonLabels.dismiss,
        },
        oneOnOneRequest: {
          title: commonLabels.oneOnOne,
          accept: commonLabels.accept,
          dismiss: commonLabels.dismiss,
          requestedOn: commonLabels.requestedOn,
          statuses: { ...statuses.en },
        },
      },
      tasks: {
        title: 'My Tasks',
        noData: {
          message: 'Once Tasks are assigned to you, they will appear here.',
        },
        noDataFinished: {
          message: "You don't have any unfinished tasks",
        },
        taskStatusDialog: { ...alertDialogs.en.taskStatusChange },
        assignedBy: 'Assigned by',
        you: commonLabels.you,
        statusTooltip: 'Toggle visibility of finished tasks',
        deletedUserTooltip: 'This user is no longer available.',
        linkButtonTooltip: {
          text: 'Click to open full task details.',
          disabled: "You currently don't have access to this task's details.",
        },
      },
      courses: {
        title: 'My Courses',
        noData: {
          message: "Courses you're enrolled in will be listed here.",
        },
        tags: commonLabels.tags,
        statuses: { ...statuses.en },
        successStatus: 'Status has been updated successfully.',
      },
      plans: {
        noData: {
          message: 'Once Action plans are added, they will appear here.',
        },
        proposeButton: commonLabels.propose,
        plan: { ...actionPlan.en },
        manageActionPlan: { ...manageActionPlan.en },
        dismissActionPlanProposalDialog: {
          ...alertDialogs.en.actionPlanProposalDismiss,
        },
        tabs: {
          myPlans: {
            name: 'My Action plans',
            infoText: 'Action plans created for you.',
          },
          createdByMe: {
            name: 'Created by me',
            infoText: 'Action plans you created for others.',
          },
          teamPlans: {
            name: "Team's Action plans",
            infoText: 'Action plans created for your direct reports.',
          },
        },
      },
      oneOnOne: {
        noData: {
          message: 'Past and scheduled 1:1 meetings will be visible here.',
        },
        requestButton: commonLabels.request,
        meetingDate: 'Meeting date',
        addToCalendar: 'Add to calendar',
        requestCard: {
          userRequest:
            'Your request has been successfully sent to the manager for approval.',
          expired:
            'Your manager is changed in the meantime. If you want to request' +
            ' 1:1 to the new manager, please delete this request and make' +
            ' a new one.',
          expiredWithNoModerator:
            'This request is outdated, delete it if you want to!',
          requested: commonLabels.requested,
          statuses: { ...statuses.en },
        },
        successMessages: {
          meetingRequestAdded: 'Your meeting request has been sent.',
          meetingRequestUpdated:
            'Your meeting request agenda topic has been updated.',
          meetingCreated: '1:1 record successfully created',
        },
        upcomingMeetingDialog: { ...alertDialogs.en.upcomingMeeting },
        deleteMeetingRequestDialog: { ...alertDialogs.en.meetingRequestDelete },
        manageTopicForm: { ...manageTopic.en },
        dismissOneOnOneRequestDialog: {
          ...alertDialogs.en.oneOnOneRequestDismiss,
        },
        oneOnOneRecordDialog: { ...oneOnOneRecordDialog.en },
        statuses: { ...statuses.en },
        requested: { ...requestedOneOnOneTooltip.en },
        tasksIconTooltip: 'This 1:1 has tasks',
        plansIconTooltip: 'This 1:1 has associated action plans',
        recurring: commonLabels.recurring,
        tags: commonLabels.tags,
        calendar: { ...calendar.en },
        tabs: {
          myOneOnOne: {
            name: 'My 1:1s',
            infoText: 'All 1:1 meetings where you are the participant.',
          },
          organizedByMe: {
            name: 'Organized by me',
            infoText: 'All 1:1 meetings where you are the moderator.',
          },
          teamOneOnOne: {
            name: 'Team’s 1:1s',
            infoText:
              'All 1:1s where your direct reports are the participants.',
          },
        },
      },
      absenceRequest: {
        approveAbsenceRequestDialog: {
          ...alertDialogs.en.approveAbsenceRequestDialog,
        },
        rejectAbsenceRequestDialog: {
          ...alertDialogs.en.rejectAbsenceRequestDialog,
        },
      },
      myTeam: {
        title: 'My Team',
        view: 'View',
        noData: {
          message: 'Once you have your team, they will appear here.',
        },
        labels: {
          oneOnOnes: commonLabels.oneOnOnes,
          actionPlans: commonLabels.actionPlans,
          courses: commonLabels.courses,
          notes: commonLabels.notes,
          ...statuses.en,
          total: 'Total',
        },
        tooltipMessages: {
          oneOnOnes: 'Trend chart based on last 6 impressions',
        },
        viewAll: commonLabels.viewAll,
        addTeam: 'Add team',
        manageTeam: {
          add: 'Add team',
          edit: 'Edit team',
          save: commonLabels.save,
          cancel: commonLabels.cancel,
          formLabels: {
            name: {
              label: 'Name',
              placeholder: 'Add team name',
            },
            users: {
              ...peoplePicker.en,
              label: commonLabels.people,
              placeholder: commonLabels.employeesName,
            },
          },
          validationMessages: {
            required: commonFieldValidationMessages.en.isEmpty,
            forbiddenCharacters:
              commonFieldValidationMessages.en.forbiddenCharacters,
            nameMaxLength: 'Exceeded max length of 100 characters.',
          },
          successMessages: {
            addPreset: 'Team is successfully created.',
            editPreset: 'Team is successfully updated.',
          },
        },
        deleteTeamDialog: { ...alertDialogs.en.deleteTeam },
        menuItems: {
          edit: commonLabels.edit,
          delete: commonLabels.delete,
        },
        previewTeamDialog: {
          noResults: 'No results match your search criteria.',
          placeholder: 'Find team member',
          labels: {
            oneOnOnes: commonLabels.oneOnOnes,
            actionPlans: commonLabels.actionPlans,
            courses: commonLabels.courses,
            notes: commonLabels.notes,
            ...statuses.en,
            total: 'Total',
          },
          tooltipMessages: {
            oneOnOnes: 'Trend chart based on last 6 impressions',
          },
        },
      },
    },
    CompanyOverviewPage: {
      pageTitle: 'Company overview',
      pageHeader: { ...pageHeader.en },
      sectionTitles: {
        oneOnOne: '1:1 meetings',
        actionPlans: 'Action plans',
        courses: 'Courses',
        overview: {
          title: 'Overview',
          description: 'General overview of all teams',
        },
      },
      tooltipLabels: {
        companyOneOnOne: 'All 1:1s throughout the entire organization.',
        companyActionPlans:
          'All Action plans throughout the entire organization.',
        companyCourses:
          'All learning actions throughout the entire organization.',
        oneOnOne:
          'All 1:1s for selected manager and his reports (all reports included) who were 1:1 organizers.',
        actionPlans:
          "All Action plans for selected manager's reports (all reports included)",
        courses:
          'All learning actions for selected manager and his reports (all reports included).',
      },
      overviewStatusLabels: { ...statsOverviewLabels.en },
      overviewPlaceholders: {
        actionPlansOverview: {
          partOne: 'Create',
          partTwo: 'Action Plans',
        },
        coursesOverview: {
          partOne: 'Assign',
          partTwo: 'Courses',
        },
        oneOnOneOverview: {
          partOne: commonLabels.schedule,
          partTwo: '1:1s',
        },
      },
      periodOptions: { ...periodFilter.en },
      teamOverviewTable: {
        headerLabels: {
          manager: {
            label: commonLabels.manager,
          },
          oneOnOne: {
            label: '1 on 1s',
            subLabels: {
              direct: 'Direct Reports',
              withoutOneOnOne: 'Without 1:1',
              negativeImpressions: 'Negative Impression',
            },
            tooltips: {
              negativeImpressions:
                'Percentage of team members with whom' +
                ' there was 1:1 with a negative impression (score of 1-3)',
            },
          },
          actionPlans: {
            label: 'Action plans',
            subLabels: {
              toDo: 'To-dos',
              overdue: 'Overdue',
            },
          },
          metrics: {
            label: 'Metrics',
            subLabels: {
              coverage: '1:1 coverage',
              learning: 'Learning',
              impression: '1:1 impression',
            },
            tooltips: {
              coverage: 'Percentage of the team covered by 1:1 meetings.',
              learning:
                'Percentage of the team that learning actions are' +
                ' assigned to.',
              impression:
                "How positive general impression of team's 1:1" +
                ' meetings is.',
            },
          },
        },
        noResults: {
          title: 'No overview',
          content:
            'There are no data on any of the teams for the last 60 days.',
        },
        loadButtonLabel: commonLabels.loadMore,
      },
      noJobTitle: commonLabels.noJobTitle,
    },
    PeoplePage: {
      pageTitle: 'People directory',
      pageHeader: { ...pageHeader.en },
      pageContainer: { ...peoplePageContainer.en },
      externalUsersViewDescription:
        'View and manage all the People in your organization. External users ARE NOT part of the monthly subscription plan.',
      deactivatedUsersViewDescription:
        'View and manage all the People in your organization. Deactivated users ARE NOT part of the monthly subscription plan.',
      activeUsersViewDescription:
        'View and manage all the People in your organization. Active users ARE part of the monthly subscription plan.',
      addPeopleButton: 'Add people',
      search: 'Search by name',
      organization: commonLabels.organization,
      loadMore: commonLabels.loadMore,
      organizationUser: commonLabels.organization,
      editPersonalInformationTitle: 'Personal information',
      editEmploymentInformationTitle: 'Employment information',
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      columns: {
        checkbox: 'Select All',
        name: 'Name',
        dateOfEmployment: 'Years Employed',
        email: commonLabels.email,
        jobTitle: 'Job title',
        levelAndTrack: 'Level and track',
        lastInquiry: 'Last Inquiry',
        roles: commonLabels.roles,
        status: 'Status',
        actions: commonLabels.actions,
      },
      systemRoles: { ...systemRoles.en },
      userStatuses: { ...userStatuses.en },
      reportToFilter: { ...statusesFilters.en.reportToFilter },
      actionPlansFilters: { ...actionPlansFilters.en },
      action: 'Action',
      selectBulkActions: {
        changeReportingTo: 'Change Reporting to',
        changeJobTitle: 'Change Job title',
        inviteUsers: 'Invite users',
        changeLevelTrack: 'Change Level/Track',
        changeDivisionDepartment: 'Change Department',
        applyTags: 'Apply Tags',
      },
      bulkEditDialog: {
        ...customDialogs.en.bulkEdit,
        ...customDialogs.en.manageUserTags,
      },
      addUsersDialog: { ...customDialogs.en.addUsersDialog },
      addUsersTable: { ...addUsers.en },
      currentUserTooltip: "You don't have permission to select yourself!",
      inactiveUserTooltip: "Can't select deactivated user!",
      userNoPermissionSelect: "You don't have permission to select this user!",
      externalUser: "Can't select External associate!",
      filters: { ...filters.en },
      invite: 'Invite',
      resendInvite: 'Resend invite',
      deactivate: 'Deactivate',
      userEditSuccess: 'User has been successfully updated.',
      userViewOptions: {
        active: 'Active users view',
        deactivated: 'Deactivated users view',
        external: 'External users view',
      },
      ...peoplePageFormLabels.en,
      menuItemLabels: {
        editPersonalInfo: 'Personal info',
        editEmploymentInfo: 'Employment info',
        delete: commonLabels.delete,
        reactivate: commonLabels.reactivate,
        invite: commonLabels.invite,
        reinvite: commonLabels.reinvite,
        deactivate: commonLabels.deactivate,
        revokeAccess: commonLabels.revokeAccess,
      },
      deleteUserDialog: { ...alertDialogs.en.userDelete },
      inviteUserDialog: { ...alertDialogs.en.userInvite },
      reinviteUserDialog: { ...alertDialogs.en.userReinvite },
      revokeAccessUserDialog: { ...alertDialogs.en.userRevokeAccess },
      deactivateSuccess: 'User has been successfully deactivated.',
      reactivateUserDialog: { ...customDialogs.en.reactivateUser },
      transferEmployeesDialog: { ...customDialogs.en.transferEmployees },
      employmentTerminationDateDialog: {
        ...customDialogs.en.employmentTerminationDate,
      },
      save: commonLabels.save,
      cancel: commonLabels.cancel,
    },
    PeopleInfoPage: {
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      description:
        'Overview of personal details, role, and employment information.',
      descriptionOwnProfile:
        'Overview of personal details, role, and employment information.',
      edit: 'Edit',
      personalInformationLabel: 'Personal information',
      employmentInfo: 'Employment information',
      tagsInfo: 'Tags',
      organizationUser: commonLabels.organization,
      add: 'Add tags',
      successUpdate: 'User data has been successfully updated.',
      noTags: 'No tags added yet for this user.',
      manageUserTagsDialog: { ...customDialogs.en.manageUserTags },
      tags: {
        description:
          'Tags help you search and filter by specific, common word.' +
          ' Tags are organized in categories such are projects, clients,' +
          ' skills or any other definition of your preference.',
      },
      employmentTerminationDateDialog: {
        ...customDialogs.en.employmentTerminationDate,
      },
      inviteUserDialog: { ...alertDialogs.en.userInvite },
      reinviteUserDialog: { ...alertDialogs.en.userReinvite },
      reactivateUserDialog: { ...customDialogs.en.reactivateUser },
      revokeAccessUserDialog: { ...alertDialogs.en.userRevokeAccess },
      deleteUserDialog: { ...alertDialogs.en.userDelete },
      transferEmployeesDialog: { ...customDialogs.en.transferEmployees },
      somethinWentWrong: commonFieldValidationMessages.somethingWentWrong,
      editInformation: 'Edit information',
      ...peoplePageFormLabels.en,
      statusLabel: commonLabels.status,
      userStatuses: { ...userStatuses.en },
      editPersonalInformationTitle: 'Personal information',
      editEmploymentInformationTitle: 'Employment information',
      save: commonLabels.save,
      cancel: commonLabels.cancel,
      basicPersonalInformation: {
        title: 'Basic',
        fields: {
          first_name: 'First name',
          last_name: 'Last name',
          email: commonLabels.email,
        },
      },
      personalDetails: {
        title: 'Personal details',
        fields: {
          gender: 'Gender',
          date_of_birth: 'Date of birth',
          place_of_birth: 'Place of birth',
        },
      },
      preferences: {
        title: 'Preferences',
        fields: {
          language: 'Language',
          timezone: 'Time zone',
        },
      },
      identification: {
        title: 'Identification',
        fields: {
          internal_id_number: 'Internal ID',
          national_id_number: 'National ID',
          residential_address: 'Residential address',
        },
      },
      professionalBackground: {
        title: 'Professional background',
        fields: {
          profession_title: 'Educational qualification',
          education: 'Education',
          years_of_work_experience: 'Years of work experience',
        },
      },
      previousWorkExperience: {
        fields: {
          previous_work_experience: 'Work experience',
        },
      },
      additionalPersonalInformation: {
        title: 'Additional information',
        fields: {
          social_accounts: 'Social accounts',
          external_resource: 'External resource',
        },
      },
      organization: {
        title: 'Organization',
        fields: {
          position: 'Job title',
          report_to: 'Reporting To',
          division: 'Division',
          department: 'Department',
          framework: 'Framework',
          track: 'Track',
          level: 'Level',
        },
      },
      employmentDetails: {
        title: 'Employment details',
        fields: {
          date_of_employment: 'Employment date',
          employment_terminated_at: 'Termination date',
          working_hours: 'Working hours',
        },
      },
      compensation: {
        title: 'Compensation',
        fields: {
          net_salary: 'Net salary',
          gross_salary_1: 'Gross 1',
          gross_salary_2: 'Gross 2',
        },
      },
      additionalEmploymentInformation: {
        title: 'Additional information',
        fields: {
          private_health_insurance: 'Private health insurance',
        },
      },
      disabledEditActionTooltip: "Can't edit deactivated user.",
      disabledTagsActionTooltip: "Can't add tags to deactivated user.",
    },
    PeopleCareerPage: {
      pageHeader: { ...pageHeader.en },
      description:
        'Follow up on the career performance for the current position as well as the other career possibilities for this employee.',
      attributeTypes: { ...attributeTypes.en },
      careerInfoSuccess: 'Career info has been successfully updated.',
      pageContainer: { ...peoplePageContainer.en },
      careerPerformance: {
        title: 'Career performance',
        jobTitle: 'Job title',
        attributes: 'Attributes',
        description: 'Description',
        addJobTitle: 'Add job title',
        assignJobTitle: 'Assign job title',
        noJobTitle: "Job title isn't assigned",
        disabledAssignActionTooltip:
          "Can't assign Job title to deactivated user.",
        measuredAttributes: {
          attributes: 'Attributes',
          peer: 'Peer, Team & Direct',
          extrinsicAssessment: 'Extrinsic assessment',
          extrinsic: 'Extrinsic',
          selfAssessment: 'Self assessment',
          self: 'Self',
          range: 'Range',
          openEndedAttribute: 'Open-ended attribute',
          sendSurvey: commonLabels.sendSurvey,
          compareReport: commonLabels.compareReport,
        },
      },
      careerProgress: {
        title: 'Career progress',
        currentLevel: 'Current level',
        nextStage: 'Next stage',
        period: 'Period',
        attributes: 'Attributes',
        range: 'Range',
        score: 'Score',
        noLevel: {
          title: 'To preview career path, add track and level.',
          assignLevel: 'Add',
          addLevel: 'Add level',
          disabledAssignActionTooltip: "Can't add Level to deactivated user.",
        },
      },
      addUserCareerForm: {
        save: commonLabels.save,
        add: 'Career info',
        formLabels: {
          jobTitle: {
            label: 'Job title',
            placeholder: 'Add job title',
            labelHelp: {
              tooltipText: employmentInfoHelpText.en.jobTitle.text,
            },
          },
          framework: {
            label: 'Framework',
            placeholder: 'Add framework',
            labelHelp: {
              tooltipText: employmentInfoHelpText.en.framework.text,
            },
          },
          track: {
            label: 'Track',
            placeholder: 'Add track',
            labelHelp: {
              tooltipText: employmentInfoHelpText.en.track.text,
            },
          },
          level: {
            label: 'Level',
            placeholder: 'Add level',
            labelHelp: {
              tooltipText: employmentInfoHelpText.en.level.text,
            },
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
        },
      },
    },
    PeopleNotesPage: {
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      description: 'View all the Notes created for this team member.',
      addNoteButton: 'New note',
      noResults: {
        title: 'No notes yet!',
        message: "Once they're added, they will appear here.",
      },
      inactiveUser: 'Inactive user',
      noteDeleteDialog: { ...alertDialogs.en.noteDelete },
      manageNotesDialog: { ...noteDialog.en },
      noteTypeDialog: { ...customDialogs.en.peopleNoteTypes },
      note: { ...note.en },
      disabledAddActionTooltip: "Can't make Note for deactivated user.",
    },
    PeopleAbsencesPage: {
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      description:
        'Track and manage absences with ease. View past and upcoming absences, including reasons and durations, all in one place.',
      requestAbsenceButton: 'Request leave',
      addAbsenceButton: 'Add leave',
      requestAbsenceButtonDisabled: "Can't request leave for deactivated user.",
      approveRequestAbsenceButtonDisabled:
        "Can't approve request for deactivated user.",
      rejectRequestAbsenceButtonDisabled:
        "Can't reject request for deactivated user.",
      noResults: {
        title: 'No time-off assigned yet!',
        message: "Once it's assigned, it will appear here.",
      },
      timeOff: 'Time off',
      upcomingTimeOffSection: 'Upcoming Time off',
      noUpcomingTimeOff: 'No upcoming time off.',
      year: 'Year',
      changedSetInfo:
        "The absence types for this year belong to a different set. Timeline and request data are based on that year's specific configuration.",
      requests: {
        title: 'Requests',
        description: 'List of all leave requests.',
      },
      timeline: {
        title: 'Timeline',
        description: 'List of all balance changes.',
      },
      noRequests: 'There are no leave requests yet!',
      noTimeline: 'There are no balance changes!',
      deleteRequestDialog: { ...alertDialogs.en.absenceRequestDelete },
      approveRequestDialog: { ...alertDialogs.en.absenceRequestApprove },
      rejectRequestDialog: { ...alertDialogs.en.absenceRequestReject },
      menuItems: {
        edit: commonLabels.edit,
        delete: commonLabels.delete,
        approve: commonLabels.approve,
        reject: commonLabels.reject,
        report: 'Open approval document',
      },
      table: {
        date: 'Date',
        requestDate: 'Request date',
        description: commonLabels.description,
        used: 'Used',
        absence: commonLabels.type,
        period: 'From-To',
        actions: commonLabels.actions,
        status: commonLabels.status,
        day: commonLabels.day,
        days: commonLabels.days,
        effectiveDate: 'Effective date',
        creator: 'Managed by',
        accrual: '+ / -',
        loadMore: commonLabels.loadMore,
        actionButtons: {
          edit: 'Edit request',
          delete: 'Delete request',
        },
        holiday: commonLabels.holiday,
      },
      absenceCards: {
        available: 'Available',
        used: 'Used',
        day: commonLabels.day,
        days: commonLabels.days,
        availableInThisCycle: 'From current year',
        availableInThisCycleMonthly: 'Calculated monthly from',
        availableInThisCycleMonthlySuffix: '(current year + extensions)',
        availableInThisCycleYearly: 'From current year',
        adjustmentDays: 'Adjustment for this year',
        usedDays: 'Used days this year',
        totalDaysLabel: 'Total',
        numberOfScheduledDays: 'Scheduled',
        carriedOver: 'From previous year expire on',
        negativeCarriedOver:
          'Carried over from previous year and deducted from current balance',
        infoTitle: 'Calculation of',
        updateBalanceCurrentYear: 'Update balance for vacation leave',
        menuItemLabels: {
          manageBalancePreviousYear: 'Previous year balance',
          manageBalanceCurrentYear: 'Current year balance',
        },
      },
      updateAbsenceBalance: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        balanceCurrentYear: 'Edit current year balance',
        balancePreviousYear: 'Edit previous year balance',
        formLabels: {
          numberOfDays: {
            label: 'Number of days from previous year',
          },
          expirationDate: {
            label: 'Expiration date',
          },
          description: {
            placeholder: 'Enter balance description',
          },
          totalDaysAdjustment: {
            label: 'Adjustment days for current year',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          minMaxDays: 'Number of days must be greater or equal to 0.',
          maxLength: 'Exceeded maximum allowed field length.',
        },
        successMessages: {
          editBalancePreviousYear: 'Previous year balance updated.',
          editBalanceCurrentYear: 'Current year balance updated.',
        },
      },
      requestStatuses: { ...statuses.en },
      manageAbsenceRequest: { ...manageAbsenceRequest.en },
    },
    PeopleReviewCyclesPage: {
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      description:
        'A comprehensive view of all review cycles. Compare current and past reports to track achievements, feedback, and development over time.',
      noResultsTitle: 'No Review cycles yet!',
      noResultsMessage: 'Once created, they will appear here.',
      analyticsSection: 'Analytics & Comparisons',
      ratingsSection: 'Detailed Ratings by Competency',
      cycleLabel: commonLabels.cycle,
      compareWithLabel: 'Compare with',
      compareWithPlaceholder: 'Select cycle to compare',
      steps: {
        self: 'Self',
        topDown: 'Top > Down',
        downUp: 'Down > Up',
      },
      cycleAttributes: {
        viewAnswers: 'View answers',
      },
      cycleAttributeRatings: {
        levelRange: 'Level range:',
        openEndedAttribute: 'Open-ended review',
        self: 'Self',
        topDown: 'Top > Down',
        downUp: 'Down > Up',
      },
      ...neutralAnswer.en,
    },
    PeopleOneOnOnePage: {
      all: commonLabels.all,
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      description: 'View all the 1:1 meetings organized for this team member.',
      addButtonLabel: 'New 1:1',
      filters: { ...filters.en },
      oneOnOneRecords: { ...oneOnOneRecords.en },
      loadMore: commonLabels.loadMore,
      statuses: { ...statuses.en },
      noDataLabel: commonLabels.none,
      noRecords: {
        title: 'Currently, there are no 1:1 records for this employee.',
        inactiveUser: 'Inactive user',
        message: "Once they're added, they will appear here.",
        noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      },
      requestCard: {
        requested: commonLabels.requested,
        scheduleMeeting:
          'Would you like to schedule this meeting as an' +
          ' employee-initiated 1:1?',
        agenda: 'Employee meeting agenda (Added [DATE])',
        actionButtons: { ...iconButtonsTooltip.en },
      },
      successMessages: { ...manageOneOnOneMessages.en },
      oneOnOneRecordDialog: { ...oneOnOneRecordDialog.en },
      deleteOneOnOneRecordDialog: { ...alertDialogs.en.oneOnOneRecordDelete },
      dismissOneOnOneRequestDialog: {
        ...alertDialogs.en.oneOnOneRequestDismiss,
      },
      addImpressionDialog: { ...customDialogs.en.addImpression },
      manageTasksDialog: { ...manageTasks.en },
      disabledAddActionTooltip: "Can't make 1:1 with deactivated user.",
    },
    PeopleDocumentsPage: {
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      pageDescription:
        'View documents by category and type. Adding and editing documents may be available depending on your role and document configuration.',
      progressDescription: 'Tracks the number of uploaded mandatory documents',
      noResults: {
        title: 'No documents yet!',
        content: 'Once documents are added, they will appear on this page.',
      },
      add: 'Add',
      edit: commonLabels.edit,
      signingDateLabel: 'Signing date',
      expiryDateLabel: 'Expiry date',
      expiredExpiryDateTooltip: 'This document expired.',
      soonToExpireTooltip: 'This document expires soon.',
      expiredDocumentsTooltip: 'There are documents that have expired.',
      soonToExpireDocumentsTooltip:
        'There are documents that will expire soon.',
      description: 'Description',
      deleteDocumentDialog: {
        title: 'Delete document',
        contentMessage: 'Are you sure you want to delete this document?',
        confirmButton: commonLabels.yes,
        closeButton: commonLabels.no,
      },
      successMessages: {
        savedDocument: 'Document is successfully saved',
        updatedDocument: 'Document is successfully updated',
        deletedDocument: 'Document is successfully deleted',
      },
      sucessMessages: {
        savedDocument: 'Document is successfully saved',
      },
      documentForm: {
        add: 'Add document',
        edit: 'Edit document',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        formLabels: {
          documentType: {
            label: 'Document type',
          },
          description: {
            label: 'Description',
            placeholder: 'Enter document description',
          },
          signingDate: {
            label: 'Signing date',
          },
          expireDate: {
            label: 'Expiry date',
          },
          uploadFile: {
            label: 'Upload file',
            placeholder: 'Upload file',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          descriptionMaxLength: 'Exceeded maximum allowed field length.',
          fileType:
            'File type should be one of: jpg, png, jpeg, pdf, doc, docx',
          fileLength: 'File should have maximum 100 characters.',
          invalidSigningDate: 'Signing date should be before expiry date',
          invalidExpiryDate: 'Expiry date should be after signing date',
        },
      },
    },
    CompareReportPage: {
      title: 'Compare',
      pageHeader: { ...pageHeader.en },
      ...readLessMoreLabels,
      description:
        'Explore the shifting perceptions and evaluations of people attributes scores over time through the lens of specific reviewers.',
      noResults: 'There are no compare scores to display.',
      user: {
        label: 'Created for',
        placeholder: 'Choose user',
      },
      filters: { ...filters.en },
      systemRoles: { ...systemRoles.en },
      reportToFilter: { ...statusesFilters.en.reportToFilter },
      compare: {
        surveyType: {
          label: 'Survey type',
        },
        period: commonLabels.period,
        reviewersPicker: {
          addPeopleLabel: 'Add reviewers',
          picker: { ...multipartPeoplePicker.en, title: 'Add reviewers' },
        },
        noAttributeResults: 'There are no attribute scores to display.',
        syncFiltersButton: 'Sync filters with created for user',
        removeCompareWith: 'Remove user',
        compareWithButton: 'Add or change user for comparison',
        addCompareWithDialog: { ...customDialogs.en.addCompareWith },
        surveyTypeFilterOptions: { ...surveyTypeFilterOptions.en },
        restoreAttributes: 'Restore removed attributes',
        attribute: { ...attributeChip.en },
      },
      presets: { ...presets.en },
    },
    SurveySettingsPage: {
      pageHeader: { ...pageHeader.en },
      anonymousSurvey: `${commonLabels.anonymous} survey`,
      oneTimeSurvey: 'Excluded from statistics',
      seeReportButton: 'See report',
      organization: commonLabels.organization,
      closeSurveyButton: 'Close survey',
      forceCompleteDialog: { ...alertDialogs.en.surveyForceComplete },
      sendReminderAllDialog: { ...alertDialogs.en.surveySendReminderAll },
      sendReminderDialog: { ...customDialogs.en.surveySendReminder },
      surveyReopenAllDialog: { ...alertDialogs.en.surveyReopenAll },
      surveyReopenDialog: { ...customDialogs.en.surveyReopen },
      addReviewersDialog: { ...customDialogs.en.addReviewers },
      statuses: { ...statuses.en },
      surveyTypes: { ...surveyTypes },
      cycleReviewTypes: { ...cycleReviewTypes.en },
      anonymous:
        'Reviewers actions are unavailable in order to provide full anonymity.',
      partOfCycle:
        'This review is part of a recurring cycle, and most settings are managed at the cycle level.',
      renameSurveyDialog: { ...customDialogs.en.surveyTitle },
      renameReviewDialog: { ...customDialogs.en.reviewTitle },
      info: {
        attributes: 'Attributes',
        questionnaire: commonLabels.questionnaire,
        status: 'Status',
        type: commonLabels.type,
        dateSent: 'Date sent',
        expireAt: 'Expiry',
        startsOn: commonLabels.startsOn,
        endsOn: commonLabels.endsOn,
        scheduledFor: 'Scheduled for',
        createdBy: commonLabels.createdBy,
        reviewedUsers: 'Who will be reviewed',
        autoSharedUsers: 'Auto-share with',
        autoShareDialog: { ...surveySummaryAutoShare.en },
        autoReminders: 'Auto reminder',
        autoReminderDialog: { ...surveyAutoReminder.en },
        completed: 'Completed',
        group: 'Group',
        manageGroupDialog: { ...customDialogs.en.manageGroupItems },
        expiryDialog: {
          title: 'Expiry',
          description: 'Please select new expiry date for this survey',
          formLabels: {
            expiryDate: {
              label: 'Expiry',
              tooltipInfo:
                'Specify an expiration date for your survey. By default, it will remain open for 7 days before closing.',
            },
          },
          close: commonLabels.close,
          save: commonLabels.save,
        },
      },
      reviewers: {
        title: 'Reviewers',
        addButton: 'Add new reviewers',
        addScheduleButton: 'Schedule new reviewers',
        loadMore: commonLabels.loadMore,
        status: 'Status',
        search: commonLabels.search,
        action: 'Action',
        completionStatuses: { ...statuses.en },
        noReviewers:
          "This survey doesn't have active reviewers with selected status.",
        actions: { ...surveyReviewersActions.en },
      },
    },
    SurveyReportPage: {
      pageHeader: { ...pageHeader.en },
      anonymousSurvey: `${commonLabels.anonymous} survey`,
      oneTimeSurvey: 'Excluded from statistics',
      statuses: { ...statuses.en },
      surveyTypes: { ...surveyTypes },
      cycleReviewTypes: { ...cycleReviewTypes.en },
      createSummaryReport: 'Create summary report',
      createSummaryReportDisabled:
        'A summary can be added once the survey is completed and has results.',
      createCycleSummaryReportDisabled:
        'A summary can be added once the review is completed and has results.',
      noReport:
        'There are no sufficient information available to prepare this report.',
      surveyTypesDescription: { ...surveyinfoDescription.en },
      reviewComments: { ...reviewCommentsDrawer.en },
      surveySummaryForm: { ...surveySummaryForm.en },
      info: {
        status: 'Status',
        type: commonLabels.type,
        dateSent: 'Date sent',
        scheduledFor: 'Scheduled for',
        createdBy: commonLabels.createdBy,
        reviewers: 'Reviewers',
        reviewedUsers: 'Who will be reviewed',
        expire: 'Expiry',
        startsOn: commonLabels.startsOn,
        endsOn: commonLabels.endsOn,
      },
      review: { ...surveyResults.en },
    },
    PeopleActionPlansPage: {
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      pageDescription:
        'View all the Action plans created for this team member.',
      descriptionOwnProfile: 'View all the Action plans created for me.',
      add: commonLabels.add,
      edit: commonLabels.edit,
      delete: commonLabels.delete,
      discard: commonLabels.discard,
      save: commonLabels.save,
      confirm: 'Confirm',
      cancel: commonLabels.cancel,
      all: commonLabels.all,
      filters: { ...filters.en },
      addFilters: commonLabels.addFilters,
      addActionPlan: 'New action plan',
      description: commonLabels.description,
      noResultsTitle: 'No Action Plans yet!',
      noResultsMessage: "Once they're added, they will appear here.",
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      loadMore: commonLabels.loadMore,
      statuses: { ...statuses.en },
      actionPlans: { ...actionPlan.en },
      manageActionPlan: { ...manageActionPlan.en },
      manageTasksDialog: { ...manageTasks.en },
      deleteActionPlanDialog: { ...alertDialogs.en.actionPlanDelete },
      dismissActionPlanProposalDialog: {
        ...alertDialogs.en.actionPlanProposalDismiss,
      },
      disabledAddActionTooltip: "Can't make Action plan for deactivated user.",
    },
    PeopleInsightsPage: {
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      subtitles: {
        peerAndTeamAndDirect: 'Peer, Team & Direct',
        self: 'Self',
      },
      surveyTypeField: {
        label: 'Survey type',
        placeholder: 'Select survey type',
      },
      surveyTypeFilterOptions: { ...surveyTypeFilterOptions.en },
      description:
        'Dive deep into the scores for each Attribute throughout the time, for selected period. ' +
        'Identify trends for specific Attribute. ' +
        'Below chart, there is a list of freeform feedbacks from people that were reviewing this employee. ' +
        'Timeline on the side shows details of sent surveys.',
      noResults: { ...noReports },
      attributes: 'Attributes',
      noAttributes: 'There are no measured attributes for this employee.',
      periodFilterText: 'Filter surveys by date range',
      tooltipLabels: {
        attribute: 'Attribute',
        questions: 'Questions',
        description: 'Description',
      },
      minAttribute: 'Minimum number of selected attributes is ',
      maxAttribute: 'Maximum number of selected attributes is ',
      noDataForChartMessage: {
        title: 'No measured attributes for selected survey type and period!',
        content: 'Change inputs to gain deeper insights into gathered data.',
      },
      noQuantitativeChartDataMessage: {
        content:
          'There is no quantitative data for the selected survey type and period. ',
      },
      groupByDropdown: 'Group by',
      periodLabel: 'Period',
      reminder: commonLabels.reminder,
      reminderSent: 'Reminder successfully sent.',
      anonymous: 'Anonymous',
      completed: 'Completed',
      inProgress: 'In progress',
      responded: 'Responded',
      and: 'and',
      more: 'more',
      none: commonLabels.none,
      timelineTooltip: {
        text: 'List of all surveys sent for this employee.',
      },
      statuses: { ...statuses.en },
      noData: ' No data for selected criteria.',
      personalAttributeTooltip: personalAttribute.en.tooltipText,
      timelineColumns: {
        sentAt: 'Sent at',
        survey: 'Survey',
        status: 'Status',
      },
      feedbackColumns: {
        sentAt: 'Sent at',
        comment: 'Comment',
        reviewer: 'Reviewer',
      },
      feedback: {
        title: 'Feedbacks',
        description: 'From all measured attributes in selected period',
        noData: ' No data for selected criteria.',
      },
      timeline: {
        title: 'Timeline',
        description:
          'List of all surveys sent for this employee in selected period.',
        noData: ' No data for selected criteria.',
      },
    },
    PeopleRolesPage: {
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      description:
        'An overview of primary and additional roles, including the specific people managed under each designation.',
      filters: { ...filters.en },
      directReports: 'Direct reports',
      systemRoles: { ...systemRoles.en },
      primaryRole: {
        title: 'Primary role',
        noEmployeesResults: {
          title: 'No direct reports',
          message: 'Once added they will appear here.',
        },
      },
      additionalRole: {
        title: 'Additional role',
        addRole: 'Add additional role',
        noRoleAssigned: 'No additional role assigned',
        addScopeButton: 'Add scope',
        menuItems: {
          edit: commonLabels.edit,
          delete: commonLabels.delete,
        },
        noEmployeesResults: {
          title: 'No employees scope groups',
          message: 'Once added they will appear here.',
        },
        noRoleResults: {
          title: 'No additional role',
          message: 'Once assigned employees scope groups can be added.',
        },
      },
      managePrimaryRole: {
        title: 'Manage primary role',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        formLabels: {
          primaryRoleId: {
            label: 'Primary role',
          },
          changeRoleWarrning: {
            label:
              'Upgrading to an Admin role will automatically remove additional role and employee scope groups associated with this user.',
          },
        },
        successMessages: {
          edit: 'Primary role successfully updated.',
        },
      },
      manageAdditionalRole: {
        title: 'Manage additional role',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        formLabels: {
          additionalRoleId: {
            label: 'Additional role',
            placeholder: 'Select additional role',
          },
        },
        successMessages: {
          add: 'Additional role successfully added.',
          edit: 'Additional role successfully updated.',
        },
      },
      manageUsersScope: {
        add: 'Add users scope',
        edit: 'Edit users scope',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        formLabels: {
          name: {
            label: 'Title',
            placeholder: 'Add scope title',
          },
          employees: {
            label: 'Users',
            ...filters.en,
            noResults: 'No results',
            noResultsContent:
              'Users will appear here once they match the selected filters.',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          requiredFilter: 'At least one filter must be selected.',
          requiredFilterValues: 'At least one employee must be present.',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          nameMaxLength: 'Exceeded max length of 255 characters',
        },
        successMessages: {
          add: 'Scope successfully added.',
          edit: 'Scope successfully updated.',
        },
      },
      deleteAdditionalRoleDialog: { ...alertDialogs.en.additionalRoleDelete },
      deleteScopeDialog: { ...alertDialogs.en.employeeScopeDelete },
    },
    PageNotFound: {
      pageTitle: '404 error',
      description: 'Where Did That Page Go?',
      goHome: 'Go home',
      pageHeader: { ...pageHeader.en },
    },
    PublicJobUnavailablePage: {
      pageTitle: '404 error',
      description: 'This job is no longer publicly available.',
    },
    ResendSignUpPage: {
      title: 'Check your email',
      submit: 'Resend Email',
      emailTo:
        "We've sent an email to [EMAIL]. Click the link in the" +
        ' email to confirm your email address and continue with' +
        ' registration.',
      checkIfMissing:
        "If you don't see the email, check other places it \n" +
        'might be, like your junk, spam, or other folders.',
      backLink: 'Return To Login',
      fields: {
        firstName: 'First Name',
        lastName: 'Last Name',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        workEmail: 'Work Email',
        workPhone: 'Work Phone',
        jobTitle: 'Job Title',
        companyName: 'Company Name',
        desiredUrl: 'Desired Url',
      },
      personalInformation: 'Personal Information',
      companyInfo: 'Company Information',
      invalidName: 'Invalid name',
      requiredPassword: 'Password is required',
      repeatPassword: 'Repeat password',
      passwordMismatch: 'Your password and confirmation password do not match.',
      invalidPassword: 'Minimum 6 characters, at least 1 letter and 1 number',
      invalidPhoneNumber: 'Phone number is invalid',
      requiredJobTitle: 'Job title is required',
      invalidJobTitle: 'Job title is invalid',
      requiredCompanyName: 'Company name is required',
      invalidCompanyName: 'Invalid company name',
      requiredDesiredUrl: 'Url is required',
      invalidDesiredUrl: 'Url is invalid',
      agree: 'I agree to',
      and: 'and',
      check: iconAlt.checkIcon,
      checkingRegistrationLink: 'Checking registration link...',
      registrationLinkExpired: 'Registration link has expired!',
      termsOfService: 'Terms of Service',
      privacyPolicy: 'Privacy Policy',
      create: 'Create',
      tooltipText: 'Click check button to validate desired url.',
      acceptTerms: 'You need to accept terms-of-service.',
      isTaken: 'is taken.',
    },
    LoginPage: {
      title: 'Sign in to your organization',
      description: 'Enter your details below.',
      submit: 'Sign in',
      email: commonLabels.email,
      password: 'Password',
      kadar: commonLabels.app,
      invalidEmailAddress: 'Invalid email address',
      invalidPassword: 'Invalid password',
      invalidEmailOrPassword: 'Invalid email address or password',
      noActiveAccount: 'No active account found with the given credentials.',
      rateLimit: 'Too many attempts. Please wait a moment and try again.',
      backLink: 'Forgot Password',
      continue: 'Continue',
      enterWorkspaceTitle: 'Sign in to your workspace',
      enterWorkspaceSubTitle: "Enter your workspace's URL",
      enterWorkspaceSubdomain: 'Workspace name',
      somethingWentWrong: commonFieldValidationMessages.en.somethingWentWrong,
      authContainer: { ...authContainer.en },
      ...validationMessages.en.organization,
    },
    LoginAuthenticationPage: {
      title: '2FA authentication',
      codeDescription: 'Enter the verification code.',
      qrCodeDialog: { ...alertDialogs.en.qrCodeDialog },
      submitCode: 'Submit',
      code: 'Code',
      kadar: commonLabels.app,
      backLabel: 'Back',
      continue: 'Continue',
      authContainer: { ...authContainer.en },
      ...validationMessages.en.twoFactor,
    },
    TwoFactorOptionsPage: {
      reset: 'Reset 2FA',
      disable: 'Disable 2FA',
      continue: 'Continue to app',
      descriptionOne: 'You logged in using a recovery code.',
      descriptionTwo: 'Your authenticator is still active.',
      descriptionThree: 'You’ll need it again the next time you sign in.',
      descriptionReset:
        'If you no longer have access to it, you can reset it now.',
      descriptionDisable:
        'If you no longer have access to it, you can disable it now.',
      kadar: commonLabels.app,
      authContainer: { ...authContainer.en },
      ...validationMessages.en.twoFactor,
    },
    DisableAuthenticationPage: {
      titleDisable: 'Disable 2F Authentication',
      titleReset: 'Reset 2F Authentication',
      descriptionReset: 'Enter a recovery code to reset your authenticator.',
      codeDescription: 'Enter the recovery code.',
      info: "This will remove your current setup. You'll need to set up a new authenticator on your next login.",
      qrCodeDialog: { ...alertDialogs.en.qrCodeDialog },
      submitCode: 'Submit',
      kadar: commonLabels.app,
      backLabel: 'Back',
      authContainer: { ...authContainer.en },
      resetAuth: 'Reset authenticator',
      ...validationMessages.en.twoFactor,
    },
    ForgottenPasswordPage: {
      email: commonLabels.email,
      submit: 'Send email',
      backLink: 'Return to Login',
      title: 'Forgot your password?',
      authContainer: { ...authContainer.en },
      kadar: commonLabels.app,
      description:
        "Just enter your email address and we'll email" +
        ' you the instructions to reset your password.',
      ...validationMessages.en.email,
    },
    ResetLinkSentPage: {
      title: 'Check your Email',
      submit: 'Resend email',
      backLink: 'Return to Login',
      kadar: commonLabels.app,
      resetLink:
        "We've sent an email to [EMAIL]. Click the link in the" +
        ' email to reset your password.',
      checkIfMissing:
        "If you don't see the email, check other places it \n" +
        'might be, like your junk, spam, or other folders.',
      authContainer: { ...authContainer.en },
    },
    ResetPasswordPage: {
      repeatPassword: 'Repeat password',
      password: 'Password',
      kadar: commonLabels.app,
      title: 'Set new password',
      description: 'Please enter your new password.',
      submit: 'Set password',
      backLink: 'Return to Login',
      welcome: 'Welcome to the organization',
      descriptionSetPassword: 'Set your password to join the organization.',
      agree: 'I agree to',
      and: 'and',
      check: iconAlt.checkIcon,
      privacy_policy: { name: 'Privacy policy' },
      terms_of_service: { name: 'Terms of service' },
      passwordRequirements:
        'Password should contain minimum eight characters without spaces, one uppercase, one lowercase letter and one number or symbol',
      passwordMismatch: 'Your password and confirmation password do not match.',
      authContainer: { ...authContainer.en },
    },
    SurveysPage: {
      ...readLessMoreLabels,
      title: 'Surveys',
      pageHeader: { ...pageHeader.en },
      sendSurvey: 'New survey',
      descriptionPartOne:
        'Surveys are the ways to collect results for a certain Attribute(s) for team member(s).',
      descriptionPartTwo:
        'View and dive deep into each sent Survey, or create new ones.',
      anonymousSurvey: `${commonLabels.anonymous} survey`,
      oneTimeSurvey: 'Excluded from statistics',
      addGroupButton: 'New group',
      surveyTypes: { ...surveyTypes },
      surveyViewOptions: {
        list: 'List view',
        group: 'Group view',
      },
      loadMore: commonLabels.loadMore,
      noOptions: commonLabels.noOptions,
      all: commonLabels.all,
      columns: {
        actions: commonLabels.actions,
        title: 'Title',
        type: 'Type',
        sentAt: 'Date sent',
        group: 'Group',
        status: 'Status',
        expiry: 'Expiry',
      },
      viewReport: commonLabels.viewReport,
      statuses: { ...statuses.en },
      filters: { ...filters.en },
      organization: commonLabels.organization,
      renameSurveyDialog: { ...customDialogs.en.surveyTitle },
      manageGroupDialog: { ...customDialogs.en.manageSurveyGroup },
      manageGroupItemsDialog: { ...customDialogs.en.manageGroupItems },
      surveyDuplicateDialog: { ...alertDialogs.en.surveyDuplicate },
      surveyGroupDuplicateDialog: {
        ...alertDialogs.en.surveyGroupDuplicate,
      },
      removeFromGroupDialog: { ...alertDialogs.en.removeSurveyFromGroup },
      menuItemLabels: {
        reminder: 'Send reminder',
        renameSurvey: 'Rename',
        delete: 'Delete',
        duplicate: commonLabels.duplicate,
        forceComplete: 'Close',
        fillSurvey: 'Fill survey',
        manageGroup: 'Manage group',
        removeGroup: 'Remove from group',
        reviewAndSend: 'Review and (Send or Schedule)',
      },
      reminderSent: 'Reminder successfully sent.',
      scheduledFor: 'Scheduled for: ',
      close: commonLabels.close,
      customFilterSelection: {
        creator: 'Creator',
        createdFor: 'Created for',
        reviewedBy: 'Reviewed by',
      },
      sectionTitleTooltipText: 'Surveys page',
      searchTooltipText: 'Use Search to find survey!',
      filtersTooltipText: 'Use Filters to narrow down your Search',
      tooltipIcon: 'Tooltip icon',
      searchPlaceholder: 'Search by title',
      defaultEmailMessage:
        'Help us in the review process by answering this survey.',
      createSurveyForm: {
        cancel: commonLabels.cancel,
        save: commonLabels.continue,
        columns: {
          preview: commonLabels.preview,
        },
        formLabels: {
          surveyType: {
            label: 'Survey type',
            placeholder: 'Select survey type',
          },
          title: {
            label: 'Survey title',
            placeholder: 'Add survey title',
          },
          sharedTo: {
            label: 'Report access',
            placeholder: "Employee's name",
            noOptions: commonLabels.noResults,
            labelHelp: {
              tooltipText:
                'By default only creator of survey and administrators can see Survey report ' +
                'and answers. Utilize the member list to explicitly grant access to additional ' +
                'users, providing control and customization over survey visibility.',
            },
          },
          attributes: {
            label: 'Add attributes',
            placeholder: 'Add attributes',
            noOptions: commonLabels.noResults,
          },
          questionnaire: {
            tooltipTextOff:
              'Turn on to add questionnaire to this survey instead of attributes.',
            tooltipTextOn:
              'Turn off to select attributes for this survey instead of questionnaire.',
          },
          selfReview: {
            label: 'Self review for',
            placeholder: commonLabels.employeesName,
            ...peoplePicker.en,
          },
          reviewers: {
            label: 'Reviewers',
            placeholder: commonLabels.employeesName,
            ...peoplePicker.en,
          },
          associates: {
            label: 'External reviewers',
            placeholder: commonLabels.employeesName,
            ...peoplePicker.en,
          },
          reviewer: {
            label: 'Reviewer',
            placeholder: commonLabels.employeesName,
            noOptions: commonLabels.noResults,
          },
          whoWillBeReviewed: {
            label: 'Who will be reviewed',
            placeholder: commonLabels.employeesName,
            noOptions: commonLabels.noResults,
            ...peoplePicker.en,
          },
          isAnonymous: {
            labelText: 'Anonymous (min. 6 reviewers)',
            endLabelIconHelp:
              "If checked, you won't be able to see who answered the" +
              ' questionnaire, only the answers.',
          },
          oneTime: {
            labelText: 'Exclude this survey from statistics',
            endLabelIconHelp:
              "If checked, this survey's results won't be part of statistics on User profiles, Competence map and Skill comparisons.",
          },
          schedule: {
            label: 'Schedule',
            tooltipInfo:
              'Activate this option if you wish to schedule a survey',
          },
          autoReminder: {
            label: 'Auto reminder',
            tooltipInfo:
              'Activate this option to send automatic reminders to reviewers who have not completed the survey.',
          },
          auto_reminders: {
            label: 'Send automatic reminders',
            labelHelp: {
              tooltipText:
                'Reminders are sent to reviewers who have not completed the survey. Options that fall before the survey start date are disabled.',
            },
            options: {
              halfway: 'Halfway through',
              day_before_end: '1 day before end',
              days_before_3: '3 days before end',
              days_before_7: '7 days before end',
            },
          },
          autoShare: {
            label: 'Auto-share report',
            tooltipInfo:
              'Toggle this option to automatically share the survey summary once it’s completed.',
          },
          autoShareTitle: {
            label: 'Survey summary title',
          },
          summary: {
            label: 'Summary',
          },
          autoShareTo: {
            label: 'Auto-share with',
            placeholder: commonLabels.employeesName,
            ...peoplePicker.en,
          },
          email: {
            label: 'Customize email',
            tooltipInfo:
              'Activate this option if you wish to personalize email message or use the default one.',
          },
          emailContent: {
            placeholder: 'Add email message',
          },
          expiry: {
            label: 'Expiry',
            tooltipInfo:
              'Specify an expiration date for your survey. By default, it will remain open for 7 days before closing.',
          },
          people: {
            label: 'People',
          },
          surveyPreview: {
            fillSurvey: { ...fillSurveyFlow.en },
            user: 'Hello User',
            fillSurveyButton: 'Fill survey',
            emailFooter: "Don't let your team melt!",
            disabledButtonTooltip:
              'Once you add required data input survey preview will be available.',
            restart: 'Restart preview',
          },
          customQuestionnaire: {
            questionnaire: 'Questionnaire',
            preview: commonLabels.preview,
            newQuestion: 'Add question',
            questionsRequired: 'Add at least one question.',
            questionnaireErrorsTooltip: 'This questionnaire has errors.',
            name: {
              label: 'Name',
              placeholder: 'Add questionnaire name',
            },
            description: {
              label: 'Description',
              placeholder: 'Enter description for your questionnaire',
            },
            maxLength: 'Exceeded max length of 150 characters',
            descriptionMaxLength: 'Exceeded max length of 10000 characters.',
            questionOptions: {
              multipleChoice: 'Multiple choice',
              multiSelect: 'Multi select',
              ranking: 'Ranking',
              openEnded: 'Open-ended',
            },
            addAnswer: 'Add answer',
            draggableTooltip: 'You can drag items to rearrange them.',
            weight: commonLabels.weight,
            ...commonFieldValidationMessages.en,
            maxEntryLength: 'Exceeded max length of 500 characters',
            maxAnswerEntryLength: 'Exceeded maximum allowed field length.',
            invalidAnswerCount: 'Number of answers must be between 2 and 15.',
            placeholders: {
              questionTitle: 'Add question',
              questionPlaceholder: 'Write a question ...',
              answer: 'Answer',
            },
            questionActions: {
              duplicateLabel: 'Duplicate',
              deleteLabel: 'Delete',
            },
            deleteQuestionDialog: {
              ...alertDialogs.en.attributeQuestionDelete,
            },
            duplicateQuestionDialog: {
              ...alertDialogs.en.attributeQuestionDuplicate,
            },
            surveyPreview: {
              fillSurvey: { ...fillSurveyFlow.en },
              user: 'Hello User',
              fillSurveyButton: 'Fill survey',
              emailFooter: "Don't let your team melt!",
              disabledButtonTooltip:
                'Add at least one question and required people to preview the survey.',
              restart: 'Restart preview',
            },
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          maxLength: 'Exceeded max length of 150 characters',
          descriptionMaxLength: 'Exceeded max length of 2500 characters',
          emailContentMaxLength: 'Exceeded max length of 500 characters',
          isPast: 'Date is in the past',
          summaryMaxLength: 'Exceeded maximum allowed field length.',
          minReviewers: 'Required minimum 6 reviewers.',
          isEmpty: commonFieldValidationMessages.en.isEmpty,
          maxEntryLength: 'Exceeded max length of 500 characters',
          maxAnswerEntryLength: 'Exceeded maximum allowed field length.',
          invalidAnswerCount: 'Number of answers must be between 2 and 15.',
        },
      },
      sendSurveyNotificationDialog: {
        ...customDialogs.en.sendSurveyNotification,
      },
      forceCompleteDialog: { ...alertDialogs.en.surveyForceComplete },
      surveyDeleteDialog: { ...alertDialogs.en.surveyDelete },
      scheduledSurveyDeleteDialog: { ...alertDialogs.en.scheduledSurveyDelete },
      draftSurveyDeleteDialog: { ...alertDialogs.en.draftSurveyDelete },
      surveyTypeDialog: { ...customDialogs.en.surveyType },
      surveyGroupDeleteDialog: { ...alertDialogs.en.surveyGroupDelete },
      successMessages: {
        created: 'Survey is successfully created',
      },
      surveysActionBar,
      noResultsTitle: 'No Surveys yet!',
      noGroupResultsTitle: 'No Survey groups yet!',
      noGroupResultsMessage:
        'Once you create some Survey groups, they will appear on this page.',
      noResultsMessage:
        'Once you create some Surveys, they will appear on this page.',
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      groupView: {
        loadMoreButton: commonLabels.loadMore,
        createSurveyButton: 'New survey',
        actionTooltips: {
          editTitle: 'Edit group title',
          deleteGroup: 'Delete group',
          duplicateGroup: 'Duplicate group',
        },
        dragTooltip: 'You can drag groups to rearrange them.',
        surveyDragTooltip: 'You can drag surveys to rearrange them.',
      },
    },
    AttributesPage: {
      ...commonLabels,
      ...readLessMoreLabels,
      viewReport: commonLabels.viewReport,
      pageHeader: { ...pageHeader.en },
      title: 'Attributes',
      addAttribute: 'New Attribute',
      description: commonLabels.description,
      descriptionPartOne:
        'Attributes represent a certain measurable trait or' +
        ' skill of an Employee or anything else you would like to evaluate.',
      descriptionPartTwo:
        'Each Attribute is made of a number of questions. Use' +
        ' existing Attributes or create new ones, to be used in Surveys later on.',
      descriptionPartThree:
        'Attributes listed below are suggested examples that you can either use for your organization, edit them or delete.',
      loadMore: 'Load more',
      openEndedAttribute: 'Open-ended attribute',
      personalAttributeTooltip: personalAttribute.en.tooltipText,
      columns: {
        color: 'Color',
        shortName: 'Short name',
        name: 'Name',
        attributeType: 'Purpose',
        isPrivate: 'Usage',
        modifiedOn: 'Modified on',
        timesUsed: 'Times used',
        questions: 'Questions',
        actions: commonLabels.actions,
      },
      attributeTypes: { ...attributeTypes.en },
      filters: { ...filters.en },
      menuItemLabels: {
        edit: 'Edit',
        delete: 'Delete',
        duplicate: commonLabels.duplicate,
        editQuestions: 'Edit questions',
        createQuestions: 'Create questions',
        previewQuestions: 'Preview questions',
      },
      deleteAttributeDialog: { ...alertDialogs.en.attributeDelete },
      deleteUsedAttributeDialog: { ...alertDialogs.en.attributeUsedDelete },
      confirmDeleteAttributeMessageWithSurveys:
        'This attribute is included in [NUMBER] survey(s) and by deleting it information in surveys will be lost.' +
        ' Are you sure that you want to delete attribute?',
      untitledTemplate: 'Untitled template',
      okActionButton: 'Yes',
      cancelActionButton: 'Cancel',
      closeButton: 'Close',
      preview: commonLabels.preview,
      disabledDeleteMessage:
        'You are not able to delete an Attribute which is already in use. You can duplicate it' +
        ' and make the changes you need.',
      chooseNameDialog: { ...customDialogs.en.duplicateAttribute },
      previewAttributeDialog: { ...customDialogs.en.attributePreview },
      statuses: {
        active: commonLabels.active,
        inactive: commonLabels.inactive,
      },
      sectionTitleTooltipText: 'Attributes page',
      searchTooltipText: 'Use Search to find attribute',
      filtersTooltipText: 'Use Filters to narrow down your Search',
      tooltipIcon: 'Tooltip icon',
      searchPlaceholder: 'Search by name',
      addAttributeDrawerForm: {
        ...addAttributeDrawerForm.en,
        questionsForm: {
          warningIcon: 'Warning!',
          questions: 'Questions',
          archived: 'Archived',
          ...commonFieldValidationMessages.en,
          maxEntryLength: 'Exceeded max length of 500 characters',
          maxAnswerEntryLength: 'Exceeded maximum allowed field length.',
          answers: commonLabels.answers,
          ...neutralAnswer.en,
          active: commonLabels.active,
          inactive: commonLabels.inactive,
          private: commonLabels.private,
          public: commonLabels.public,
          save: commonLabels.save,
          discard: commonLabels.discard,
          weight: commonLabels.weight,
          unarchivedDisabledTooltipText:
            'This question has been used in surveys.',
          newQuestion: 'Add question',
          okActionButton: commonLabels.yes,
          placeholders: {
            questionTitle: 'Add question',
            questionPlaceholder: 'Write a question ...',
          },
          cancelActionButton: commonLabels.cancel,
          archiveQuestionDialog: {
            ...alertDialogs.en.attributeQuestionArchive,
          },
          unarchiveQuestionDialog: {
            ...alertDialogs.en.attributeQuestionUnarchive,
          },
          deleteQuestionDialog: { ...alertDialogs.en.attributeQuestionDelete },
          duplicateQuestionDialog: {
            ...alertDialogs.en.attributeQuestionDuplicate,
          },
          preview: commonLabels.preview,
          draggableTooltip: 'You can drag items to rearrange them.',
          draggableTooltipDisabled:
            'You can not drag items to rearrange them for Attribute which is' +
            ' already in use.',
          answer: 'Answer',
          questionStyleChangeDialog: {
            increaseAnswersCount: {
              ...alertDialogs.en.questionsIncreaseAnswerCount,
            },
            decreaseAnswersCount: {
              ...alertDialogs.en.questionsDecreaseAnswerCount,
            },
            toOpenEndedQuestions: {
              ...alertDialogs.en.questionsOpenEndedQuestions,
            },
            toMultipleChoiceQuestions: {
              ...alertDialogs.en.questionsMultipleChoice,
            },
            addNeutralAnswer: { ...alertDialogs.en.questionsNeutralAnswer },
            removeNeutralAnswer: {
              ...alertDialogs.en.questionsRemoveNeutralAnswer,
            },
            answerTypeChangeDialog: {
              ...alertDialogs.en.answerTypeChangeDialog,
            },
          },
          questionActions: {
            duplicateLabel: 'Duplicate',
            deleteLabel: 'Delete',
            archiveLabel: commonLabels.archive,
          },
          disabledAddQuestion:
            'You are not able to Add Question to Attribute which is already in' +
            ' use.',
          editQuestionDisabled:
            'You are not able to Edit question for Attribute which is already in' +
            ' use.',
          presetAnswers: {
            yesNo: 'Yes/No question',
            scaleSmall: '1 to 5 scale',
            scaleBig: '1 to 10 scale',
            lowMid: 'Low, Medium, High',
            lowMidDesc: 'Low, Medium, High with description',
            answerItems: {
              yesNo: ['Yes', 'No'],
              lowMid: ['Low', 'Medium', 'High'],
              lowMidDesc: ['Low', 'Medium', 'High'],
            },
          },
          updateQuestionsMessageSuccess:
            'You have updated questions successfully.',
        },
        horizontalMessageWarning:
          "Answer this long won't preview wholly in a survey. Consider changing Question Style to vertical!",
        finish: 'Finish',
      },
      noData: {
        titleActive: 'No active Attributes to show yet!',
        titleInactive: 'No inactive Attributes to show!',
        message:
          'Create your own Attributes now and make the first step towards gathering important data.',
        search: commonLabels.noSearchResultsMessage,
      },
      noResultsTitle: 'No Attributes to show yet!',
      noResultsMessage:
        'Create your own Attributes now and make the first step towards gathering important data.',
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      attributeDeleteWarningDialog: { ...warningDialogs.en.attributeDelete },
      addRecommendedLabel: 'Add recommended attributes',
      loadingImportText:
        "Attribute import is in progress. Please don't reload the page until attributes are imported.",
      attributesViewOptions: {
        active: 'Active attributes',
        inactive: 'Inactive attributes',
      },
    },
    TagsPage: {
      title: 'Tags',
      pageHeader: { ...pageHeader.en },
      description:
        'Use them for free-form grouping, and later for filtering on various pages.',
      addCategory: 'Add category',
      search: 'Search by tag',
      usedTagDeleteDialog: { ...warningDialogs.en.tagDelete },
      usedTagsDeleteDialog: { ...warningDialogs.en.tagsDelete },
      addCategoryButton: 'Add category',
      categoryDeleteDialog: { ...alertDialogs.en.tagCategoryDelete },
      tagDeleteDialog: { ...alertDialogs.en.tagDelete },
      noData: {
        noSearch: 'No results match your search criteria.',
        noCategories: {
          title: 'No categories yet!',
          message: 'Once categories are added, they will appear on this page.',
        },
      },
      categories: {
        manageTagsButton: 'Manage tags',
        noTags: {
          title: 'No tags',
          content: 'Currently, there are no tags in this category.',
          message:
            'After adding tags, this category will appear in filters menu.',
        },
        draggableTooltip: 'You can drag categories to rearrange them.',
        previewPeople: 'Preview people associated with tags in this category.',
      },
      successMessages: {
        tagCategory: {
          created: 'Tag category successfully created',
          edited: 'Tag category successfully edited',
        },
        tag: {
          saved: 'Tags successfully saved',
          edited: 'Tag successfully edited',
        },
      },
      manageCategoryForm: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'Add category',
        edit: 'Edit category',
        formLabels: {
          name: {
            label: 'Category',
            placeholder: 'Add category',
          },
          color: {
            label: 'Color',
            tooltip:
              'Add color to tags category for better optimization and overview.',
          },
          placements: {
            label: 'Filters setup',
            subtext: 'Add this category to filters menu in:',
            helpText:
              'Only category with tags will be visible in filters menu.',
          },
          organizationMenu: {
            label: 'Main menu setup',
            subtext: 'Add this category to',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          availableName: 'Name is already taken',
          maxLength: 'Exceeded 100 characters',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
        },
      },
      manageTagsForm: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        manage: 'Manage tags',
        edit: 'Edit tag',
        formLabels: {
          category: {
            label: 'Category',
          },
          name: {
            label: 'Tag',
            placeholder: 'Add tag',
          },
          users: {
            label: 'Users',
            placeholder: 'Select user(s) to assign.',
          },
        },
        validationMessages: {
          requiredTags: 'At least one tag is required',
          required: commonFieldValidationMessages.en.isEmpty,
          availableName: 'Name is already taken',
          availableNameInCategory: 'Name is already taken',
          maxLength: 'Exceeded 50 characters',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
        },
      },
    },
    TagCategoryPage: {
      title: 'Tag category',
      pageHeader: { ...pageHeader.en },
      viewAll: commonLabels.viewAll,
      viewLess: commonLabels.viewLess,
      noData: "This category doesn't have tags yet.",
      manageUsersButtonLabel: commonLabels.assignTo,
      manageTagUsersForm: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'Assign tag',
        formLabels: {
          users: {
            label: commonLabels.assignTo,
            placeholder: 'Select user(s) to assign.',
          },
        },
        successMessage: 'Successfully updated tag users.',
      },
    },
    AbsenceSettingsPage: {
      title: 'Settings',
      pageHeader: { ...pageHeader.en },
      description:
        'Configure absences, approvals, and policies for streamlined absence management.',
      addSetButton: 'New absence set',
      filters: { ...filters.en },
      systemRoles: { ...systemRoles.en },
      reportToFilter: { ...statusesFilters.en.reportToFilter },
      absenceSets: {
        remove: 'Remove',
        add: 'Add',
        deactivated: 'Deactivated user',
        addAbsenceButtonLabel: 'Add absence type',
        addHolidayLabel: 'Add holiday',
        addTypeExtension: 'New extension',
        showDays: 'Show days',
        holidays: { ...holidays.en },
        day: commonLabels.day,
        days: commonLabels.days,
        daysCountLabel: 'Number of days',
        menuItemLabels: {
          add: commonLabels.add,
          edit: commonLabels.edit,
          editTemplate: 'Edit approval document template',
          delete: commonLabels.delete,
          duplicate: commonLabels.duplicate,
        },
        rollOverExpiryDate: 'Rollover expiry date:',
        reportTooltip: 'View absence report',
        reportTooltipDisabled:
          'The absence report is only available for types with assigned users.',
      },
      accrual: 'Accrual',
      accrualOptions: { ...absenceAccrualOptions.en },
      manageHoliday: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'New holiday',
        edit: 'Edit holiday',
        formLabels: {
          name: {
            label: 'Name',
            placeholder: 'Enter holiday name',
          },
          dates: {
            label: 'Date',
            placeholder: 'Select holiday date',
            addDateButtonLabel: 'Add date',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          nameMaxLength: 'Exceeded max length of 255 characters',
          uniqueDate: 'Days must be unique.',
        },
      },
      deleteHolidayDialog: { ...alertDialogs.en.holidayDelete },
      manageAbsenceSet: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'New set',
        edit: 'Edit set',
        formLabels: {
          name: {
            label: 'Title',
            placeholder: 'Enter set title',
          },
          types: {
            label: 'Absence types',
            addAbsenceButton: 'New absence type',
            dragTooltip: 'You can drag absence types to rearrange them.',
            absenceErrorsTooltip: 'This absence type has errors!',
            formLabels: {
              name: {
                label: 'Title',
                placeholder: 'Enter absence type title',
              },
              icon: {
                label: 'Icon',
              },
              color: {
                label: 'Color',
                tooltip:
                  'This color will be used as the background for absence cards.',
              },
              hasAvailableDays: {
                label: 'Available days in one year',
                tooltipInfo:
                  'Toggle this option to switch between unlimited and limited number of days in one year.',
                disabledTooltip:
                  'Before switching off available days, remove any assigned users from extensions.',
              },
              accrual: {
                label: 'Accrual',
              },
              hasRollover: {
                label: 'Roll over',
                tooltipInfo:
                  'If turned on, any unused leave from last year will carry over to this year.',
              },
              rolloverDate: {
                label: 'Roll over balance expiration',
                tooltipInfo:
                  'Enter the starting roll over balance expiration date. The balance will automatically reset each year on the selected date.',
              },
              hasExtensions: {
                label: 'Extensions',
                labelText: 'Allow custom extensions',
                labelHelp:
                  'Check this to allow additional custom day-based extensions and assign them to eligible employees.',
                disabledTooltip:
                  'Before switching off extensions, remove any assigned users from them.',
              },
              hasTemplate: {
                label: 'Template',
                labelText: 'Enable absence approval documents',
                labelHelp:
                  'Automatically generate approval documents for approved requests of this absence type.',
              },
              hasReasons: {
                label: 'Reasons',
                labelText: 'Use predefined reasons',
                labelHelp:
                  'When enabled, this absence type uses the predefined list of reasons. When disabled, users can enter a custom reason (free text). Predefined absence type reasons can be customized via their respective edit forms.',
              },
            },
            validationMessages: {
              required: commonFieldValidationMessages.en.isEmpty,
              forbiddenCharacters:
                commonFieldValidationMessages.en.forbiddenCharacters,
              minMaxDays: 'Number of days must be greater or equal to 1.',
              nameMaxLength: 'Exceeded max length of 255 characters',
            },
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          nameMaxLength: 'Exceeded max length of 255 characters',
          availableName: 'Title is already taken.',
        },
      },
      duplicateAbsenceSet: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        edit: 'Duplicate set',
        formLabels: {
          name: {
            label: 'Title',
            placeholder: 'Enter set title',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          nameMaxLength: 'Exceeded max length of 255 characters.',
          availableName: 'Title is already taken.',
        },
      },
      manageAbsence: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'New absence type',
        edit: 'Edit absence type',
        formLabels: {
          name: {
            label: 'Title',
            placeholder: 'Enter absence type title',
          },
          icon: {
            label: 'Icon',
          },
          color: {
            label: 'Color',
            tooltip:
              'This color will be used as the background for absence type cards.',
          },
          hasAvailableDays: {
            label: 'Available days in one year',
            tooltipInfo:
              'Toggle this option to switch between unlimited and limited number of days in one year.',
            disabledTooltip:
              'Before switching off available days, remove any assigned users from extensions.',
          },
          accrual: {
            label: 'Accrual',
          },
          hasRollover: {
            label: 'Roll over',
            tooltipInfo:
              'If turned on, any unused leave from last year will carry over to this year.',
          },
          rolloverDate: {
            label: 'Roll over balance expiration',
            tooltipInfo:
              'Enter the starting roll over balance expiration date. The balance will automatically reset each year on the selected date.',
          },
          hasExtensions: {
            label: 'Extensions',
            labelText: 'Allow custom extensions',
            labelHelp:
              'Check this to allow additional custom day-based extensions and assign them to eligible employees.',
            disabledTooltip:
              'Before switching off extensions, remove any assigned users from them.',
          },
          hasTemplate: {
            label: 'Template',
            labelText: 'Enable absence approval documents',
            labelHelp:
              'Automatically generate approval documents for approved requests of this absence type.',
          },
          hasReasons: {
            label: 'Reasons',
            labelText: 'Use predefined reasons',
            labelHelp:
              'When enabled, this absence type uses the predefined list of reasons. When disabled, users can enter a custom reason (free text). Predefined absence type reasons can be customized via their respective edit forms.',
          },
          reasons: {
            label: 'Reasons',
            addButton: 'Add reason',
            disabledReasonDeleteText: 'At least one reason is required.',
            fieldLabels: {
              name: {
                placeholder: 'Enter reason',
              },
              fieldValidationMessages: {
                required: commonFieldValidationMessages.en.isEmpty,
                forbiddenCharacters:
                  commonFieldValidationMessages.en.forbiddenCharacters,
                nameMaxLength: 'Exceeded max length of 255 characters',
              },
            },
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          minMaxDays: 'Number of days must be greater or equal to 1.',
          nameMaxLength: 'Exceeded max length of 255 characters',
        },
      },
      manageAbsenceTemplate: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        edit: 'Absence approval document template',
        preview: 'Template preview',
        formLabels: {
          previewDescription: {
            label:
              'The preview updates automatically as you edit the template. Variables will be replaced with actual data when the approval document is generated.',
          },
          templateDescription: {
            label:
              'Create a custom template for absence approval documents generated for this absence type. When an absence request of this type is approved, the system will automatically generate an approval document based on this template, attach it to the approval email, and make it available for employees to download. Use variables to automatically populate employee, absence, approval, and organizational information. Variables must be written inside double curly brackets, for example: {{ first_name }}.\nVariable groups',
          },
          templateVariables: {
            groups: [
              {
                title: 'Employee information',
                values: ['{{ first_name }}', '{{ last_name }}', '{{ role }}'],
              },
              {
                title: 'Approval information',
                values: [
                  '{{ approved_at_date }}',
                  '{{ approved_by_first_name }}',
                  '{{ approved_by_last_name }}',
                ],
              },
              {
                title: 'Absence information',
                values: [
                  '{{ absence_name }}',
                  '{{ absence_from }}',
                  '{{ absence_to }}',
                  '{{ number_of_used_days }}',
                  '{{ requested_at_date }}',
                ],
              },
              {
                title: 'Organization information',
                values: ['{{ division_name }}', '{{ department_name }}'],
              },
            ],
          },
          template: {
            placeholder: 'Enter template content',
          },
        },
        validationMessages: {
          maxLength: 'Exceeded max length of 10000 characters.',
        },
      },
      manageExtension: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'New extension',
        edit: 'Edit extension',
        formLabels: {
          name: {
            label: 'Title',
            placeholder: 'Enter extension title',
          },
          description: {
            label: commonLabels.description,
            placeholder: 'Enter extension description',
          },
          numberOfDays: {
            label: 'Number of days in one year',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          minMaxDays: 'Number of days must be greater or equal to 1.',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          maxLength: 'Exceeded max length of 255 characters.',
        },
      },
      assignSetUsers: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'Remove users',
        formLabels: {
          users: {
            label: 'Users',
            noOptions: commonLabels.noResults,
            disabledUserTooltip: 'This user has leave requests.',
            ...peoplePicker.en,
          },
        },
      },
      assignAbsenceUsers: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'Remove users',
        formLabels: {
          users: {
            label: 'Users',
            disabledUserTooltip: 'This user has leave requests.',
          },
        },
      },
      assignExtensionUsers: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'Remove users',
        formLabels: {
          users: {
            label: 'Users',
          },
        },
      },
      assignUsersToSetAndAbsences: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'Assign users',
        formLabels: {
          users: {
            ...filters.en,
            noResults: 'No results',
            noResultsContent:
              'Users will appear here once they match the selected filters and are available for the selected absence category.',
          },
          types: {
            label: 'Assign people to the following absence types:',
          },
        },
        addSetUsersSuccess:
          'Users are successfully added to set and selected absence type(s).',
        addUsersToAbsenceSuccess:
          'Users are successfully added to absence type.',
        addUsersToExtensionSuccess:
          'Users are successfully added to extension.',
      },
      deleteSetDialog: { ...alertDialogs.en.absenceSetDelete },
      deleteSetDialogWarning: { ...alertDialogs.en.absenceSetDeleteWarning },
      deleteAbsenceDialog: { ...alertDialogs.en.absenceDelete },
      deleteAbsenceWarningDialog: {
        ...alertDialogs.en.absenceWarningDelete,
      },
      deleteExtensionDialog: { ...alertDialogs.en.absenceExtensionDelete },
      deleteExtensionWarningDialog: {
        ...alertDialogs.en.absenceExtensionWarningDelete,
      },
      noResults: {
        title: 'No Absence sets yet!',
        content: 'Once Absence sets are added, they will appear on this page.',
      },
      successMessages: {
        addHoliday: 'New Holiday has been added.',
        editHoliday: 'Holiday has been updated.',
        addSet: 'New Absence set has been added.',
        editSet: 'Absence set has been updated.',
        duplicateSet: 'Absence set successfully duplicated.',
        deleteSet: 'Absence set successfully deleted.',
        addSetUsers: 'Successfully updated set users.',
        addAbsence: 'Absence type has been added.',
        editAbsence: 'Absence type has been updated.',
        addTemplate: 'Absence template has been added.',
        editTemplate: 'Absence template has been updated.',
        updateAbsenceUsers: 'Successfully updated absence type users.',
        addExtension: 'Extension has been added.',
        editExtension: 'Extension has been updated.',
        addExtensionUsers: 'Successfully updated extension users.',
      },
    },
    AbsenceRequestsPage: {
      title: 'Requests',
      pageHeader: { ...pageHeader.en },
      description:
        'Manage employee time-off requests with ease. Approve, decline, and track leave balances in one place.',
      addLeaveButtonLabel: 'Add leave',
      waitingForAction: 'Waiting for action',
      search: commonLabels.search,
      filters: { ...filters.en },
      statuses: { ...statuses.en },
      all: commonLabels.all,
      loadMore: commonLabels.loadMore,
      day: commonLabels.day,
      days: commonLabels.days,
      columns: {
        for: 'For',
        createdAt: 'Request date',
        description: commonLabels.description,
        absence: commonLabels.type,
        period: 'From-To',
        status: commonLabels.status,
        approvedBy: 'Reviewers',
        actions: commonLabels.actions,
      },
      menuItems: {
        edit: commonLabels.edit,
        delete: commonLabels.delete,
        approve: commonLabels.approve,
        reject: commonLabels.reject,
      },
      noResults: {
        title: 'No leave requests yet!',
        message:
          'Once leave requests are added, they will appear on this page.',
        search: commonLabels.noSearchResultsMessage,
      },
      deleteRequestDialog: { ...alertDialogs.en.absenceRequestDelete },
      approveRequestDialog: { ...alertDialogs.en.absenceRequestApprove },
      rejectRequestDialog: { ...alertDialogs.en.absenceRequestReject },
      manageAbsenceRequest: { ...manageAbsenceRequest.en },
    },
    HeadcountReportPage: {
      title: 'Headcount report',
      pageHeader: { ...pageHeader.en },
      description:
        'Visualize headcount trends and workforce structure across the organization.',
      chartDescription:
        'Workforce trends are based on employment and termination dates when available, otherwise profile creation and deactivation dates are used.',
      filters: { ...filters.en },
      gender: 'Gender',
      age: 'Age',
      divisions: 'Divisions',
      noData: 'No data',
      tracks: 'Tracks',
      totalEmployeesTitle: 'Total Employees',
      totalEmployeesLabel: 'Employees',
      genderTitle: 'Gender',
      ageTitle: 'Age',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      headcount: 'Headcount',
      ageGroupOne: '18-24',
      ageGroupTwo: '25-34',
      ageGroupThree: '35-44',
      ageGroupFour: '45-54',
      ageGroupFive: '55+',
      dateLabel: 'To date',
      dateTooltip:
        'Displays headcount trends for the selected date and the previous 12 months.',
      overviewPlaceholders: {
        deparmentOverview: {
          partOne: 'Distributed by',
          partTwo: 'department',
          subtitle: 'Current HC distribution by department',
        },
        levelOverview: {
          partOne: 'Distributed by',
          partTwo: 'level',
          subtitle: 'Current HC distribution by level',
        },
      },
    },
    AbsenceCalendarPage: {
      title: 'Calendar',
      pageHeader: { ...pageHeader.en },
      description:
        'Easily track employee time off, sick days, vacations, and other absences with our intuitive Absence Calendar.',
      presets: { ...presets.en },
      search: commonLabels.search,
      searchByName: 'Search by name',
      filters: { ...filters.en },
      interval: { ...interval.en },
      statuses: { ...statuses.en },
      systemRoles: { ...systemRoles.en },
      noCriteriaResults:
        'No employees found. Try adjusting your search or filters.',
      noResults: 'No results',
      absenceCalendar: {
        loadMore: commonLabels.loadMore,
        employee: commonLabels.employee,
        tooltipTitle: 'Users actions',
        intervalLabel: 'Jumping interval',
        today: commonLabels.today,
      },
      absenceRequestDialog: { ...customDialogs.en.absenceRequest },
    },
    AbsenceReportPage: {
      title: 'Absence report',
      filters: {
        absenceSet: {
          label: 'Absence set',
          placeholder: 'Select absence set',
        },
        absenceType: {
          label: 'Absence type',
          placeholder: 'Select absence type',
        },
        search: {
          placeholder: 'Enter employee name',
        },
      },
      pageHeader: { ...pageHeader.en },
      description:
        'See how vacations and other time off add up from the start of the year through today—spot trends and plan coverage across teams.',
      balanceOverview: 'Balance overview',
      balanceStats: {
        available: 'Available',
        accrued: 'Accrued',
        taken: 'Taken',
        scheduled: 'Scheduled',
        totalAcrossTeam: 'Total across team',
        dayUnit: 'd',
      },
      employees: 'Employee(s)',
      tableDescription:
        'Review individual employee absence balances for the selected absence set and type.',
      noResults: 'There are no report results to display.',
      exportTooltip: 'Download report',
      exportTooltipDisabled: 'There is no report to download.',
      day: commonLabels.day,
      days: commonLabels.days,
      columns: {
        name: commonLabels.name,
        available: 'Available',
        accrued: 'Accrued',
        taken: 'Taken',
        scheduled: 'Scheduled',
      },
    },
    FillSurveyPage: {
      expiredSurveyMessage: 'The survey has ended or expired.',
      ...fillSurveyFlow.en,
    },
    ThankYouPage: {
      title: 'Thank you!',
      messagePart1: 'Thank you for submitting the survey.',
      messagePart2: 'Your response is very important to us.',
      returnToApp: 'Return to app',
      craftYourSurvey: 'Love this survey? Craft your own with',
      kadar: 'Kadar',
    },
    OrganizationPage: {
      title: 'Organizational chart',
      descriptionPartOne: 'Observe the structure of your organization.',
      descriptionPartTwo:
        'Find and take a closer look at a member by clicking on their avatar.',
      pageHeader: { ...pageHeader.en },
    },
    ActionPlansPage: {
      ...readLessMoreLabels,
      loadMore: commonLabels.loadMore,
      pageHeader: { ...pageHeader.en },
      me: commonLabels.me,
      pageTitle: 'Action plans',
      descriptionPartOne:
        'Unlock user potential and achieve goals with our comprehensive Action plans.',
      descriptionPartTwo:
        'Whether aiming for personal development, professional growth, or simply striving to be more organized, our tailored action plans provide a clear and actionable roadmap to success.',
      descriptionPartThree:
        "Customize Action plans to fit user's unique needs and objectives.",
      search: commonLabels.search,
      add: 'Add',
      all: commonLabels.all,
      delete: commonLabels.delete,
      discard: commonLabels.discard,
      save: commonLabels.save,
      confirm: 'Confirm',
      cancel: commonLabels.cancel,
      selectCourse: 'Recommended courses',
      datePlaceholder: 'Set the date',
      columns: {
        actions: commonLabels.actions,
        name: commonLabels.for,
        title: commonLabels.title,
        dueDate: commonLabels.dueDate,
        modifiedOn: commonLabels.modifiedOn,
        status: commonLabels.status,
      },
      filters: { ...filters.en },
      statuses: { ...statuses.en },
      ...commonFieldValidationMessages.en,
      addFilters: commonLabels.addFilters,
      addActionPlan: 'New action plan',
      manageActionPlan: { ...manageActionPlan.en },
      deleteActionPlanDialog: { ...alertDialogs.en.actionPlanDelete },
      dismissActionPlanProposalDialog: {
        ...alertDialogs.en.actionPlanProposalDismiss,
      },
      noJobTitle: commonLabels.noJobTitle,
      noResultsTitle: 'No Action plans yet!',
      noResultsMessage:
        'Once Action plans are added, they will appear on this page.',
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      exportTooltip: 'Export all Action plans',
      menuItemLabels: {
        edit: commonLabels.edit,
        delete: commonLabels.delete,
        manageTasks: commonLabels.manageTasks,
        dismiss: commonLabels.dismiss,
        accept: commonLabels.accept,
      },
      manageTasksDialog: { ...manageTasks.en },
      tasksIconTooltip: 'This Action plan has tasks',
      coursesIconTooltip: 'This Action plan has course',
      progressTooltip: `${commonLabels.completeness} of Action plan`,
      proposedTooltip: { ...proposedPlanTooltip.en },
      proposedStatus: commonLabels.proposed,
      actionButtons: {
        accept: commonLabels.accept,
      },
    },
    ActionPlanDetailsPage: {
      me: commonLabels.me,
      pageHeader: { ...pageHeader.en },
      statuses: { ...statuses.en },
      viewMore: 'View previous activities',
      title: 'Action plan',
      noJobTitle: commonLabels.noJobTitle,
      activity: {
        title: 'Activity',
        at: 'at',
        to: 'to ',
        labels: {
          assigned: 'Assigned this action plan to ',
          comment: 'Wrote',
          description: 'Changed description for this action plan',
          dueDate: 'Changed due date for this action plan from',
          status: 'Changed status of this action plan from',
        },
        addComment: {
          comment: {
            placeholder: 'Write a comment',
          },
          errorMessages: {
            required: 'Comment is required',
            forbiddenCharacters:
              commonFieldValidationMessages.en.forbiddenCharacters,
            maxLength: 'Exceeded max length of 1000 characters',
          },
          save: commonLabels.save,
          success: 'Comment successfully sent.',
          notifyDialog: { ...customDialogs.en.actionPointCommentNotify },
        },
        deleteCommentDialog: { ...alertDialogs.en.actionPointCommentDelete },
      },
      details: {
        title: 'Details',
        actions: {
          discard: commonLabels.discard,
          save: commonLabels.save,
        },
        noValue: commonLabels.none,
        me: commonLabels.me,
        edit: commonLabels.edit,
        dismiss: commonLabels.dismiss,
        ...actionPlan.en,
        manageActionPlan: { ...manageActionPlan.en },
        details: 'Details',
        proposedTooltip: { ...proposedPlanTooltip.en },
        comment: { ...usersComments.en },
        tasksList: {
          taskStatusDialog: { ...alertDialogs.en.taskStatusChange },
        },
        usersListTooltip: 'Who can see this action plan',
        usersListTitle: 'Users who see this action plan',
        pageContainer: { ...peoplePageContainer.en },
        notifications: { ...teamNotifications.en },
      },
      manageTasksDialog: { ...manageTasks.en },
      deleteActionPlanDialog: { ...alertDialogs.en.actionPlanDelete },
      dismissActionPlanProposalDialog: {
        ...alertDialogs.en.actionPlanProposalDismiss,
      },
      loadMore: commonLabels.loadMore,
    },
    OneOnOnePage: {
      title: '1:1 meetings',
      pageHeader: { ...pageHeader.en },
      description: 'Schedule, view, resolve and manage all 1:1 meetings.',
      addOneOnOne: 'New 1:1',
      search: commonLabels.search,
      period: {
        label: commonLabels.period,
        placeholder: 'Select period',
      },
      all: commonLabels.all,
      noResults: {
        title: 'There are no 1:1 records',
        message: "Once 1:1's are added, they will appear on this page.",
        noSearchResults: commonLabels.noSearchResultsMessage,
      },
      loadMore: commonLabels.loadMore,
      columns: {
        actions: commonLabels.actions,
        with: 'With',
        moderator: 'Organized by',
        date: 'Date',
        status: 'Status',
      },
      statuses: { ...statuses.en },
      filters: { ...filters.en },
      menuItemLabels: {
        edit: commonLabels.edit,
        delete: commonLabels.delete,
        dismiss: 'Dismiss',
        manageTasks: commonLabels.manageTasks,
      },
      addImpressionDialog: { ...customDialogs.en.addImpression },
      deleteOneOnOneRecordDialog: { ...alertDialogs.en.oneOnOneRecordDelete },
      dismissOneOnOneRequestDialog: {
        ...alertDialogs.en.oneOnOneRequestDismiss,
      },
      oneOnOneRecordDialog: { ...oneOnOneRecordDialog.en },
      successMessages: { ...manageOneOnOneMessages.en },
      actionButtons: { ...iconButtonsTooltip.en },
      recurring: commonLabels.recurring,
      tasksTooltip: 'This 1:1 has tasks',
      plansTooltip: 'This 1:1 has associated action plans',
      requested: { ...requestedOneOnOneTooltip.en },
      manageTasksDialog: { ...manageTasks.en },
    },
    OneOnOneDetailsPage: {
      title: '1:1 meeting',
      pageHeader: { ...pageHeader.en },
      details: 'Details',
      privateNote: 'Private note',
      privateNoteTooltip: 'This will be visible exclusively to you.',
      loadMore: commonLabels.loadMore,
      comment: { ...usersNotes.en },
      record: {
        edit: commonLabels.edit,
        delete: commonLabels.delete,
        manageTasks: commonLabels.manageTasks,
        manageEmployeeTopic: commonLabels.manageEmployeeTopic,
        with: 'With',
        managerAgenda: 'Manager meeting agenda',
        employeeAgenda: 'Employee meeting agenda',
        moderator: 'Organized by',
        description: 'Description',
        privateNote: 'Private note',
        impression: 'Impression',
        impressionTooltip: 'Not visible for [FULL NAME]',
        tags: commonLabels.tags,
        tasks: commonLabels.tasks,
        statuses: { ...statuses.en },
        requested: { ...requestedOneOnOneTooltip.en },
        actionButtons: { ...iconButtonsTooltip.en },
        calendar: { ...calendar.en },
        recurring: commonLabels.recurring,
        associatedPlans: 'Associated Action plans',
        tasksList: {
          taskStatusDialog: { ...alertDialogs.en.taskStatusChange },
        },
        usersListTooltip: 'Who can see this 1:1',
        usersListTitle: 'Users who see this 1:1',
        meetingNotesUsersListTooltip: 'Who can see meeting notes',
        meetingNotesUsersListTitle: 'Users who see meeting notes',
        pageContainer: { ...peoplePageContainer.en },
      },
      noPrivateNote: {
        title: 'No private note yet!',
        message: "Once it's added, it will appear here.",
      },
      meetingNotes: 'Meeting notes',
      addImpressionDialog: { ...customDialogs.en.addImpression },
      deleteOneOnOneRecordDialog: { ...alertDialogs.en.oneOnOneRecordDelete },
      deleteOneOnOneTopicDialog: { ...alertDialogs.en.oneOnOneTopicDelete },
      oneOnOneRecordDialog: { ...oneOnOneRecordDialog.en },
      manageTasks: { ...manageTasks.en },
      manageTopicForm: { ...manageTopic.en },
      successMessages: { ...manageOneOnOneMessages.en },
      notifications: { ...teamNotifications.en },
    },
    OneOnOneReportPage: {
      title: 'General mood',
      pageHeader: { ...pageHeader.en },
      descriptionPartOne:
        'Take a look at all relevant 1:1 meetings in the last six months,' +
        ' trends of general mood, impressions, and dates.',
      descriptionPartTwo:
        'Each circle on the report, represent 1 calendar week.',
      loadMore: commonLabels.loadMore,
      peoplePicker: {
        ...peoplePicker.en,
        label: commonLabels.people,
        placeholder: commonLabels.employeesName,
      },
      report: {
        employee: 'Employee',
        today: commonLabels.today,
        meetings: '1:1 meetings',
        noMeeting: 'No 1:1 this week.',
      },
      noResults: 'Select people to see report.',
      presets: { ...presets.en },
    },
    CompetenceMapPage: {
      title: 'Competence map',
      description:
        'Analyze and compare the results for a single member or' +
        ' between multiple team members for a chosen Attribute(s).',
      surveyType: 'Survey type',
      surveyTypeFilterOptions: { ...surveyTypeFilterOptions.en },
      attributes: commonLabels.attributes,
      minAttribute: 'Minimum number of selected attributes is',
      maxAttribute: 'Maximum number of selected attributes is',
      maxSelectedScores: 'Maximum number of selected scores is',
      selectedScore: 'Selected score',
      pageHeader: { ...pageHeader.en },
      range: commonLabels.period,
      personalAttributeTooltip: personalAttribute.en.tooltipText,
      noRecords: 'There are no measured Attributes in the chosen time frame.',
      noScores: 'There is no selected score to display.',
      noMatchedUsers:
        'No employees match the selected scores for the chosen attributes.',
      yAxisLabel: 'Number of employees',
      presets: { ...presets.en },
    },
    UnauthorizedAccessPage: {
      pageTitle: "You don't have permission to access this page.",
      goHome: 'Go home',
      pageHeader: { ...pageHeader.en },
    },
    CourseDetailsPage: {
      title: 'Learning',
      courseDetails: 'Course details',
      enrolledEmployees: 'Enrolled employees',
      noEnrolledEmployees:
        'There are no employees currently enrolled in this course.',
      you: '(you)',
      levels: { ...coursesLevels.en },
      status: filters.en.labels.status,
      all: commonLabels.all,
      pageHeader: { ...pageHeader.en },
      enrollUser: 'Enroll to course',
      noJobTitle: commonLabels.noJobTitle,
      enrolledUsers: 'Enrolled employees',
      enrollmentStatuses: { ...statuses.en },
      disenrollCourseDialog: { ...alertDialogs.en.courseDisenroll },
      deleteCourseDialog: { ...alertDialogs.en.courseDelete },
      courseDetailsCard: { ...courseLabels.en },
      courseActions: { ...courseActions.en },
      editCourseForm: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        edit: 'Edit course',
        formLabels: {
          title: {
            label: 'Title',
            placeholder: 'Add title',
          },
          level: {
            label: 'Course level',
          },
          tags: {
            label: 'Tags',
            placeholder: '#Tag',
            creatableOptionLabel: 'Add tag',
          },
          url: {
            label: 'Course URL',
            placeholder: 'Add URL',
          },
          description: {
            label: 'Description',
            placeholder: 'Add description',
          },
          attribute: {
            label: commonLabels.attribute,
            placeholder: 'Add attribute',
          },
          courseImage: {
            label: 'Thumbnail',
            placeholder: 'Add photo',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          invalidUrl: 'Enter a valid URL',
          titleMaxLength: 'Exceeded max length of 500 characters',
          descriptionMaxLength: 'Exceeded max length of 2500 characters',
          fileType: 'File type should be one of: jpg, png, jpeg',
          fileSize: 'Exceeded max file size of 5mb',
        },
      },
      enrollToCourseDialog: { ...customDialogs.en.enrollToCourse },
      successMessages: {
        editCourse: 'Course successfully edited',
        enroll: 'user(s) has/have been enrolled to this course.',
        status: 'Status has been updated successfully.',
      },
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
    },
    AnnouncementsPage: {
      title: 'Announcements',
      pageTitle: 'Announcements',
      description:
        'Stay informed — company updates, legal notices, and team news in one place.',
      pageHeader: { ...pageHeader.en },
      announcements: 'announcements',
      categories: {
        SOCIAL: {
          title: 'Social',
          countLabel: '[COUNT] announcements',
          description:
            'Team events, celebrations, offsite recaps, and culture moments from across the company.',
          noAnnouncements: {
            title: 'No announcements yet',
            content:
              'New updates in this category will appear here once they are published.',
          },
        },
        NEWS: {
          title: 'News',
          countLabel: '[COUNT] announcements',
          description:
            'Company milestones, strategic moves, product launches, and leadership updates.',
          noAnnouncements: {
            title: 'No announcements yet',
            content:
              'New updates in this category will appear here once they are published.',
          },
        },
        LEGAL: {
          title: 'Legal',
          countLabel: '[COUNT] announcements',
          description:
            'Policy updates, compliance notices, contract changes, and regulatory communications.',
          noAnnouncements: {
            title: 'No announcements yet',
            content:
              'New updates in this category will appear here once they are published.',
          },
        },
        GENERAL: {
          title: 'General',
          countLabel: '[COUNT] announcements',
          description:
            "HR policy changes, benefits updates, IT notices, and everything that doesn't fit a specific category.",
          noAnnouncements: {
            title: 'No announcements yet',
            content:
              'New updates in this category will appear here once they are published.',
          },
        },
      },
    },
    AnnouncementCategoryPage: {
      title: '',
      pageHeader: { ...pageHeader.en },
      parentTitle: 'Announcements',
      newAnnouncement: 'New announcement',
      noResults: 'No announcements in this category yet.',
      categories: {
        SOCIAL: {
          title: 'Social',
          description:
            'Team events, celebrations, offsite recaps, and culture moments from across the company.',
        },
        NEWS: {
          title: 'News',
          description:
            'Company milestones, strategic moves, product launches, and leadership updates.',
        },
        LEGAL: {
          title: 'Legal',
          description:
            'Policy updates, compliance notices, contract changes, and regulatory communications.',
        },
        GENERAL: {
          title: 'General',
          description:
            "HR policy changes, benefits updates, IT notices, and everything that doesn't fit a specific category.",
        },
      },
      card: {
        createdBy: commonLabels.createdBy,
        publishedBy: 'Published by',
        unpublished: 'Unpublished',
        downloadFile: 'Download file',
        menuItems: {
          edit: commonLabels.edit,
          publish: 'Publish',
          unpublish: 'Unpublish',
          delete: commonLabels.delete,
        },
      },
      deleteAnnouncementDialog: { ...alertDialogs.en.announcementDelete },
      announcementForm: {
        add: 'New announcement',
        edit: 'Edit announcement',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        addSuccess: 'Announcement successfully created.',
        editSuccess: 'Announcement successfully updated.',
        publishSuccess: 'Announcement successfully published.',
        unpublishSuccess: 'Announcement successfully unpublished.',
        formLabels: {
          title: {
            label: 'Title',
            placeholder: 'Enter title',
          },
          description: {
            label: 'Description',
            placeholder: 'Enter announcement description',
          },
          published: {
            label: 'Publish',
            description:
              'When enabled, the announcement will be publicly visible after saving.',
          },
          uploadFile: {
            label: 'Attachment',
            placeholder: 'Upload file',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          titleMaxLength: 'Exceeded max length of 255 characters.',
          descriptionMaxLength: 'Exceeded max length of 10000 characters.',
          fileType: 'File type should be one of: pdf, doc, docx, csv',
          fileLength: 'File should have maximum 100 characters.',
          fileSize: 'Exceeded max file size of 5mb',
        },
      },
    },
    CoursesPage: {
      title: 'Learning hub',
      pageDescriptionOne:
        'Library of all courses that are used in this organization.',
      pageDescriptionTwo:
        'Enroll employees to specific Courses and keep track of who is' +
        ' learning what.',
      pageDescriptionThree:
        'Start building your organization library by adding new courses from eLearning platforms.',
      readLessMore: { ...readLessMoreLabels },
      pageHeader: { ...pageHeader.en },
      noJobTitle: commonLabels.noJobTitle,
      addCourse: 'New course',
      search: commonLabels.search,
      usersEnrolledMessage: 'user(s) has been enrolled to this course.',
      levels: { ...coursesLevels.en },
      courseLabels: { ...courseLabels.en },
      all: commonLabels.all,
      filters: { ...filters.en },
      addCourseForm: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        add: 'Add course to library',
        edit: 'Edit course',
        formLabels: {
          title: {
            label: 'Title',
            placeholder: 'Add title',
          },
          level: {
            label: 'Course level',
          },
          tags: {
            label: 'Tags',
            placeholder: '#Tag',
            creatableOptionLabel: 'Add tag',
          },
          url: {
            label: 'Course URL',
            placeholder: 'Add URL',
          },
          description: {
            label: 'Description',
            placeholder: 'Add description',
          },
          attribute: {
            label: commonLabels.attribute,
            placeholder: 'Add attribute',
          },
          courseImage: {
            label: 'Thumbnail',
            placeholder: 'Add photo',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          invalidUrl: 'Enter a valid URL',
          titleMaxLength: 'Exceeded max length of 500 characters',
          uniqueTitle: 'Title should be unique.',
          descriptionMaxLength: 'Exceeded max length of 2500 characters',
          fileType: 'File type should be one of: jpg, png, jpeg',
          fileSize: 'Exceeded max file size of 5mb',
        },
      },
      courseActions: { ...courseActions.en },
      deleteCourseDialog: { ...alertDialogs.en.courseDelete },
      successMessages: {
        addCourseSuccess: 'New course has been successfully added.',
        editCourse: 'Course successfully edited',
        completed: 'Course successfully completed',
      },
      noResultsTitle: 'No courses in the library yet!',
      noResultsMessage:
        'Add courses and enable users to jump into the learning journey.',
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      addRecommendedLabel: 'Add recommended courses',
      loadingImportText:
        "Course import is in progress. Please don't reload the page until courses are imported.",
    },
    PeopleCoursesPage: {
      pageContainer: { ...peoplePageContainer.en },
      pageHeader: { ...pageHeader.en },
      pageDescription: 'View all courses enrolled for this team member.',
      descriptionOwnProfile: 'View all courses assigned to you.',
      enrollEmployeeToMoreCourses: 'Enroll to courses',
      noResultsTitle: "This user hasn't been enrolled in any course yet.",
      noResultsMessage:
        "As soon as enrolling occurs, you'll see the list of courses here.",
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      search: commonLabels.search,
      levels: { ...coursesLevels.en },
      all: commonLabels.all,
      enrollmentStatuses: { ...statuses.en },
      courseLabels: { ...courseLabels.en },
      courseActions: { ...courseActions.en },
      ...commonFieldValidationMessages.en,
      enrollCourseDialog: { ...customDialogs.en.enrollCourse },
      disenrollDialog: { ...alertDialogs.en.courseDisenroll },
      filters: { ...filters.en },
      successMessages: {
        enrolled: 'User has been enrolled to new course.',
        status: 'Status has been updated successfully.',
      },
      disabledEnrollActionTooltip: "Can't enroll deactivated user.",
    },
    PrivateNotesPage: {
      ...readLessMoreLabels,
      noJobTitle: commonLabels.noJobTitle,
      loadMore: commonLabels.loadMore,
      pageHeader: { ...pageHeader.en },
      title: 'My private notes',
      subtitle: 'Only you can see your private notes',
      noResultsTitle: 'No Private notes yet!',
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      noResultsMessage:
        'Once you add your Private notes, they will appear on this page.',
      descriptionSections: {
        first:
          'Private notes are visible only to person that created them - that is: currently logged in user.',
        second:
          'No other user of the application can view private notes that someone else has created.',
        third:
          'This page shows cumulative, all private notes you have written for various people in organization.',
        fourth: "Go to a person's specific Profile page to add/delete them.",
      },
      filters: {
        dateRangeLabel: 'Period',
      },
      item: {
        about: 'About',
      },
      noteDeleteDialog: { ...alertDialogs.en.noteDelete },
      manageNotesDialog: { ...noteDialog.en },
      note: { ...note.en },
    },
    SkillsMatrixPage: {
      title: 'Skills matrix',
      pageHeader: { ...pageHeader.en },
      noJobTitle: commonLabels.noJobTitle,
      filters: {
        surveyType: {
          label: 'Survey type',
          placeholder: 'Select survey type',
        },
        range: 'Period',
        attributes: 'Attributes',
        measuredAttributes: 'Measured attributes',
        minAttribute: 'Minimum number of selected attributes is',
        maxAttribute: 'Maximum number of selected attributes is',
        attributeNoSurveyed:
          'There are no measured Attributes for selected people in the chosen time frame.',
        attributeNoQuantitativeData:
          'There are no quantitative Attributes data for selected people in' +
          ' the' +
          ' chosen time frame.',
        peoplePicker: {
          ...peoplePicker.en,
          label: commonLabels.people,
          placeholder: commonLabels.employeesName,
        },
        presets: { ...presets.en },
      },
      noSelectedUsers: 'Select employees to see report.',
      surveyTypeFilterOptions: { ...surveyTypeFilterOptions.en },
      compareWidget,
    },
    ReleaseNotesPage: {
      title: 'Release notes',
      pageHeader: { ...pageHeader.en },
      version: 'Version',
      releaseNote: 'Release note',
      latest: 'Latest',
      publishedDate: 'Published date',
    },
    OrganizationSettingsFeaturesPage: {
      title: 'Organization settings',
      name: 'Organization name',
      description:
        'Toggle Features on or off to instantly update available functionality for all users across the platform.',
      pageHeader: { ...pageHeader.en },
      required: commonFieldValidationMessages.en.isEmpty,
      navigationItems: { ...organizationSettingsNavigation.en },
      absenceTracking: {
        label: 'Absence Tracking',
        description:
          "Organization-wide absence overview. When enabled, it's visible to all roles. When disabled, no one sees it.",
      },
      absenceNotifications: {
        label: 'Email notifications for absence requests',
        description:
          'Email will be sent to users who can decide on a leave request when absence request is created, updated or canceled and to user who requested it when request is approved or denied.',
      },
      absenceTrackingDoubleApprove: {
        label: 'Absence Tracking double approve ',
        disabledTooltip: 'Absence tracking must be enabled first.',
        description:
          'Can be enabled only with enabled absence tracking. When enabled, double approve is needed for absence request.',
      },
      recruitment: {
        label: 'Recruitment',
        description:
          "Organization-wide recruitment process overview. When enabled, it's visible to all roles except Users. When disabled, no one sees it.",
      },
      learningHub: {
        label: 'Learning Hub',
        description:
          "Organization-wide visible learning courses. When enabled, it's visible to all roles. When disabled, no one sees it.",
      },
      succession: {
        label: 'Succession (BETA)',
        description: 'Organization-wide succession planning.',
      },
      twoFactorAuthentication: {
        label: 'Require 2FA for all users',
        description: `When enabled, all users must use 2FA. Users won't be able to disable it individually.`,
      },
      submit: commonLabels.save,
      defaultAbsenceSetDialog: { ...customDialogs.en.defaultAbsenceSet },
      settingSavedMessage:
        'Organization settings has been updated successfully.',
    },
    OrganizationSettingsPermissionsPage: {
      title: 'Organization settings',
      name: 'Organization name',
      pageHeader: { ...pageHeader.en },
      descriptionPartOne:
        'Map permissions to Main Roles (Admin, Moderator, Employee) and Additional Roles.',
      descriptionPartTwo:
        'Main Roles set baseline access. Additional Roles grant granular permissions over specific employee groups (e.g. HRBP).',
      manageAdditionalRoles: 'Manage additional roles',
      manageAdditionalRolesForm: {
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        title: 'Manage additional roles',
        formLabels: {
          additionalRoles: {
            addAdditionalRole: 'Add additional role',
            placeholder: 'Additional role name',
            dragTooltip: 'Drag to reorder roles.',
            deleteTooltip: 'Delete role',
            reloadTooltip: 'Undo role delete',
            validationMessages: {
              required: commonFieldValidationMessages.en.isEmpty,
              maxRoleLength: 'Exceeded max length of 150 characters.',
              forbiddenCharacters:
                commonFieldValidationMessages.en.forbiddenCharacters,
            },
          },
        },
        validationMessages: {},
      },
      navigationItems: { ...organizationSettingsNavigation.en },
      systemRoles: { ...systemRoles.en },
      permissionsGroups: { ...permissionsGroups.en },
      permissionScopes: {
        global: {
          label: 'Global',
          tooltip: 'Global scope',
        },
        self: {
          label: 'Self',
          tooltip: 'Self scope',
        },
        directReports: {
          label: 'DR',
          tooltip: 'Direct reports scope',
        },
        indirectReports: {
          label: 'IDR',
          tooltip: 'Indirect reports scope',
        },
        custom: {
          label: 'Custom',
          tooltip: 'Custom scope',
        },
      },
      permissionMatrix: {
        modules: 'Modules',
        scopeLegendTitle: 'Scopes',
        scopeLegend: [
          { name: 'Global', description: 'Global' },
          { name: 'Self', description: 'Self' },
          { name: 'DR', description: 'Direct reporters' },
          { name: 'IDR', description: 'Indirect reporters' },
          { name: 'Custom', description: 'Custom employee scope' },
        ],
        scopeSettingsTooltip: {
          default: 'Expand scope settings',
          expanded: 'Collapse scope settings',
          disabled:
            'Scope settings are disabled because the View permission is partially enabled.',
        },
        expandableScope: {
          label: 'Self / DR / IDR',
          tooltip: 'Self / Direct reports / Indirect reports',
        },
        globalScope: {
          label: 'Global',
          tooltip: 'Global',
        },
        permissionCheckboxTooltip: '[ROLE] — scope: [SCOPE].',
      },
    },
    OrganizationSettingsDocumentsPage: {
      title: 'Organization settings',
      pageHeader: { ...pageHeader.en },
      description:
        'Manage document categories and define which document types are mandatory or available for employee self-upload.',
      navigationItems: { ...organizationSettingsNavigation.en },
      edit: commonLabels.edit,
      subtitle: 'Documents',
      addCategory: 'Add Category',
      nameLabel: 'Category and document type',
      mandatoryLabel: 'Mandatory',
      selfUploadLabel: 'Self upload',
      expiryDateLabel: 'Expiry date',
      noResults: {
        title: 'No added category and document type',
        content: 'Start by adding category using Add Category.',
      },
      categoryDeleteDialog: { ...alertDialogs.en.categoryDelete },
      categoryForm: {
        add: 'Add category',
        edit: 'Edit category',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        formLabels: {
          name: {
            label: 'Name',
            placeholder: 'Name of the category',
          },
          notifyBefore: {
            label: 'Notify before expiry',
            placeholder: 'Select period',
            options: {
              oneWeek: '1 week before',
              oneMonth: '1 month before',
              twoMonths: '2 months before',
            },
          },
          subtitle: {
            label: 'Document types',
          },
          documentTypes: {
            addFieldButton: 'Add document type',
            deleteDocumentDialog: {
              ...alertDialogs.en.documentTypeFieldDelete,
            },
            field: {
              headers: {
                documentTypeLabel: 'Document type',
                mandatoryLabel: 'Mandatory',
                selfUploadLabel: 'Self upload',
                expiryDateLabel: 'Expiry date',
              },
              documentName: {
                placeholder: 'Add document type',
              },
              validationMessages: {
                required: commonFieldValidationMessages.en.isEmpty,
                maxLength: 'Maximum length is 128 characters.',
                forbiddenCharacters:
                  commonFieldValidationMessages.en.forbiddenCharacters,
              },
            },
            validationMessages: {
              required: commonFieldValidationMessages.en.isEmpty,
            },
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          maxLength: 'Exceeded max length of 128 characters.',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
        },
      },
      successMessages: {
        createdCategory: 'Document category is successfully saved.',
        updatedCategory: 'Document category is successfully updated.',
      },
    },
    PeopleInfoSettingsPage: {
      title: 'Organization settings',
      pageHeader: { ...pageHeader.en },
      description:
        'Manage people information and define which information is mandatory, editable or sensitive.',
      navigationItems: { ...organizationSettingsNavigation.en },
      edit: commonLabels.edit,
      subtitle: 'People information',
      nameLabel: 'Name',
      visibleLabel: 'Visible',
      editableLabel: 'Editable',
      sensitiveLabel: 'Sensitive',
      categories: {
        employmentInformation: 'Employment information',
        personalInformation: 'Personal information',
      },
      userFieldSettingsForm: {
        add: 'Edit people information',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        formLabels: {
          infoFields: {
            categories: {
              employmentInformation: 'Employment information',
              personalInformation: 'Personal information',
            },
            field: {
              headers: {
                nameLabel: 'Name',
                visibleLabel: 'Visible',
                sensitiveLabel: 'Sensitive',
              },
              infoName: {
                label: 'Name',
                placeholder: 'Add name',
              },
              isVisible: {
                label: 'Is visible',
              },
              isSensitive: {
                label: 'Is sesitive',
              },
            },
          },
        },
      },
      successMessages: {
        updatedInformation: 'People information is successfully updated.',
      },
    },
    UpgradeRequired: { ...customDialogs.en.upgradeRequired },
    StarterPlan: { ...customDialogs.en.starterPlan },
    SlackIntegrationPage: {
      title: 'Slack integration',
      description:
        'Slack makes it easy to quickly find, share and act on information across your tech stack by creating one central place to stay focused and get work done.',
      pageHeader: { ...pageHeader.en },
      connect: 'Connect Kadar with Slack',
      disconnect: 'Disconnect',
      notConnected: 'Not connected',
      connected: 'Connected',
      organization: commonLabels.organization,
      systemRoles: { ...systemRoles.en },
      app: commonLabels.app,
      import: {
        syncLabel: 'Slack users',
        descriptionPartOne: 'Users not found in Kadar.',
        descriptionPartTwo: 'Click the button to start importing.',
        buttonLabel: 'Import from Slack',
        noData: {
          title: 'No data',
          content: 'There are no users to import.',
        },
      },
      deactivate: {
        syncLabel: 'Deactivate Kadar users',
        descriptionPartOne: 'Users not active in Slack.',
        descriptionPartTwo: 'Click the button to deactivate them in Kadar.',
        buttonLabel: 'Deactivate',
        noData: {
          title: 'No data',
          content: 'There are no deactivated users.',
        },
      },
      deactivateUsersDialog: { ...customDialogs.en.deactivateUsers },
      retryButtonLabel: 'Retry',
      importSlackUsersTable: {
        add: 'Import from Slack',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        description:
          'Add users by entering required data. By default, new users are not invited to join. If you want to invite them right away, click on the checkbox.',
        formLabels: {
          firstName: {
            label: 'First name',
          },
          lastName: {
            label: 'Last name',
          },
          email: {
            label: commonLabels.email,
          },
          reportingTo: {
            label: 'Reporting to',
            noOptions: 'No options',
          },
          role: {
            label: 'Role',
          },
          invite: {
            label: 'Invite',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          invalidEmail: 'Email is invalid',
          exceededLengthEmail: 'Maximum length is 100 characters',
          availableEmail: validationMessages.en.email.isAvailable,
          duplicatedEmail: validationMessages.en.email.isUnique,
          minLength: validationMessages.en.firstName.minLength,
          maxLength: validationMessages.en.firstName.maxLength,
          invalidName: validationMessages.en.firstName.invalid,
          freemiumLimit: commonFieldValidationMessages.en.freemium,
        },
      },
      success: {
        import: 'Slack users successfully added.',
        sync: 'Slack users successfully synced.',
      },
      timeLabels: {
        today: commonLabels.today,
        yesterday: commonLabels.yesterday,
        days: commonLabels.days,
        ago: commonLabels.ago,
      },
    },
    PricingPlansPage: {
      pageHeader: { ...pageHeader.en },
      title: 'Plans & Pricing',
      plans: {
        starter: {
          name: 'Starter',
          description: 'The foundation you need to get started, free forever.',
          price: '$0',
          priceDescription: '/forever',
          subscribeButton: {
            default: 'Starter plan',
            current: 'Current plan',
          },
          features: [
            {
              text: '1x admin',
              tooltip:
                'Admins have full access to all features, including billing and user management.',
            },
            {
              text: '2x managers',
              tooltip:
                'Managers have access to all team management features allowing them to lead their team. They don’t have access to billing and organizational features.',
            },
            {
              text: 'Unlimited employees',
              tooltip:
                'User roles for your employees. They have access to their own profile, personal growth plans, they can collaborate with their manager, and they can see publicly shared organizational updates.',
            },
            {
              text: 'Unlimited external associates',
              tooltip:
                'Invite external collaborators to give feedback without paying for extra seats.',
            },
            {
              text: '30x action plans',
              tooltip:
                'Outline goals employees need to achieve for job promotions and higher salaries. Track their progress, measure both hard and soft skills.',
            },
            {
              text: '50x 1:1 meetings',
              tooltip:
                'Create a structured process for your 1:1s, ensuring focused, productive meetings that move things forward.',
            },
            {
              text: '1x leveling framework',
              tooltip:
                'Create custom development frameworks for every team and help your employees grow with your company.',
            },
            {
              text: '30x surveys',
              tooltip:
                'Collect real-time data for a deep understanding of employee engagement. Types of surveys: self-assessments, direct review, team review, peer review, and company pulse.',
            },
            {
              text: '50x attributes',
              tooltip:
                'Set both hard and soft skills you want to benchmark your employees against.',
            },
            {
              text: '100x courses',
              tooltip:
                'Customized learning hub and courses at both team and individual levels.',
            },
            {
              text: '30x job descriptions',
              tooltip:
                'Your company’s directory with all the job titles and their descriptions.',
            },
            {
              text: 'Unlimited absence sets',
              tooltip:
                'Track vacations, sick leave, parental leave and other time off with organization-wide leave policies.',
            },
          ],
        },
        growth: {
          name: 'Growth',
          description:
            'Everything growing teams need to manage people at scale.',
          price: '$4',
          priceDescription: '/user/month',
          subscribeButton: {
            default: 'Subscribe',
            current: 'Current plan',
          },
          features: [
            {
              text: 'Unlimited admins',
              tooltip:
                'Admins have full access to all features, including billing and user management.',
            },
            {
              text: 'Unlimited managers',
              tooltip:
                'Managers have access to all team management features allowing them to lead their team. They don’t have access to billing and organizational features.',
            },
            {
              text: 'Unlimited employees',
              tooltip:
                'User roles for your employees. They have access to their own profile, personal growth plans, they can collaborate with their manager, and they can see publicly shared organizational updates.',
            },
            {
              text: 'Unlimited external associates',
              tooltip:
                'Invite external collaborators to give feedback without paying for extra seats.',
            },
            {
              text: 'Unlimited action plans',
              tooltip:
                'Outline goals employees need to achieve for job promotions and higher salaries. Track their progress, measure both hard and soft skills.',
            },
            {
              text: 'Unlimited 1:1 meetings',
              tooltip:
                'Create a structured process for your 1:1s, ensuring focused, productive meetings that move things forward.',
            },
            {
              text: 'Unlimited leveling frameworks',
              tooltip:
                'Create custom development frameworks for every team and help your employees grow with your company.',
            },
            {
              text: 'Unlimited surveys',
              tooltip:
                'Collect real-time data for a deep understanding of employee engagement. Types of surveys: self-assessments, direct review, team review, peer review, and company pulse.',
            },
            {
              text: 'Unlimited attributes',
              tooltip:
                'Set both hard and soft skills you want to benchmark your employees against.',
            },
            {
              text: 'Unlimited courses',
              tooltip:
                'Customized learning hub and courses at both team and individual levels.',
            },
            {
              text: 'Unlimited job descriptions',
              tooltip:
                'Your company’s directory with all the job titles and their descriptions.',
            },
            {
              text: 'Unlimited absence sets',
              tooltip:
                'Track vacations, sick leave, parental leave and other time off with organization-wide leave policies.',
            },
          ],
        },
        enterprise: {
          name: 'Enterprise',
          description: 'Custom HR solutions with dedicated priority support.',
          price: 'Custom',
          subscribeButton: {
            default: 'Book 1:1 call',
          },
          featureTitle: 'All in Growth, plus:',
          features: [
            {
              text: 'Custom integrations',
              tooltip:
                'Custom integrations with other tools in your HR stack that make your life simpler.',
            },
            {
              text: 'Dedicated AM',
              tooltip:
                "You'll have a dedicated Kadar expert for your account to help you and hop on a call whenever you need.",
            },
            {
              text: 'Priority support',
              tooltip:
                "Whenever you run into trouble and need our help, we'll prioritize your inquiries.",
            },
          ],
        },
      },
    },
    LevelingPage: {
      title: 'Levels and tracks',
      description: {
        admin:
          'Here you can add, edit or delete tracks and levels. Customize them to represent your organization and teams.',
        read: 'Here you can view the leveling system in your organization.',
      },
      openEndedAttribute: 'Open-ended attribute',
      currencies: { ...levelingCurrencies.en },
      pageHeader: { ...pageHeader.en },
      noJobTitle: commonLabels.noJobTitle,
      addTemplateButton: 'Add template',
      levelingAgent: {
        openLevelingAgentButtonLabel: 'Kadar AI',
        assistant: 'Assistant',
        title: 'Kadar AI',
        placeholder:
          'Ask Kadar AI to help you design or refine a leveling framework.',
        emptyMessages:
          'No messages yet. Your conversation with Kadar AI will appear here.',
        stopTooltip: 'Stop',
        sendTooltip: commonLabels.send,
        reasoning: {
          label: 'Thinking',
        },
        tools: {
          markDiscoveryComplete: 'mark_discovery_complete',
          generateLevelFramework: 'generate_level_framework',
          suggestCompetencies: 'suggest_competencies',
          validateLevelStructure: 'validate_level_structure',
          listFrameworks: 'list_frameworks',
          listDepartments: 'list_departments',
          listDivisions: 'list_divisions',
          listLevels: 'list_levels',
          exportFramework: 'export_leveling_framework',
          createFramework: 'create_full_framework',
          createTrack: 'create_track',
          createLevel: 'create_level',
          updateLevel: 'update_level',
          deleteLevel: 'delete_level',
          status: {
            running: 'Running',
            completed: 'Completed',
            failed: 'Failed',
          },
        },
      },
      tableLabels: {
        level: 'Level',
        addLevelButtonLabel: 'New level',
        addTrackButtonLabel: 'New track',
      },
      levelingTypeDialog: { ...customDialogs.en.levelingType },
      levelingTypes: { ...levelingTypes.en },
      addTemplate: {
        save: 'Use Template',
        cancel: commonLabels.cancel,
        add: 'Templates',
        formLabels: {
          preview: {
            noSelection: {
              title: 'Best Leveling Templates',
              content:
                "Creating leveling frameworks from scratch can be tough—we're here to help! On the left, you’ll find a curated collection of leveling templates from top companies. Whether you want to adapt them to align with your organization or use them as-is, these templates are designed to make the process smoother and more efficient.",
            },
            preview: {
              attributes: commonLabels.attributes,
              range: commonLabels.range,
              people: commonLabels.people,
            },
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          isAlreadyChosen: 'This template has already been chosen.',
        },
      },
      deleteTemplateDialog: { ...alertDialogs.en.deleteLevelingTemplate },
      deleteFrameworkDialog: { ...alertDialogs.en.levelingFrameworkDelete },
      deleteTrackDialog: { ...alertDialogs.en.levelingTrackDelete },
      deleteLevelDialog: { ...alertDialogs.en.levelingLevelDelete },
      editLevelingTemplate: { ...alertDialogs.en.editLevelingTemplate },
      successMessages: {
        addTemplate: 'Leveling system successfully added.',
        editTemplate: 'Leveling system successfully updated.',
        frameworkSaved: 'Framework name is successfully saved.',
        frameworkUpdated: 'Framework name is successfully updated.',
        trackSaved: 'Track name is successfully saved.',
        trackUpdated: 'Track name is successfully updated.',
        levelUpdated: 'Level data is successfully updated.',
        levelSaved: 'Level data is successfully saved.',
        trackDeleted: 'Track is successfully deleted.',
        frameworkDeleted: 'Framework is successfully deleted.',
        levelDeleted: 'Level is successfully deleted.',
        assignedUsersToLevel: 'Users are successfully assigned.',
        moveTrack: 'Track is successfully moved.',
        moveLevel: 'Level is successfully moved.',
        duplicateLevel: 'Level is successfully duplicated.',
        duplicateTrack: 'Track is successfully duplicated.',
        duplicateFramework: 'Framework is successfully duplicated.',
        updatedSalaryRange: 'Salaries are successfully saved.',
      },
      noResults: {
        title: 'No Leveling system yet!',
        content:
          'Start from templates, choose one and edit it to fit your needs, or just start from scratch!',
      },
      frameworkGroupView: {
        delete: commonLabels.delete,
        editSalaries: 'Edit salaries',
        edit: commonLabels.edit,
        move: commonLabels.move,
        duplicate: commonLabels.duplicate,
        loadMoreButton: commonLabels.loadMore,
        attributes: 'Ranged attributes',
        range: commonLabels.range,
        people: commonLabels.people,
        templateSubtitle:
          'Templates based on good examples of the leveling frameworks.',
        track: 'Track',
        level: 'Level',
        createFrameworkButton: 'New Framework',
        createTrackButton: 'New Track',
        createLevelButton: 'New Level',
        salaryRange: 'Salary range',
        frameworkDragTooltip: 'You can drag frameworks to rearrange them.',
        trackDragTooltip: 'You can drag tracks to rearrange them.',
        levelDragTooltip: 'You can drag levels to rearrange them.',
        duplicateFramework: {
          ...frameworkForm.en,
          edit: 'Duplicate Framework',
        },
        moveOrDuplicate: {
          ...frameworkForm.en,
          add: '[LABEL] [RECORD TYPE]',
        },
        addFramework: {
          ...frameworkForm.en,
          add: 'Add Framework',
          edit: 'Edit Framework',
        },
        addTrack: {
          ...frameworkForm.en,
          add: 'Add Track',
          edit: 'Edit Track',
        },
        addLevel: {
          ...frameworkForm.en,
          add: 'Add Level',
          edit: 'Edit Level',
        },
        assignUsersToLevel: {
          ...frameworkForm.en,
          add: 'Assign users to level',
          assignLabel: 'Assign users',
        },
        addSalaries: {
          ...frameworkForm.en,
          add: 'Add salaries',
          edit: 'Edit salaries',
        },
      },
    },
    TimeToHireReportPage: {
      title: 'Time to hire report',
      pageHeader: { ...pageHeader.en },
      description: 'Analytics overview for your hiring pipeline',
      periodLabel: 'Period',
      departmentChartTitle: 'Time to Hire by Department',
      recruiterChartTitle: 'Time to Hire by Recruiter',
      recruiterChartNote: '*Recruiter data is based on job creator.',
      jobChartTitle: 'Time to Hire by Job',
      recruiterSelectLabel: 'Recruiters',
      jobSelectLabel: 'Jobs',
      recruiterSelectPlaceholder: 'Select recruiters',
      jobSelectPlaceholder: 'Select jobs',
      hiresLegendLabel: 'Number of hired candidates',
      candidatesLegendLabel: 'Number of candidates',
      daysLegendLabel: 'Time to hire (days)',
      daysSuffix: 'days',
      employeesSuffix: 'employees',
      averageTimeToHireLabel: 'Average Time to Hire',
      medianTimeToHireLabel: 'Median Time to Hire',
      totalHiresLabel: 'Total Hires',
      noResultsForPeriod: 'No results for selected period',
      periodOptions: {
        last90Days: 'Last 90 days',
        last30Days: 'Last 30 days',
        last180Days: 'Last 180 days',
        last365Days: 'Last 365 days',
      },
    },
    JobsPage: {
      title: 'Jobs',
      pageHeader: { ...pageHeader.en },
      createNewButtonLabel: 'Create new job',
      viewJobPostingLabel: 'Details',
      all: commonLabels.all,
      department: commonLabels.department,
      dropdownMenuLabel: 'Add candidates',
      search: commonLabels.search,
      loadMore: commonLabels.loadMore,
      archiveJobDialog: { ...alertDialogs.en.jobArchive },
      unarchiveJobDialog: { ...alertDialogs.en.jobUnarchive },
      deleteJobDialog: { ...alertDialogs.en.jobDelete },
      duplicateJobDialog: { ...alertDialogs.en.jobDuplicate },
      hiringTeamLabel: 'Hiring team',
      recruitmentStepsLabel: 'Steps',
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      disabledAddCandidateAction: 'Add steps to enable adding candidates.',
      noResults: 'There are no jobs to display',
      unarchive: commonLabels.unarchive,
      duplicate: commonLabels.duplicate,
      details: 'Details',
      delete: commonLabels.delete,
      separator: '·',
      createdOnLabel: 'Created on',
      createdByLabel: 'Created by',
      totalCandidatesLabel: 'Total Candidates',
      activeCandidatesLabel: 'Active Candidates',
      lastActivityLabel: 'Last Activity',
      menuItemLabels: {
        edit: commonLabels.edit,
        duplicate: commonLabels.duplicate,
        archive: commonLabels.archive,
        delete: commonLabels.delete,
      },
      viewOptions: {
        active: 'Active jobs view',
        archived: 'Archived jobs view',
      },
      candidateMenuItemLabels: {
        upload: 'Upload cv',
        uploadMultiple: 'Upload multiple cvs',
        addXls: 'Add xls file',
        addExistingCandidate: 'Add existing',
        addCandidate: 'Add manually',
      },
      addCandidatesManually: { ...addCandidatesManually.en },
      addCandidatesUsingCv: { ...addCandidatesUsingCv.en },
      workspace: { ...jobWorkspace.en },
      successMessages: {
        jobSaved: 'New job is successfully created.',
        jobUpdated: 'Job is successfully updated.',
        hiringTeamSaved: 'Selected hiring team is successfully saved.',
        existingCandidatesSaved:
          'Selected candidates are successfully added to job.',
        stepSelectionSaved: 'Step selection is successfully saved.',
        candidateSaved: 'Candidate is successfully saved.',
        duplicateSuccess: 'Job is successfully duplicated.',
      },
      manageHiringTeam: { ...manageHiringTeam.en },
      manageAddExistingCandidates: { ...manageAddExistingCandidates.en },
      uploadCvErrorMessage: 'There is some error uploading cv. Try again.',
      cvUploadedSuccessfullyMessage: 'Uploaded cv is successfully saved.',
      stepsDialog: { ...manageSteps.en },
      manageJob: { ...manageJobForm.en },
    },
    JobPostingDetailsPage: {
      pageHeader: { ...pageHeader.en },
      menuItemLabels: {
        edit: commonLabels.edit,
        viewPipeline: 'View pipeline',
      },
      manageJobs: { ...manageJobForm.en },
      details: 'Details',
      disabledSwitchMessage:
        'Add job pipeline steps to enable public publishing.',
      noPublicLinkTitle: 'No public job page yet',
      noPublicLinkContent:
        'Enable public publishing to generate a shareable job link',
      copyLink: 'Copy link',
      linkCopied: 'Link copied to clipboard',
      errorCopyLink: 'Error copying link',
      preview: 'Preview',
      emptySection: 'No content',
      ended: 'Ended',
      archived: 'Archived',
      open: 'Open',
      errorTitle: 'Unable to load job',
      errorMessage:
        'The job could not be loaded. Check the link or try again later.',
      workspace: { ...jobWorkspace.en },
      summary: {
        subtitle: 'Job information',
        labels: {
          title: 'Title',
          status: 'Status',
          department: 'Department',
          workspace: 'Workspace',
          location: 'Office location',
          createdBy: 'Created by',
          dateRange: 'Date open / Date end',
          tags: 'Tags',
        },
        noValue: '-',
      },
      metrics: {
        subtitle: 'Hiring overview',
        createdAt: 'Job created',
        totalCandidates: 'Total candidates',
        decisionPipeline: 'Active candidates',
        hired: 'Hired candidates',
        lastActivity: 'Last activity',
      },
      sections: {
        publishing: 'Publishing',
        description: 'Description',
        requirements: 'Requirements',
        benefits: 'Benefits',
      },
      successMessages: {
        jobUpdated: 'Job is successfully updated.',
      },
    },
    PublicJobPage: {
      apply: 'Apply',
      poweredBy: 'Powered by Kadar',
      jobTitle: 'Job title',
      location: 'Location',
      workspace: 'Workspace',
      dateEnd: 'Active until',
      requirements: 'Requirements',
      description: 'Description',
      benefits: 'Benefits',
      noValue: '-',
      disabledDescription: 'This position is no longer accepting applications.',
    },
    ApplyJobPage: {
      submit: 'Apply',
      poweredBy: 'Powered by Kadar',
      backToJob: '< Back to job description',
      agree: 'I agree to the',
      and: 'and',
      submitError: 'Unable to submit your application. Please try again.',
      successMessages: {
        applicationSubmitted: 'Application submitted successfully.',
      },
      rateLimitMessage:
        'Too many attempts. Please wait a moment and try again.',
      terms_of_service: {
        name: 'Terms of Service',
      },
      privacy_policy: {
        name: 'Privacy Policy',
      },
      formLabels: {
        fullName: {
          label: 'Full name *',
          placeholder: 'Enter full name',
        },
        email: {
          label: 'Email *',
          placeholder: 'Enter email',
        },
        phone: {
          label: 'Phone number *',
          placeholder: 'Enter phone number',
        },
        resume: {
          label: 'Resume *',
          placeholder: 'Upload resume',
        },
        termsAccepted: {
          label: 'Terms & Privacy',
        },
      },
      validationMessages: {
        required: 'This field is required.',
        invalidName: 'Name should contain only letters.',
        invalidFullName: 'This field should contain full name.',
        minLength: 'Minimum length is 2 characters.',
        inputMaxLength: 'Exceeded max length of 255 characters.',
        invalidEmail: 'Email is invalid.',
        exceededLengthEmail: 'Maximum length is 100 characters.',
        invalidPhone: 'Invalid phone number.',
        fileType: 'File type should be pdf',
        fileLength: 'File name should have maximum 100 characters.',
      },
    },
    JobDetailsPage: {
      pageHeader: { ...pageHeader.en },
      viewJobPostingLabel: 'Details',
      qualified: 'Qualified',
      disqualified: 'Disqualified',
      searchPlaceholder: commonLabels.search,
      ordering: 'Ordering',
      orderingOptions: {
        nameAsc: 'Name A→Z',
        nameDesc: 'Name Z→A',
        updatedAtOldest: 'Updated at (oldest)',
        updatedAtNewest: 'Updated at (newest)',
        addedToJobOldest: 'Added to job (oldest)',
        addedToJobNewest: 'Added to job (newest)',
      },
      uploadLabel: 'Upload cvs',
      dropdownMenuLabel: 'Add candidates',
      addTeamMemberLabel: 'Hiring team',
      loadMore: commonLabels.loadMore,
      qualifyCandidateDialog: { ...alertDialogs.en.qualifyCandidate },
      deleteCandidateDialog: { ...alertDialogs.en.candidateDelete },
      disqualifyCandidateDialog: { ...alertDialogs.en.disqualifyCandidate },
      deleteCommentDialog: { ...alertDialogs.en.commentDelete },
      deleteVoteDialog: { ...alertDialogs.en.voteDelete },
      disabledAddCandidateAction: 'Add steps to enable adding candidates.',
      referral: 'Referral',
      noResults: {
        title: 'No candidates to review',
        message:
          'Candidates will appear here once they reach [STATUS] [STEP NAME] stage.',
        noSearchResultsMessage: commonLabels.noSearchResultsMessage,
        noStepsMessage:
          'Candidates will appear here once they are imported in this job.',
        waitingForCandidatesTitle: 'Waiting for candidates',
        communication: {
          title: 'No messages yet',
          message:
            "Quiet so far, once someone sends an email, it'll show up here.",
        },
        comments: {
          title: 'No comments yet',
          message:
            "Quiet so far, once someone sends a comment, it'll show up here.",
        },
        reviews: {
          title: 'No reviews yet',
          message:
            "Quiet so far, once someone gives an evaluation, it'll show up here.",
        },
        timeline: {
          title: 'No messages, comments or reviews yet',
          message:
            "Quiet so far, once someone gives an evaluation or sends an email or comment, it'll show up here.",
        },
      },
      manageHiringTeam: { ...manageHiringTeam.en },
      sendEmail: { ...sendEmail.en },
      vote: { ...vote.en },
      addComment: { ...addComment.en },
      addCandidatesManually: { ...addCandidatesManually.en },
      addCandidatesUsingCv: { ...addCandidatesUsingCv.en },
      manageAddExistingCandidates: { ...manageAddExistingCandidates.en },
      buttons: { ...candidateViewButtons.en },
      evaluationsLabel: 'Evaluations',
      disqualifiedUserMessage: 'Actions are disabled for disqualified user.',
      voteLabel: 'Vote',
      edited: 'Edited',
      pendingUsersLabel: 'Evaluations pending status',
      disabledButtonCommunication: 'Emails cannot be modified.',
      disabledButtonOtherStep: 'Action is created in another step.',
      archivedJob: 'Job is archived.',
      madeByOtherUser: 'Made by other user.',
      addedToJob: 'Added to job',
      appliedTo: 'Applied to',
      addedTo: 'Added to',
      deletedUser: {
        first_name: 'Deleted',
        last_name: 'user',
      },
      disqualifiedOnStep: 'Disqualified on',
      requalifiedOnStep: 'Requalified on',
      movedFrom: 'Moved from',
      to: 'to',
      on: 'on',
      menuItemLabels: {
        edit: commonLabels.edit,
        delete: commonLabels.delete,
      },
      candidates: {
        addedToJob: 'Added to job',
        added: 'Added',
        applied: 'Applied',
        updated: 'Updated',
        justNow: 'just now',
        ago: commonLabels.ago,
        min: 'min',
        mins: 'mins',
        hour: 'hour',
        hours: 'hours',
        day: commonLabels.day,
        days: commonLabels.days,
        year: 'year',
        years: 'years',
      },
      candidateMenuItemLabels: {
        upload: 'Upload cv',
        uploadMultiple: 'Upload multiple cvs',
        addXls: 'Add xls file',
        addExistingCandidate: 'Add existing',
        addCandidate: 'Add manually',
      },
      edit: commonLabels.edit,
      candidateInfoFields: { ...candidateInfoFields.en },
      uploadCvMessage:
        'Results are being uploaded from cv. It will take a couple of minutes.',
      uploadCvErrorMessage: 'There is some error uploading cv. Try again.',
      cvUploadedSuccessfullyMessage: 'Uploaded cv is successfully saved.',
      successMessages: {
        hiringTeamSaved: 'Selected hiring team is successfully saved.',
        existingCandidatesSaved:
          'Selected candidates are successfully added to job.',
        candidateSaved: 'Candidate is successfully saved.',
        candidateMoveToStepSaved:
          'Candidate is successfully moved to other step.',
        candidateSuccessfullyDisqualified:
          'Candidate is successfully disqualified.',
        candidateSuccessfullyQualified: 'Candidate is successfully qualified.',
        voteForCandidateSuccessfullySaved:
          'Vote for candidate is successfully saved.',
        commentForCandidateSuccessfullySaved:
          'Comment for candidate is successfully saved.',
        voteForCandidateSuccessfullyUpdated:
          'Vote for candidate is successfully updated.',
        commentForCandidateSuccessfullyUpdated:
          'Comment for candidate is successfully updated.',
        emailForCandidateSuccessfullySaved:
          'Email to candidate is successfully sent.',
      },
    },
    CandidatesPage: {
      title: 'Candidates',
      pageHeader: { ...pageHeader.en },
      loadMore: commonLabels.loadMore,
      all: commonLabels.all,
      department: commonLabels.department,
      job: commonLabels.job,
      stage: commonLabels.stage,
      tag: commonLabels.tag,
      search: 'Search all candidates using keywords',
      addCandidatesManually: { ...addCandidatesManually.en },
      manageJobs: { ...manageJobs.en },
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      noResults: 'There are no candidates to display',
      successMessages: {
        candidateSaved: 'Candidate is successfully saved.',
        manageJobsSaved: 'Jobs for candidate are successfully saved.',
      },
      deleteCandidateDialog: { ...alertDialogs.en.candidateDelete },
      columns: {
        name: 'Name',
        job: 'Job',
        stage: 'Stage',
        createdAt: 'Created at',
        modifiedOn: 'Modified on',
        actions: 'Actions',
      },
      menuItemLabels: {
        edit: commonLabels.edit,
        manageJobs: 'Manage jobs',
      },
    },
    CandidateDetailsPage: {
      title: 'Candidate',
      pageHeader: { ...pageHeader.en },
      edit: commonLabels.edit,
      addCandidatesManually: { ...addCandidatesManually.en },
      successMessages: {
        candidateSaved: 'Candidate is successfully saved.',
      },
      deleteCandidateDialog: { ...alertDialogs.en.candidateDelete },
      candidateInfoFields: { ...candidateInfoFields.en },
      uploadCvMessage:
        'Results are being uploaded from cv. It will take a couple of minutes.',
    },
    DivisionsPage: {
      title: 'Divisions and departments',
      description: {
        admin: 'Here you can add, edit or delete divisions and departments.',
        read: 'Here you can view the divisions and departments in your organization.',
      },
      pageHeader: { ...pageHeader.en },
      noJobTitle: commonLabels.noJobTitle,
      tableLabels: {
        department: 'Department',
        addDepartmentButtonLabel: 'New Department',
      },
      deleteDivisionDialog: { ...alertDialogs.en.divisionDelete },
      deleteDepartmentDialog: { ...alertDialogs.en.departmentDelete },
      successMessages: {
        divisionSaved: 'Division name is successfully saved.',
        divisionUpdated: 'Division name is successfully updated.',
        departmentSaved: 'Department data is successfully saved.',
        departmentUpdated: 'Department data is successfully updated.',
        departmentDeleted: 'Department is successfully deleted.',
        divisionDeleted: 'Division is successfully deleted.',
        assignedUsersToDepartment: 'Users are successfully assigned.',
        duplicateDepartment: 'Department is successfully duplicated.',
        duplicateDivision: 'Division is successfully duplicated.',
      },
      divisionGroupView: {
        delete: commonLabels.delete,
        edit: commonLabels.edit,
        duplicate: commonLabels.duplicate,
        loadMoreButton: commonLabels.loadMore,
        people: commonLabels.people,
        noResults: {
          title: 'No Division system yet!',
          content: 'Once the division is added, it will be displayed.',
        },
        department: 'Department',
        createDivisionButton: 'New Division',
        createDepartmentButton: 'New Department',
        divisionDragTooltip: 'You can drag divisions to rearrange them.',
        departmentDragTooltip: 'You can drag departments to rearrange them.',
        duplicateDivision: {
          ...divisionForm.en,
          edit: 'Duplicate Division',
        },
        duplicateDepartment: {
          ...divisionForm.en,
          add: 'Duplicate Department',
        },
        addDivision: {
          ...divisionForm.en,
          add: 'Add Division',
          edit: 'Edit Division',
        },
        addDepartment: {
          ...divisionForm.en,
          add: 'Add Department',
          edit: 'Edit Department',
        },
        assignUsersToDepartment: {
          ...divisionForm.en,
          add: 'Assign users to department',
          assignLabel: 'Assign users',
        },
      },
    },
    JobTitlesPage: {
      title: 'Job titles',
      search: commonLabels.search,
      filters: { ...filters.en },
      addRecommendedLabel: 'Add recommended job titles',
      loadingImportText:
        "Job title import is in progress. Please don't reload the page until job titles are imported.",
      description:
        'Customize the list of job titles entirely to represent your' +
        ' organization.',
      descriptionReadOnly:
        'Here you can view the list of all the job titles defined in your organization.',
      pageHeader: { ...pageHeader.en },
      addButtonLabel: 'New job title',
      successMessages: {
        add: 'Job title successfully added',
        edit: 'Job title successfully edited',
      },
      labels: {
        attributes: 'Attributes',
        noAttributes: 'No attributes',
        description: 'Description',
        noDescription: 'No description',
        assignTo: 'Assign to',
        tags: 'Tags',
        preview: commonLabels.preview,
        jobFamily: 'Family',
        type: 'Type',
        keyJob: 'Key job',
        criticality: 'Criticality',
        seat: 'Seat',
        generic: 'Generic',
        yes: commonLabels.yes,
        no: commonLabels.no,
      },
      jobTitleAssigning: { ...jobTitleAssigning.en },
      addJobTitleForm: {
        save: commonLabels.save,
        add: 'New job title',
        edit: 'Edit job title',
        formLabels: {
          name: {
            label: 'Job title',
            placeholder: 'Add job title',
          },
          job_family: {
            label: 'Job family',
            placeholder: 'Select job family',
          },
          job_type: {
            label: 'Type',
            labelHelp: {
              tooltipText:
                'Seat is one position, covered when there is at least one Ready-now successor. Generic is held by several people and is covered when Ready-now successors meet the holders ratio.',
            },
            options: {
              seat: 'Seat',
              generic: 'Generic',
            },
          },
          is_key: {
            label: 'Key job',
            labelHelp:
              'Mark this job title as a key job so it is tracked in succession.',
          },
          criticality: {
            label: 'Criticality',
            placeholder: 'Select criticality',
          },
          succession_notes: {
            label: 'Succession notes',
            placeholder: 'Add succession notes',
          },
          description: {
            label: 'Description',
            placeholder: 'Add description',
          },
          attributes: {
            label: 'Add attributes',
            placeholder: 'Add attributes',
            noOptions: commonLabels.noOptions,
          },
          tags: {
            label: 'Tags',
            placeholder: '#Tag',
            creatableOptionLabel: 'Add tag',
          },
        },
        validationMessages: {
          availableName: commonFieldValidationMessages.en.availableName,
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          nameMaxLength: 'Exceeded max length of 255 characters',
          descriptionMaxLength: 'Exceeded maximum allowed field length.',
        },
      },
      deleteJobTitleDialog: { ...alertDialogs.en.jobTitleDelete },
      noResultsTitle: 'No Job Titles yet!',
      noResultsMessage:
        'The first step in career development is defining who is who, so - get started.',
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
    },
    AttributeReportPage: {
      title: 'Attribute',
      pageHeader: { ...pageHeader.en },
      ...readLessMoreLabels,
      descriptionPartOne:
        'Analyse single attribute through time, and by any subset of reviewers or who was reviewed.',
      descriptionPartTwo:
        'Filter reviewers in order to view scores given only by certain group of people. (Ideal to view results through eyes of high-performers or managers or belonging to certain location).',
      descriptionPartThree:
        'Filter who was reviewed, in order to review scores only given to specific subset. Ideal to compare results given to teams in different locations or in different projects etc).',
      descriptionPartFour: 'Anonymous surveys are excluded from analytics.',
      selectFilters: {
        attribute: {
          label: commonLabels.attribute,
          placeholder: 'Add attribute',
        },
        period: commonLabels.period,
        surveyType: 'Survey type',
      },
      presets: { ...presets.en },
      systemRoles: { ...systemRoles.en },
      surveyStatuses: { ...statuses.en },
      reportToFilter: { ...statusesFilters.en.reportToFilter },
      filters: { ...filters.en },
      users: {
        objectsOfReview: {
          title: 'Survey about people',
          description: 'Show only surveys that are about these people.',
        },
        reviewers: {
          title: 'Results by following reviewers',
          description:
            'Show all surveys results and scores by following reviewers.',
        },
      },
      surveyTypeFilterOptions: { ...surveyTypeFilterOptions.en },
      objectsPicker: {
        addPeopleLabel: 'Add reviewed users',
        picker: { ...multipartPeoplePicker.en, title: 'Add reviewed users' },
      },
      reviewersPicker: {
        addPeopleLabel: 'Add reviewers',
        picker: { ...multipartPeoplePicker.en, title: 'Add reviewers' },
      },
      detractorsScore: 'Score 1-6',
      neutralScore: 'Score 7-8',
      promotersScore: 'Score 9-10',
      detractorsLabel: commonLabels.detractors,
      neutralLabel: commonLabels.neutral,
      promotersLabel: commonLabels.promoters,
      score: commonLabels.score,
      attributeInfoBar: {
        attributeScore: {
          anonymous: 'This is an average score.',
          default: 'Click to view individual user scores.',
        },
        textReplyNoAverageScore:
          "Open-ended attributes don't have an average score.",
        scoreLabel: commonLabels.score,
      },
      review: {
        question: 'Questions',
        answers: 'Answers',
        answerShorthand: 'A',
        questionShorthand: 'Q',
        questionScore: commonLabels.score,
        anonymousUser: { ...anonymousUser.en },
        feedback: {
          title: 'Feedback',
          noResults: 'There is no feedback for this review.',
          anonymousUser: { ...anonymousUser.en },
        },
        ...neutralAnswer.en,
        people: commonLabels.people,
        percentage: commonLabels.percentage,
        details: {
          title: 'Survey reference',
          description:
            'List of all surveys with this attribute for selected period.',
          date: commonLabels.date,
          commentText: commonLabels.description,
          status: commonLabels.status,
        },
      },
      noResults: 'There are no report results to display.',
    },
    SurveySummaryPage: {
      title: 'Survey summary',
      pageHeader: { ...pageHeader.en },
      ...readLessMoreLabels,
      description:
        'Provides comprehensive overview of survey results, designed to give quick insights and detailed analysis at a glance.',
      filters: { ...filters.en },
      surveyTypes: { ...surveyTypes },
      search: 'Search by title',
      sharedWith: 'Shared with',
      noResults: {
        title: 'No Survey summary reports yet!',
        message: 'There are no survey summary reports to display.',
        search: commonLabels.noSearchResultsMessage,
      },
      all: commonLabels.all,
      loadMore: commonLabels.loadMore,
      menuItemLabels: {
        share: commonLabels.share,
        delete: commonLabels.delete,
      },
      deleteReportDialog: { ...alertDialogs.en.surveySummaryReportDelete },
      reportShareDialog: { ...surveySummaryShare.en },
      columns: {
        actions: commonLabels.actions,
        title: commonLabels.title,
        type: commonLabels.type,
        createdBy: commonLabels.createdBy,
        createdAt: commonLabels.createdAt,
        sharedWith: 'Shared with',
      },
    },
    SurveySummaryDetailsPage: {
      pageHeader: { ...pageHeader.en },
      surveyTypes: { ...surveyTypes },
      info: {
        anonymized: 'Anonymized',
        anonymizedInfoTooltip: {
          default:
            'If summary report is anonymized all the reviewers will be shown with their identities hidden.',
          managable: 'Toogle between anonymized and original reviewers.',
        },
        createdBy: commonLabels.createdBy,
        createdAt: commonLabels.createdAt,
        type: commonLabels.type,
        reviewers: 'Reviewers',
        reviewer: 'Reviewer',
        reviewedUsers: 'Who were reviewed',
        reviewedUser: 'Who was reviewed',
        yes: commonLabels.yes,
        no: commonLabels.no,
        toggleViewDataTooltip: 'Toggle between anonymized and original data.',
      },
      description: { ...surveyinfoDescription.en },
      reviews: {
        attributes: 'Measured attributes',
        questionnaire: 'Questionnaire',
      },
      review: { ...surveyResults.en },
      summaryTitle: 'Summary',
      reviewComments: { ...reviewCommentsDrawer.en },
    },
    SurveysHistoryPage: {
      title: 'Survey history',
      pageHeader: { ...pageHeader.en },
      description:
        'A complete record of your survey responses and feedback history. Use these insights to understand progress, recognize patterns, and prepare for future reviews.',
      loadMore: commonLabels.loadMore,
      filters: { ...filters.en },
      columns: {
        title: 'Title',
        attributesQuestionnaire: 'Attributes/Questionnaire',
        subjects: 'Who was reviewed',
        dateSent: 'Received on',
      },
      noResults: {
        title: 'No Surveys history available yet!',
        message:
          'Once you start submitting surveys, your feedback history will appear here for your reference.',
        search: commonLabels.noSearchResultsMessage,
      },
      anonymousSurvey: `${commonLabels.anonymous} survey`,
    },
    SurveyHistoryPage: {
      pageHeader: { ...pageHeader.en },
      anonymousSurveyInfo:
        "To protect reviewer anonymity, survey results aren't shown. This page is a record of the reviews you submitted.",
      info: {
        labels: {
          attributes: 'Attributes',
          questionnaire: commonLabels.questionnaire,
          subjects: 'Who was reviewed',
          dateReceived: 'Received on',
          anonymous: {
            label: commonLabels.anonymous,
            helpText:
              "To protect reviewer anonymity, survey results aren't shown. This page is a record of the reviews you submitted.",
          },
          yes: commonLabels.yes,
          no: commonLabels.no,
        },
      },
      survey: { ...fillSurveyFlow.en },
    },
    CyclesPage: {
      title: 'Cycles',
      pageHeader: { ...pageHeader.en },
      description:
        "Design, launch, and administer your organization's entire survey strategy.",
      searchPlaceholder: 'Search by title',
      addCycle: 'New cycle',
      loadMore: commonLabels.loadMore,
      statuses: { ...statuses.en },
      filters: { ...filters.en },
      reportToFilter: { ...statusesFilters.en.reportToFilter },
      systemRoles: { ...systemRoles.en },
      cycleReviewTypes: { ...cycleReviewTypes.en },
      all: commonLabels.all,
      viewReport: commonLabels.viewReport,
      reminderSent: 'Reminder successfully sent.',
      expandTooltip: 'Click to expand review(s)',
      after: commonLabels.after,
      timeline: {
        startsToday: 'Starts today',
        endsToday: 'Ends today',
        ended: 'Ended',
        start: 'Starts in',
        end: 'Ends in',
        day: commonLabels.day,
        days: commonLabels.days,
      },
      expandTooltipDisabled:
        'Once cycle starts you will be able to see review(s)',
      columns: {
        actions: commonLabels.actions,
        title: commonLabels.title,
        startsOn: commonLabels.startsOn,
        endsOn: commonLabels.endsOn,
        status: commonLabels.status,
        timeline: 'Timeline',
        repeat: 'Repeat',
        employeesInCycle: 'Employees in cycle',
      },
      previewAttributeDialog: { ...customDialogs.en.attributePreview },
      renameReviewDialog: { ...customDialogs.en.reviewTitle },
      repeatInterval: {
        month: {
          name: 'Month',
          single: 'month',
          plural: 'months',
        },
        week: {
          name: 'Week',
          single: 'week',
          plural: 'weeks',
        },
      },
      reviewColumns: {
        actions: commonLabels.actions,
        title: commonLabels.title,
        status: commonLabels.status,
        type: commonLabels.type,
        startsOn: commonLabels.startsOn,
        endsOn: commonLabels.endsOn,
      },
      menuItemLabels: {
        edit: 'Edit cycle',
        delete: 'Delete cycle',
        fillReview: 'Fill review',
      },
      reviewMenu: {
        rename: 'Rename',
        reminder: 'Send reminder',
      },
      cycleSteps: { ...cycleSteps.en },
      successMessages: {
        create: 'Cycle has been created.',
        edit: 'Cycle has been updated.',
      },
      manageCycle: {
        cancel: commonLabels.cancel,
        save: commonLabels.save,
        add: 'Create cycle',
        edit: 'Edit cycle',
        defaultStepEmailMessage:
          'Help us in the review process by answering this survey.',
        formLabels: {
          attributes: {
            label: 'Selected attributes',
            placeholder: 'Add attributes',
            noOptions: commonLabels.noResults,
          },
          title: {
            label: 'Cycle title',
            placeholder: 'Add cycle title',
          },
          repeatingCycle: {
            label: 'Cycle repeat',
            tooltip: {
              active: 'Turn on cycle repeat',
              inactive: 'Turn off cycle repeat',
            },
            info: 'After',
          },
          repeatTitle: {
            label: 'Cycle repeat',
          },
          repeatDescription: {
            label:
              'The next cycle will be created as soon as this one finishes.',
          },
          cycleSteps: {
            label: 'Set Up Steps',
            tooltip: {
              active: 'Activate step',
              inactive: 'Deactivate step and reset all step data',
            },
            dragTooltip: 'You can drag steps to rearrange them.',
            error: 'This step has errors.',
            start: 'Starts at',
            end: 'Ends at',
          },
          repeatIntervalUnit: {
            label: 'Unit',
            noOptions: commonLabels.noResults,
          },
          repeatInterval: {
            label: 'Repeat after',
            noOptions: commonLabels.noResults,
          },
          usersSettings: {
            label: commonLabels.employees,
            content: 'No selected employees',
            contentWithValue: 'View [COUNT] selected employees',
            error: commonFieldValidationMessages.en.isEmpty,
          },
          attributesSettings: {
            label: commonLabels.attributes,
            content: 'No selected attributes',
            contentWithValue: 'View [COUNT] selected attributes',
            error: commonFieldValidationMessages.en.isEmpty,
          },
          participantsSettings: {
            label: commonLabels.participants,
            content: 'No eligible participants',
            contentWithValue: 'View [COUNT] eligible participants',
            error: commonFieldValidationMessages.en.isEmpty,
          },
          employeesInCycle: {
            label: 'Employees in cycle',
          },
          users: {
            noUsers: 'No employees match your filter criteria',
          },
          stepStartDate: {
            label: 'Step starts at',
          },
          stepEndDate: {
            label: 'Step ends at',
          },
          emailStepSubtitle: {
            label: commonLabels.email,
          },
          stepEmail: {
            label: 'Customize email',
            tooltipInfo:
              'Activate this option if you wish to personalize step email message or use the default one.',
          },
          stepEmailContent: {
            placeholder: 'Add email message',
          },
          filters: {
            ...filters.en,
          },
          disabledFilter: {
            label:
              'Clear all will reset Employees in cycle back to its default selection (all available employees).',
          },
          subject: {
            label: 'Subject',
            placeholder: 'Add subject',
          },
          emailMessage: {
            label: 'Message',
            placeholder: 'Add message',
          },
          selfReviewStepSubtitle: {
            label: 'Self review',
          },
          topDownStepSubtitle: {
            label: 'Top > Down review',
          },
          downUpStepSubtitle: {
            label: 'Down > Up review',
          },
          assignments: {
            label: commonLabels.participants,
            includeUser: 'Include in this review.',
            excludeUser: 'Exclude from this review.',
            noParticipants: {
              title: 'No eligable participants',
            },
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
          maxLength: 'Exceeded max length of 150 characters',
          emailContentMaxLength: 'Exceeded max length of 500 characters',
          dateInPast: 'Date cannot be in the past',
          steps: 'Activate at least 1 review step',
          invalidReviewStructure: 'Invalid review structure',
          emailStepDateInvalid:
            'Date should be before any review step start date',
          stepStartDateInvalid: 'Date should be after email step start date',
        },
      },
      deleteCycleDialog: { ...alertDialogs.en.cycleDelete },
      noResults: {
        title: 'No Cycles available yet!',
        message:
          'Once you create and launch your first cycle, it will appear here to be managed and tracked.',
        search: commonLabels.noSearchResultsMessage,
      },
    },
    CycleDetailsPage: {
      pageHeader: { ...pageHeader.en },
      statuses: { ...statuses.en },
      employees: 'Employee(s)',
      cycleSteps: { ...cycleSteps.en },
      timeline: 'Timeline',
      cycleStatuses: 'Statuses',
      completionStatuses: { ...statuses.en },
      searchPlaceholder: 'Enter employee name',
      noSearchResults: commonLabels.noSearchResultsMessage,
      table: {
        loadMoreLabel: commonLabels.loadMore,
        expandTooltipLabel: 'Click to view reviewers',
        endsOn: commonLabels.endsOn,
      },
      viewReport: commonLabels.viewReport,
      tableDescription:
        'Monitor the review cycle. Expand an employee record to track review status and timelines across all perspectives: Self, Top > Down, and Down > Up.',
      loadMore: commonLabels.loadMore,
      columns: {
        name: commonLabels.name,
        self: 'Self',
        topDown: 'Top > Down',
        downUp: 'Down > Up',
        actions: commonLabels.actions,
      },
    },
    attributeChip: { ...attributeChip.en },
    selectField: { ...attributeChip.en },
    InstructionGuide: {
      instructionGuideTitle: 'Instruction guide',
      descriptionInstructionGuideOne: `We’re thrilled to have you here! Kadar is designed to empower you with the tools and insights you need to streamline your tasks and boost your productivity. Whether you’re managing projects, tracking progress, or collaborating with your team, we’ve got you covered.`,
      descriptionInstructionGuideTwo:
        'Explore our features, connect with like-minded users, and make the most of your experience. If you have any questions or need assistance, our support team is just a click away.',
      descriptionInstructionGuideThree: `Let’s get started on your journey to greater efficiency!`,
      descriptionInstructionGuideFour: 'Happy exploring!',
      guideTooltipText:
        'This video is a recomendation based on the selected incentives.',
      guideButtons: {
        onboardingYourTeam: 'Onboarding your team',
        welcomeToKadar: 'Welcome to Kadar',
        jobRoles: 'Creating Career paths',
        attributes: 'Defining Competencies',
        reviews: 'Conducting 360',
        skillMetrics: 'Interpreting 360',
        oneOnOne: 'Scheduling and tracking 1:1s',
        actionPlans: 'Setting targets and Action Plans',
        managerInsights: 'Company and employee overview',
        kadarOverview: 'Kadar overview',
        yourProfile: 'Your profile',
      },
    },
    SuccessionKeyJobsPage: {
      title: 'Succession',
      description:
        'See which key jobs have successors and where coverage is still a gap.',
      setInJobsAfter: '.',
      search: 'Search job title',
      loadMore: commonLabels.loadMore,
      all: commonLabels.all,
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      noResults: {
        title: 'No Key jobs yet!',
        message:
          'Once Key jobs are added from Job titles page, they will appear here.',
      },
      pageHeader: { ...pageHeader.en },
      navigationItems: { ...successionNavigation.en },
      filters: {
        ...filters.en,
      },
      columns: {
        job: 'Key job',
        type: 'Type',
        family: 'Family',
        criticality: 'Criticality',
        holders: 'Holders',
        readiness: 'Readiness',
        coverage: 'Coverage',
      },
      types: {
        seat: 'Seat',
        generic: 'Generic',
      },
      coverage: {
        covered: 'Covered',
        partial: 'Partial',
        gap: 'Gap',
      },
    },
    SuccessionKeyJobPage: {
      title: 'Key job',
      system: 'Kadar system',
      pageHeader: { ...pageHeader.en },
      type: 'Type',
      family: 'Family',
      criticality: 'Criticality',
      coverageLabel: 'Coverage',
      notes: 'Succession notes',
      showRemoved: 'Show removed',
      addSuccessor: 'Add successor',
      loadMore: commonLabels.loadMore,
      empty: 'This key job could not be loaded.',
      noHolders: 'No one currently holds this key job.',
      noSuccessors:
        'No successors nominated yet. Add someone to start building coverage for this role.',
      noChangelog: 'No changes yet.',
      emptyValue: '—',
      vacant: 'VACANT',
      statuses: { ...statuses.en },
      types: {
        seat: 'Seat',
        generic: 'Generic',
      },
      coverage: {
        covered: 'Covered',
        partial: 'Partial',
        gap: 'Gap',
      },
      sections: {
        holders: 'Holders',
        successors: 'Successors',
        changelog: 'Change log',
      },
      columns: {
        employee: commonLabels.employees,
        level: commonLabels.level,
        manager: commonLabels.manager,
        tenure: 'Tenure',
        readiness: 'Readiness',
        rank: 'Rank',
        note: 'Note',
        actions: commonLabels.actions,
        when: 'When',
        who: 'Who',
        action: 'Action',
        status: commonLabels.status,
      },
      changelogActions: { ...successionJobChangelogActions.en },
      menu: {
        edit: commonLabels.edit,
        remove: 'Remove',
        view: 'View',
        readd: 'Re-add',
      },
      successMessages: {
        created: 'Successor added.',
        updated: 'Successor updated.',
        removed: 'Successor removed.',
        readded: 'Successor re-added.',
      },
      successorForm: {
        add: 'Add successor',
        edit: 'Edit successor',
        remove: 'Remove successor',
        readd: 'Re-add successor',

        save: commonLabels.save,
        cancel: commonLabels.cancel,
        sourceOptions: {
          employees: 'Employees',
          fromPool: 'Pools',
        },
        formLabels: {
          source: {
            label: 'From',
          },
          successor: {
            label: 'Successor',
            placeholder: 'Select a successor',
          },
          pool: {
            label: 'Pool',
            placeholder: 'Select a pool',
          },
          readiness: {
            label: 'Readiness',
            placeholder: 'Select readiness',
          },
          rank: {
            label: 'Rank',
          },
          note: {
            label: 'Note',
            placeholder: 'Optional note',
          },
          reason: {
            label: 'Reason',
            placeholder: 'Select a reason',
          },
          comment: {
            label: 'Comment',
            placeholder: 'Optional comment',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          minValue: 'Rank must be a whole number of at least 1.',
          maxLength: 'Maximum length is 1000 characters.',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
        },
      },
    },
    SuccessionPoolsPage: {
      title: 'Succession',
      description:
        'Group employees you are preparing for future roles, and see readiness across each pool.',
      pageHeader: { ...pageHeader.en },
      navigationItems: { ...successionNavigation.en },
      search: 'Search pool',
      all: commonLabels.all,
      createPool: 'Create pool',
      noSearchResultsMessage: commonLabels.noSearchResultsMessage,
      noResults: {
        title: 'No Pools yet!',
        message: 'Once Pools are added, they will appear here.',
      },
      filters: {
        ...filters.en,
        labels: {
          ...filters.en.labels,
          owner: 'Owner',
        },
      },
      columns: {
        name: 'Name',
        owner: 'Owner',
        members: 'Members',
        readiness: 'Readiness',
        status: commonLabels.status,
        actions: commonLabels.actions,
      },
      statuses: { ...statuses.en },
      menu: {
        edit: commonLabels.edit,
        archive: commonLabels.archive,
        delete: commonLabels.delete,
      },
      poolForm: {
        add: 'Create pool',
        edit: 'Edit pool',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        formLabels: {
          name: {
            label: commonLabels.name,
            placeholder: 'Pool name',
          },
          description: {
            label: commonLabels.description,
            placeholder: 'Optional description',
          },
          owner: {
            label: 'Owner',
            placeholder: 'Select Owner',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          nameMaxLength: 'Maximum length is 128 characters.',
          descriptionMaxLength: 'Maximum length is 1000 characters.',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
        },
      },
      archiveDialog: {
        title: 'Archive pool',
        contentMessage: 'Archive this pool? Members stay read-only.',
        closeButton: commonLabels.cancel,
        confirmButton: commonLabels.archive,
      },
      deleteDialog: {
        title: 'Delete pool',
        contentMessage: 'Delete this pool? This cannot be undone.',
        closeButton: commonLabels.cancel,
        confirmButton: commonLabels.delete,
      },
      successMessages: {
        created: 'Pool created.',
        updated: 'Pool updated.',
        archived: 'Pool archived.',
        deleted: 'Pool deleted.',
      },
    },
    SuccessionPoolPage: {
      title: 'Talent pool',
      description: '',
      system: 'Kadar system',
      pageHeader: { ...pageHeader.en },
      name: commonLabels.name,
      descriptionLabel: commonLabels.description,
      owner: 'Owner',
      status: commonLabels.status,
      loadMore: commonLabels.loadMore,
      editPool: 'Edit pool',
      showRemoved: 'Show removed',
      addMembers: 'Add members',
      empty: 'This talent pool could not be loaded.',
      noMembers:
        'No members in this pool yet. Add employees to start building the talent pool.',
      noChangelog: 'No changes yet.',
      emptyValue: '—',
      statuses: { ...statuses.en },
      sections: {
        members: 'Members',
        changelog: 'Change log',
      },
      columns: {
        name: commonLabels.name,
        jobLevel: 'Current job · level',
        family: 'Family',
        readiness: 'Readiness',
        note: 'Note',
        added: 'Added',
        actions: commonLabels.actions,
        when: 'When',
        who: 'Who',
        status: commonLabels.status,
        action: 'Action',
      },
      changelogActions: { ...successionPoolChangelogActions.en },
      menu: {
        edit: commonLabels.edit,
        remove: 'Remove',
        view: 'View',
      },
      poolForm: {
        add: 'Create pool',
        edit: 'Edit pool',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        formLabels: {
          name: {
            label: commonLabels.name,
            placeholder: 'Pool name',
          },
          description: {
            label: commonLabels.description,
            placeholder: 'Optional description',
          },
          owner: {
            label: 'Owner',
            placeholder: 'Search employees',
            ...peoplePicker.en,
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          onePerson: 'Select one person.',
          nameMaxLength: 'Maximum length is 128 characters.',
          descriptionMaxLength: 'Maximum length is 1000 characters.',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
        },
      },
      memberForm: {
        add: 'Add members',
        edit: 'Edit member',
        remove: 'Remove member',
        viewRemoved: 'Removed member',
        save: commonLabels.save,
        cancel: commonLabels.cancel,
        formLabels: {
          members: {
            label: 'Members',
            placeholder: 'Search employees',
            ...peoplePicker.en,
          },
          member: {
            label: 'Member',
          },
          readiness: {
            label: 'Readiness',
            placeholder: 'Select readiness',
          },
          note: {
            label: 'Note',
            placeholder: 'Optional note',
          },
          reason: {
            label: 'Reason',
            placeholder: 'Select a reason',
          },
          comment: {
            label: 'Comment',
            placeholder: 'Optional comment',
          },
        },
        validationMessages: {
          required: commonFieldValidationMessages.en.isEmpty,
          atLeastOnePerson: 'Select at least one person.',
          maxLength: 'Maximum length is 1000 characters.',
          forbiddenCharacters:
            commonFieldValidationMessages.en.forbiddenCharacters,
        },
      },
      successMessages: {
        updated: 'Pool updated.',
        membersAdded: 'Pool members added.',
        memberUpdated: 'Pool member updated.',
        memberRemoved: 'Pool member removed.',
      },
      errors: {
        load: commonFieldValidationMessages.en.somethingWentWrong,
        save: commonFieldValidationMessages.en.somethingWentWrong,
      },
    },
    SuccessionSettingsPage: {
      title: 'Succession',
      description:
        'Define the lists and coverage rule used across succession: readiness, criticality, removal reasons, and job families.',
      pageHeader: { ...pageHeader.en },
      navigationItems: { ...successionNavigation.en },
      active: commonLabels.active,
      inactive: commonLabels.inactive,
      columns: {
        name: commonLabels.name,
        active: 'Status',
        actions: commonLabels.actions,
        usedBy: 'Used by',
        jobsCount: 'Jobs',
      },
      menu: {
        edit: commonLabels.edit,
        moveUp: 'Move up',
        moveDown: 'Move down',
      },
      usedBy: {
        system: 'System',
        users: 'Users',
        systemAndUsers: 'System + users',
      },
      sections: {
        readiness: {
          title: 'Readiness levels',
          description: 'How soon a successor can step in.',
          add: 'Add level',
          empty: 'No readiness levels.',
        },
        criticality: {
          title: 'Criticality levels',
          description: 'How critical a key job is.',
          add: 'Add level',
          empty: 'No criticality levels.',
        },
        removalReasons: {
          title: 'Removal reasons',
          description: 'Why a successor is removed.',
          add: 'Add reason',
          empty: 'No removal reasons.',
        },
        jobFamilies: {
          title: 'Job families',
          description: 'Groups of related key jobs.',
          add: 'Add family',
          empty: 'No job families.',
        },
      },
      drawers: {
        readiness: {
          add: 'Add readiness',
          edit: 'Edit readiness',
          ...successionSettingsForm.en,
        },
        criticality: {
          add: 'Add criticality',
          edit: 'Edit criticality',
          ...successionSettingsForm.en,
        },
        removalReasons: {
          add: 'Add removal reason',
          edit: 'Edit removal reason',
          ...successionSettingsForm.en,
        },
        jobFamilies: {
          add: 'Add job family',
          edit: 'Edit job family',
          ...successionSettingsForm.en,
        },
      },
      coverage: {
        title: 'Coverage',
        genericRule: 'Covered when Ready-now successors ≥ 1 per N holders.',
        seatRule:
          'A seat is covered when there is at least one Ready-now successor.',
        save: commonLabels.save,
        saved: 'Coverage rule saved.',
        holders: {
          label: 'Holders per Ready-now successor',
        },
        validationMessages: {
          minValue: 'Enter a whole number of at least 1.',
        },
      },
      successMessages: {
        readinessSaved: 'Readiness level saved.',
        readinessUpdated: 'Readiness level updated.',
        readinessReordered: 'Readiness order updated.',
        criticalitySaved: 'Criticality level saved.',
        criticalityUpdated: 'Criticality level updated.',
        criticalityReordered: 'Criticality order updated.',
        removalReasonSaved: 'Removal reason saved.',
        removalReasonUpdated: 'Removal reason updated.',
        jobFamilySaved: 'Job family saved.',
        jobFamilyUpdated: 'Job family updated.',
      },
      errors: {
        load: commonFieldValidationMessages.en.somethingWentWrong,
        save: commonFieldValidationMessages.en.somethingWentWrong,
      },
    },
    CookieConsent: {
      consentModal: {
        title: 'We value your privacy',
        description: `We use cookies to improve your browsing experience, analyze traffic,
             and deliver personalized content and ads. By clicking "Accept All", you consent to the use of cookies as described in our
              <a href="https://www.kadar.app/privacy-and-cookie-policy" target="_blank" class="cc__link">Privacy and Cookie Policy</a>.`,
        acceptAllBtn: 'Accept All',
        acceptNecessaryBtn: 'Only Necessary',
        showPreferencesBtn: 'Manage Preferences',
        closeIconLabel: 'Close',
        footer: `<a href="https://www.kadar.app/privacy-and-cookie-policy" target="_blank">Privacy and Cookie Policy</a>
            <a href="https://www.kadar.app/terms-of-service" target="_blank">Terms of Service</a>`,
      },
      preferencesModal: {
        title: 'Cookie Preferences',
        acceptAllBtn: 'Accept All',
        acceptNecessaryBtn: 'Only Necessary',
        savePreferencesBtn: 'Save Preferences',
        closeIconLabel: 'Close',
        sections: [
          {
            description:
              'We use cookies to enhance your experience across our Services. You can choose which categories of cookies you want to allow below.',
          },
          {
            title: 'Necessary Cookies',
            description:
              'These cookies are required to enable the basic features of our Services and cannot be disabled in our systems. They are typically set in response to actions you take, such as providing secure log-in or adjusting your consent preferences.',
            linkedCategory: 'necessary',
          },
          {
            title: 'Analytics Cookies',
            description:
              'These cookies help us understand how you interact with our Services. They allow us to measure traffic, identify popular content, fix issues, and improve the overall user experience.',
            linkedCategory: 'analytics',
          },
          {
            title: 'More Information',
            description:
              'For more information about the cookies we use and how we use them, please refer to our <a href="https://www.kadar.app/privacy-and-cookie-policy" target="_blank" class="cc__link">Privacy and Cookie Policy</a>.',
          },
        ],
      },
    },
  },
};
